import { ɵɵdefineInjectable, Injectable, ɵɵinject, Component, Input, Directive, NgModule, ApplicationRef, QueryList, ViewChildren, Optional, EventEmitter, Injector, Output, Attribute, Inject, ViewChild, ContentChildren, ElementRef, forwardRef, Host, Renderer2, HostListener, TemplateRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { Subject, BehaviorSubject, Subscription, of, fromEvent, Observable, from } from 'rxjs';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import { Location, CommonModule } from '@angular/common';
import { NgbActiveModal, NgbAlertModule, NgbModal, NgbDatepickerModule, NgbDateAdapter, NgbPaginationModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterOutlet, NavigationEnd, Router, ActivatedRoute, RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { HttpParams, HttpClient } from '@angular/common/http';
import { map, filter, debounceTime, flatMap, distinct, toArray, first, concat } from 'rxjs/operators';
import { createNewHosts } from '@angularclass/hmr';
import { isEqual, padStart } from 'lodash-es';
import cloneDeep from 'lodash-es/cloneDeep';
import isEqual$1 from 'lodash-es/isEqual';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, RequiredValidator, Validators, NgControl, NG_ASYNC_VALIDATORS, NgModel, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import template from 'lodash-es/template';
import templateSettings from 'lodash-es/templateSettings';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { trigger, transition, style, animate } from '@angular/animations';
import { SwUpdate } from '@angular/service-worker';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-toastr';
import * as ɵngcc2 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/common/http';
import * as ɵngcc5 from 'ngx-cookie';
import * as ɵngcc6 from '@angular/forms';
import * as ɵngcc7 from '@tinymce/tinymce-angular';
import * as ɵngcc8 from '@angular/router';
import * as ɵngcc9 from '@angular/service-worker';

function SelectorIdiomaComponent_div_0_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "titlecase");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, lang_r2.name), " ");
} }
function SelectorIdiomaComponent_div_0_span_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 3);
    ɵngcc0.ɵɵlistener("click", function SelectorIdiomaComponent_div_0_span_1_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const lang_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.changeLang(lang_r2); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "titlecase");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, lang_r2.name));
} }
function SelectorIdiomaComponent_div_0_span_1_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, " | ");
    ɵngcc0.ɵɵelementEnd();
} }
function SelectorIdiomaComponent_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, SelectorIdiomaComponent_div_0_span_1_span_1_Template, 3, 3, "span", 0);
    ɵngcc0.ɵɵtemplate(2, SelectorIdiomaComponent_div_0_span_1_a_2_Template, 3, 3, "a", 2);
    ɵngcc0.ɵɵtemplate(3, SelectorIdiomaComponent_div_0_span_1_span_3_Template, 2, 0, "span", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", lang_r2.code.toLowerCase() === ctx_r1.locale || lang_r2.default && ctx_r1.locale == null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.locale != null && lang_r2.default || !lang_r2.default && lang_r2.code.toLowerCase() !== ctx_r1.locale);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r3 < ctx_r1.languages.length - 1);
} }
function SelectorIdiomaComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, SelectorIdiomaComponent_div_0_span_1_Template, 4, 3, "span", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.languages);
} }
const _c0 = ["fieldset"];
function CustomInputComponent_div_3_div_2_small_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.textRequired, " ");
} }
function CustomInputComponent_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CustomInputComponent_div_3_div_2_small_1_Template, 2, 1, "small", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.referencia.errors.required);
} }
function CustomInputComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵtemplate(2, CustomInputComponent_div_3_div_2_Template, 2, 1, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ((ctx_r0.referencia == null ? null : ctx_r0.referencia.dirty) || ctx_r0.submitted) && (ctx_r0.referencia == null ? null : ctx_r0.referencia.invalid));
} }
function CustomInputComponent_div_4_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.referencia || "-");
} }
function CustomInputComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", null, 5);
    ɵngcc0.ɵɵprojection(3, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, CustomInputComponent_div_4_span_4_Template, 2, 1, "span", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !_r4.innerHTML.trim());
} }
const _c1 = ["*", [["fw-value"]]];
const _c2 = ["*", "fw-value"];
function ErrorComponent_div_0_small_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small");
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
function ErrorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, ErrorComponent_div_0_small_1_Template, 2, 0, "small", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", error_r1 == ctx_r0.value);
} }
const _c3 = ["*"];
function BooleanComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.editing && ctx_r1.required ? "required" : "");
    ɵngcc0.ɵɵpropertyInterpolate("for", ctx_r1.cid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function BooleanComponent_input_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function BooleanComponent_input_6_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.value = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r2.cid);
    ɵngcc0.ɵɵpropertyInterpolate("name", ctx_r2.cid);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.disabled)("ngModel", ctx_r2.value);
} }
function BooleanComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.value ? ctx_r3.formsConfig.i18n.booleanYes || "Yes" : ctx_r3.formsConfig.i18n.booleanNo || "No");
} }
const _c4 = [[["fw-label"]]];
const _c5 = ["fw-label"];
const _c6 = ["inputElement"];
function TextareaComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.editing && ctx_r1.required ? "required" : "");
    ɵngcc0.ɵɵpropertyInterpolate("for", ctx_r1.cid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.label);
} }
function TextareaComponent_div_5_ng_container_4_fw_validation_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fw-validation", 8);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("errores", ctx_r6.notOverridenErrors);
} }
function TextareaComponent_div_5_ng_container_4_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.setFailures(ctx_r7.failures), " ");
} }
function TextareaComponent_div_5_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TextareaComponent_div_5_ng_container_4_fw_validation_1_Template, 1, 1, "fw-validation", 7);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, TextareaComponent_div_5_ng_container_4_div_3_Template, 3, 1, "div", 3);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r5.invalid));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 4, ctx_r5.invalid));
} }
function TextareaComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "textarea", 5, 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function TextareaComponent_div_5_Template_textarea_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.value = $event; });
    ɵngcc0.ɵɵtext(3, " ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, TextareaComponent_div_5_ng_container_4_Template, 5, 6, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("ng-invalid", ctx_r2.input.control.invalid)("ng-dirty", ctx_r2.input.control.dirty)("ng-touched", ctx_r2.input.control.touched)("ng-valid", ctx_r2.input.control.valid);
    ɵngcc0.ɵɵpropertyInterpolate("rows", ctx_r2.rows);
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r2.cid);
    ɵngcc0.ɵɵpropertyInterpolate("name", ctx_r2.cid);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r2.placeholder);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.value)("fwAutofocus", ctx_r2.autoFocus)("disabled", ctx_r2.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.submitted === null || ctx_r2.submitted === undefined) && ctx_r2.contextoFormService && ctx_r2.contextoFormService.state.submitted || ctx_r2.input.dirty || ctx_r2.submitted);
} }
function TextareaComponent_div_6_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r11.value || "-");
} }
function TextareaComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", null, 1);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, TextareaComponent_div_6_span_4_Template, 2, 1, "span", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r10 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !_r10.innerHTML.trim());
} }
const _c7 = [[["fw-label"]], "*", [["fw-value"]]];
const _c8 = ["fw-label", "*", "fw-value"];
function FormHeaderButtonsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
function FormSaveComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 3);
} }
function FormSaveComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 4);
} }
function FormFooterButtonsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
const _c9 = ["editForm"];
function SelectComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.editing && ctx_r1.required ? "required" : "");
    ɵngcc0.ɵɵpropertyInterpolate("for", ctx_r1.cid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function SelectComponent_div_5_select_1_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("value", undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.placeholder);
} }
function SelectComponent_div_5_select_1_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const opcion_r9 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngValue", ctx_r8.valueFn(opcion_r9));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.labelFn(opcion_r9));
} }
function SelectComponent_div_5_select_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function SelectComponent_div_5_select_1_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.value = $event; })("ngModelChange", function SelectComponent_div_5_select_1_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.selectItem($event); });
    ɵngcc0.ɵɵtemplate(1, SelectComponent_div_5_select_1_option_1_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵtemplate(2, SelectComponent_div_5_select_1_option_2_Template, 2, 2, "option", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("ng-invalid", ctx_r4.input.control.invalid)("ng-dirty", ctx_r4.input.control.dirty)("ng-touched", ctx_r4.input.control.touched)("ng-valid", ctx_r4.input.control.valid);
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r4.cid);
    ɵngcc0.ɵɵpropertyInterpolate("name", ctx_r4.cid);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.disabled)("ngModel", ctx_r4.value)("compareWith", ctx_r4.compareWith)("fwAutofocus", ctx_r4.autoFocus);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.options);
} }
function SelectComponent_div_5_select_2_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("value", undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r13.placeholder);
} }
function SelectComponent_div_5_select_2_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const opcion_r15 = ctx.$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngValue", ctx_r14.valueFn(opcion_r15));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.labelFn(opcion_r15));
} }
function SelectComponent_div_5_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function SelectComponent_div_5_select_2_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.value = $event; })("ngModelChange", function SelectComponent_div_5_select_2_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.selectItem($event); });
    ɵngcc0.ɵɵtemplate(1, SelectComponent_div_5_select_2_option_1_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵtemplate(2, SelectComponent_div_5_select_2_option_2_Template, 2, 2, "option", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("ng-invalid", ctx_r5.input.control.invalid)("ng-dirty", ctx_r5.input.control.dirty)("ng-touched", ctx_r5.input.control.touched)("ng-valid", ctx_r5.input.control.valid);
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r5.cid);
    ɵngcc0.ɵɵpropertyInterpolate("name", ctx_r5.cid);
    ɵngcc0.ɵɵproperty("disabled", ctx_r5.disabled)("ngModel", ctx_r5.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.options);
} }
function SelectComponent_div_5_ng_container_3_fw_validation_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fw-validation", 14);
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("errores", ctx_r19.notOverridenErrors);
} }
function SelectComponent_div_5_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r20.setFailures(ctx_r20.failures), " ");
} }
function SelectComponent_div_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SelectComponent_div_5_ng_container_3_fw_validation_1_Template, 1, 1, "fw-validation", 13);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, SelectComponent_div_5_ng_container_3_div_3_Template, 3, 1, "div", 3);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r6.invalid));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 4, ctx_r6.invalid));
} }
function SelectComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, SelectComponent_div_5_select_1_Template, 3, 16, "select", 5);
    ɵngcc0.ɵɵtemplate(2, SelectComponent_div_5_select_2_Template, 3, 14, "select", 6);
    ɵngcc0.ɵɵtemplate(3, SelectComponent_div_5_ng_container_3_Template, 5, 6, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.multiple);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.multiple);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.contextFormService && ctx_r2.contextFormService.state.submitted || ctx_r2.input.dirty);
} }
function SelectComponent_div_6_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "json");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r22.value != null ? ctx_r22.value["label"] || ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r22.value) : "-");
} }
function SelectComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", null, 1);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, SelectComponent_div_6_p_4_Template, 3, 3, "p", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r21 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !_r21.innerHTML.trim());
} }
function ValidationComponent_small_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(message_r1[1]);
} }
function TextComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.editing && ctx_r1.required ? "required" : "");
    ɵngcc0.ɵɵpropertyInterpolate("for", ctx_r1.cid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function TextComponent_ng_container_8_fw_validation_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fw-validation", 9);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("errores", ctx_r5.notOverridenErrors);
} }
function TextComponent_ng_container_8_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.setFailures(ctx_r6.failures), " ");
} }
function TextComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TextComponent_ng_container_8_fw_validation_1_Template, 1, 1, "fw-validation", 8);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, TextComponent_ng_container_8_div_3_Template, 3, 1, "div", 6);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r3.invalid));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 4, ctx_r3.invalid));
} }
function TextComponent_div_9_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.value || "-");
} }
function TextComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", null, 1);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, TextComponent_div_9_span_4_Template, 2, 1, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r7 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !_r7.innerHTML.trim());
} }
function SelectEnumComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.editing && ctx_r1.required ? "required" : "");
    ɵngcc0.ɵɵpropertyInterpolate("for", ctx_r1.cid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function SelectEnumComponent_div_5_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("value", undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.placeholder);
} }
function SelectEnumComponent_div_5_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const enumerado_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", enumerado_r8.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", enumerado_r8.value, " ");
} }
function SelectEnumComponent_div_5_ng_container_6_fw_validation_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fw-validation", 12);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("errores", ctx_r9.notOverridenErrors);
} }
function SelectEnumComponent_div_5_ng_container_6_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r10.setFailures(ctx_r10.failures), " ");
} }
function SelectEnumComponent_div_5_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SelectEnumComponent_div_5_ng_container_6_fw_validation_1_Template, 1, 1, "fw-validation", 11);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, SelectEnumComponent_div_5_ng_container_6_div_3_Template, 3, 1, "div", 3);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r7.invalid));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 4, ctx_r7.invalid));
} }
function SelectEnumComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "select", 5, 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function SelectEnumComponent_div_5_Template_select_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.value = $event; })("ngModelChange", function SelectEnumComponent_div_5_Template_select_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.selectItem($event); });
    ɵngcc0.ɵɵtemplate(3, SelectEnumComponent_div_5_option_3_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵtemplate(4, SelectEnumComponent_div_5_option_4_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵpipe(5, "keyvalue");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, SelectEnumComponent_div_5_ng_container_6_Template, 5, 6, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(2);
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r2.cid);
    ɵngcc0.ɵɵpropertyInterpolate("name", ctx_r2.cid);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.disabled)("ngModel", ctx_r2.value)("required", ctx_r2.required)("fwAutofocus", ctx_r2.autoFocus);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(5, 9, ctx_r2.elements, ctx_r2.keepOrder));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.contextFormService && ctx_r2.contextFormService.state.submitted || _r4.dirty);
} }
function SelectEnumComponent_div_6_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r15.elements[ctx_r15.value] ? ctx_r15.elements[ctx_r15.value] : "-");
} }
function SelectEnumComponent_div_6_p_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1, "-");
    ɵngcc0.ɵɵelementEnd();
} }
function SelectEnumComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", null, 1);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, SelectEnumComponent_div_6_p_4_Template, 2, 1, "p", 3);
    ɵngcc0.ɵɵtemplate(5, SelectEnumComponent_div_6_p_5_Template, 2, 0, "p", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r14 = ɵngcc0.ɵɵreference(2);
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.elements && ctx_r3.value && !_r14.innerHTML.trim());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.elements || !ctx_r3.value);
} }
function NumberComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.editing && ctx_r1.required ? "required" : "");
    ɵngcc0.ɵɵpropertyInterpolate("for", ctx_r1.cid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function NumberComponent_ng_container_8_fw_validation_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fw-validation", 9);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("errores", ctx_r5.notOverridenErrors);
} }
function NumberComponent_ng_container_8_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.setFailures(ctx_r6.failures), " ");
} }
function NumberComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NumberComponent_ng_container_8_fw_validation_1_Template, 1, 1, "fw-validation", 8);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, NumberComponent_ng_container_8_div_3_Template, 3, 1, "div", 6);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r3.invalid));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 4, ctx_r3.invalid));
} }
function NumberComponent_div_9_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.value || "-");
} }
function NumberComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", null, 1);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, NumberComponent_div_9_span_4_Template, 2, 1, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r7 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !_r7.innerHTML.trim());
} }
function TableComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "table", 3);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function TableComponent_fw_empty_list_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fw-empty-list");
} }
function DateComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.editing && ctx_r1.required ? "required" : "");
    ɵngcc0.ɵɵpropertyInterpolate("for", ctx_r1.cid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function DateComponent_ng_container_17_fw_validation_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fw-validation", 14);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("errores", ctx_r7.notOverridenErrors);
} }
function DateComponent_ng_container_17_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r8.setFailures(ctx_r8.failures), " ");
} }
function DateComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DateComponent_ng_container_17_fw_validation_1_Template, 1, 1, "fw-validation", 13);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, DateComponent_ng_container_17_div_3_Template, 3, 1, "div", 10);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r4.invalid));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 4, ctx_r4.invalid));
} }
function DateComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "small");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate((ctx_r5.formsConfig.i18n.validationInvalidPattern || "Invalid pattern") + " (" + ctx_r5.inputDateFormat + ")");
} }
function DateComponent_div_19_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.value && ctx_r10.value.length > 0 ? ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r10.value, ctx_r10.inputDateFormat) : "-");
} }
function DateComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", null, 1);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, DateComponent_div_19_span_4_Template, 3, 4, "span", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !_r9.innerHTML.trim());
} }
const _c10 = function () { return { "border-left-color": "#f86c6b" }; };
function DatetimeComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.editing && ctx_r1.required ? "required" : "");
    ɵngcc0.ɵɵpropertyInterpolate("for", ctx_r1.cid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function DatetimeComponent_ng_container_14_fw_validation_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fw-validation", 13);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("errores", ctx_r5.notOverridenErrors);
} }
function DatetimeComponent_ng_container_14_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.setFailures(ctx_r6.failures), " ");
} }
function DatetimeComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DatetimeComponent_ng_container_14_fw_validation_1_Template, 1, 1, "fw-validation", 12);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, DatetimeComponent_ng_container_14_div_3_Template, 3, 1, "div", 10);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r3.invalid));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 4, ctx_r3.invalid));
} }
function DatetimeComponent_div_15_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r8.value, ctx_r8.inputDatetimeFormat) || "-");
} }
function DatetimeComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", null, 1);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, DatetimeComponent_div_15_span_4_Template, 3, 4, "span", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r7 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !_r7.innerHTML.trim());
} }
function RichEditorComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.editing && ctx_r1.required ? "required" : "");
    ɵngcc0.ɵɵpropertyInterpolate("for", ctx_r1.cid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function RichEditorComponent_div_5_ng_container_2_fw_validation_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fw-validation", 7);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("errores", ctx_r5.notOverridenErrors);
} }
function RichEditorComponent_div_5_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.setFailures(ctx_r6.failures), " ");
} }
function RichEditorComponent_div_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, RichEditorComponent_div_5_ng_container_2_fw_validation_1_Template, 1, 1, "fw-validation", 6);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, RichEditorComponent_div_5_ng_container_2_div_3_Template, 3, 1, "div", 3);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r4.invalid));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 4, ctx_r4.invalid));
} }
function RichEditorComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "editor", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function RichEditorComponent_div_5_Template_editor_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.value = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, RichEditorComponent_div_5_ng_container_2_Template, 5, 6, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("invalid", (ctx_r2.contextFormService && ctx_r2.contextFormService.state.submitted || ctx_r2.input.dirty || ctx_r2.submitted) && ctx_r2.input.control.invalid)("ng-dirty", ctx_r2.input.control.dirty)("ng-touched", ctx_r2.input.control.touched)("valid", ctx_r2.input.control.valid);
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r2.cid);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.value)("init", ctx_r2.config);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.submitted === null || ctx_r2.submitted === undefined) && ctx_r2.contextFormService && ctx_r2.contextFormService.state.submitted || ctx_r2.input.dirty || ctx_r2.submitted);
} }
function RichEditorComponent_div_6_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 9);
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r10.value || "-", ɵngcc0.ɵɵsanitizeHtml);
} }
function RichEditorComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", null, 1);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, RichEditorComponent_div_6_span_4_Template, 1, 1, "span", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !_r9.innerHTML.trim());
} }
function FormSaveContinueComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 3);
} }
function FormSaveContinueComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 4);
} }
function BreadcrumbsComponent_ol_0_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", crumb_r2.path)("queryParams", crumb_r2.params);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(crumb_r2.text);
} }
function BreadcrumbsComponent_ol_0_li_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(crumb_r2.text);
} }
const _c11 = function (a0) { return { "active": a0 }; };
function BreadcrumbsComponent_ol_0_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 3);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_ol_0_li_1_a_1_Template, 2, 3, "a", 4);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_ol_0_li_1_span_2_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r2 = ctx.$implicit;
    const last_r3 = ctx.last;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c11, last_r3));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r3 && crumb_r2.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", last_r3 || !crumb_r2.path);
} }
function BreadcrumbsComponent_ol_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ol", 1);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_ol_0_li_1_Template, 3, 5, "li", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.crumbs);
} }
function FwPaginacionComponent_div_0_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.totalElements);
} }
function FwPaginacionComponent_div_0_div_1_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r4.page * ctx_r4.itemsPerPage, " ");
} }
function FwPaginacionComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementContainerStart(1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementContainerStart(4);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtemplate(6, FwPaginacionComponent_div_0_div_1_span_6_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵtemplate(7, FwPaginacionComponent_div_0_div_1_span_7_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵelementContainerStart(8);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.textShowingFrom);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r1.page - 1) * ctx_r1.itemsPerPage + 1, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.textShowingTo, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.page * ctx_r1.itemsPerPage >= ctx_r1.totalElements);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.page * ctx_r1.itemsPerPage < ctx_r1.totalElements);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.textShowingOf, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.totalElements, " ");
} }
function FwPaginacionComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "ngb-pagination", 7);
    ɵngcc0.ɵɵlistener("pageChange", function FwPaginacionComponent_div_0_div_2_Template_ngb_pagination_pageChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.page = $event; })("pageChange", function FwPaginacionComponent_div_0_div_2_Template_ngb_pagination_pageChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.loadPage(ctx_r7.page); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("collectionSize", ctx_r2.totalElements)("page", ctx_r2.page)("pageSize", ctx_r2.itemsPerPage)("maxSize", ctx_r2.maxSize)("rotate", true)("boundaryLinks", true)("directionLinks", false);
} }
function FwPaginacionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, FwPaginacionComponent_div_0_div_1_Template, 11, 7, "div", 2);
    ɵngcc0.ɵɵtemplate(2, FwPaginacionComponent_div_0_div_2_Template, 2, 7, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showTotalElements);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.totalElements > ctx_r0.itemsPerPage);
} }
function FwPaginacionSiguienteComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 2);
    ɵngcc0.ɵɵlistener("click", function FwPaginacionSiguienteComponent_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.loadNext(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.textLoadMore, " ");
} }
function FwAnchorComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FwAnchorComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 3);
    ɵngcc0.ɵɵtemplate(2, FwAnchorComponent_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r0.link);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function FwAnchorComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FwAnchorComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FwAnchorComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function FwAnchorComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function FwAsideComponent_aside_0_ng_content_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1, ["*ngIf", "!showDefaultHeader", "class", "aside-title-huj"]);
} }
function FwAsideComponent_aside_0_header_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "header");
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵlistener("click", function FwAsideComponent_aside_0_header_2_Template_div_click_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.hideAside($event); });
    ɵngcc0.ɵɵtext(4, " \u00D7 ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.title, " ");
} }
function FwAsideComponent_aside_0_ng_content_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 2, ["*ngIf", "!showDefaultFooter"]);
} }
function FwAsideComponent_aside_0_footer_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "footer");
    ɵngcc0.ɵɵelementStart(1, "button", 6);
    ɵngcc0.ɵɵlistener("click", function FwAsideComponent_aside_0_footer_7_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.hideAside($event); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 7);
    ɵngcc0.ɵɵlistener("click", function FwAsideComponent_aside_0_footer_7_Template_button_click_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.submitAside($event); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.cancelButtonTitle, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.submitButtonTitle);
} }
function FwAsideComponent_aside_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "aside", 1);
    ɵngcc0.ɵɵtemplate(1, FwAsideComponent_aside_0_ng_content_1_Template, 1, 0, "ng-content", 2);
    ɵngcc0.ɵɵtemplate(2, FwAsideComponent_aside_0_header_2_Template, 5, 1, "header", 2);
    ɵngcc0.ɵɵelementStart(3, "section");
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵprojection(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, FwAsideComponent_aside_0_ng_content_6_Template, 1, 0, "ng-content", 2);
    ɵngcc0.ɵɵtemplate(7, FwAsideComponent_aside_0_footer_7_Template, 5, 2, "footer", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@slide", ctx_r0.position)("className", ctx_r0.position);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.showDefaultHeader);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showDefaultHeader);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.showDefaultFooter);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showDefaultFooter);
} }
const _c12 = ["*", [["header"]], [["footer"]]];
const _c13 = ["*", "header", "footer"];
function ConfirmUpdateToastComponent_ngb_toast_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-toast", 1);
    ɵngcc0.ɵɵlistener("hide", function ConfirmUpdateToastComponent_ngb_toast_0_Template_ngb_toast_hide_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const toast_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.confirmUpdateToastService.hide(toast_r1); });
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementStart(3, "a", 2);
    ɵngcc0.ɵɵlistener("click", function ConfirmUpdateToastComponent_ngb_toast_0_Template_a_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r3); const toast_r1 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.launchUpdate(toast_r1); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const toast_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("autohide", false)("header", toast_r1.header)("ngClass", toast_r1.cssClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", toast_r1.body, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(toast_r1.updateLabel);
} }
class FwCommonConfig {
    constructor() {
        this.i18n = {};
    }
}
FwCommonConfig.ɵfac = function FwCommonConfig_Factory(t) { return new (t || FwCommonConfig)(); };
FwCommonConfig.ɵprov = ɵɵdefineInjectable({ factory: function FwCommonConfig_Factory() { return new FwCommonConfig(); }, token: FwCommonConfig, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwCommonConfig, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class ToastService {
    constructor(toastr) {
        this.toastr = toastr;
        this.timeout = 7000;
        toastr.toastrConfig.positionClass = 'toast-bottom-center';
        toastr.toastrConfig.enableHtml = true;
    }
    success(message, timeout) {
        this.toastr.success(message, null, { timeOut: timeout || this.timeout });
    }
    info(message, timeout) {
        this.toastr.info(message, null, { timeOut: timeout || this.timeout });
    }
    warning(message, timeout) {
        this.toastr.warning(message, null, { timeOut: timeout || this.timeout });
    }
    error(message, timeout) {
        this.toastr.error(message, null, { timeOut: timeout || this.timeout });
    }
    clear() {
        this.toastr.clear();
    }
}
ToastService.ɵfac = function ToastService_Factory(t) { return new (t || ToastService)(ɵngcc0.ɵɵinject(ɵngcc1.ToastrService)); };
ToastService.ɵprov = ɵɵdefineInjectable({ factory: function ToastService_Factory() { return new ToastService(ɵɵinject(ToastrService)); }, token: ToastService, providedIn: "root" });
ToastService.ctorParameters = () => [
    { type: ToastrService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.ToastrService }]; }, null); })();

class AlertErrorService {
    constructor(toastService, config) {
        this.toastService = toastService;
        this.config = config;
        this.visible = false;
        this.alerts = [];
        this.newAlertSource = new Subject();
        this.removeAlertsSource = new Subject();
        this.newAlert$ = this.newAlertSource.asObservable();
        this.removeAlerts$ = this.removeAlertsSource.asObservable();
        this.innerWidth = window.innerWidth;
        window.addEventListener('resize', () => {
            this.innerWidth = window.innerWidth;
        });
    }
    static buildErrorMessage(error) {
        let mensaje = error.message;
        const fieldErrors = error.fieldErrors;
        if (fieldErrors) {
            mensaje += '<ul >';
            for (let i = 0; i < fieldErrors.length; i++) {
                const fieldError = fieldErrors[i];
                // TODO test whith nested objects
                mensaje += '<li>' + fieldError.field + ': ' + fieldError.message + '</li>';
            }
            mensaje += '</ul>';
        }
        return mensaje;
    }
    show(httpErrorResponse) {
        this.alerts = [];
        const error = httpErrorResponse.error;
        if (!error || error.path === '/api/account') { /* TODO Los errores, incluso los de la cuenta de users deberían llegar traducidos */
            return;
        }
        const NO_HAY_CONEXION = 0;
        const GATEWAY_TIMEOUT = 504;
        if (httpErrorResponse.status === NO_HAY_CONEXION || httpErrorResponse.status === GATEWAY_TIMEOUT) {
            // tslint:disable-next-line:max-line-length
            this.toastService.warning(this.config.i18n.connectionErrorToastMessage || 'Connection to the server failed, check your Internet connection. If the problem persists please contact the administrator.');
        }
        else {
            const mensaje = AlertErrorService.buildErrorMessage(error);
            const LIMITE_PX_XS_BOOTSTRAP = 576;
            if (this.innerWidth < LIMITE_PX_XS_BOOTSTRAP || !this.visible) {
                this.toastService.error(mensaje);
            }
            else {
                this.addErrorAlert(mensaje);
            }
        }
    }
    closeAlert() {
        this.removeAlertsSource.next(true);
        this.alerts = [];
        this.toastService.clear();
    }
    ngOnDestroy() {
        this.alerts = [];
    }
    addErrorAlert(message) {
        this.newAlertSource.next({
            type: 'danger',
            msg: message
        });
    }
}
AlertErrorService.ɵfac = function AlertErrorService_Factory(t) { return new (t || AlertErrorService)(ɵngcc0.ɵɵinject(ToastService), ɵngcc0.ɵɵinject(FwCommonConfig)); };
AlertErrorService.ɵprov = ɵɵdefineInjectable({ factory: function AlertErrorService_Factory() { return new AlertErrorService(ɵɵinject(ToastService), ɵɵinject(FwCommonConfig)); }, token: AlertErrorService, providedIn: "root" });
AlertErrorService.ctorParameters = () => [
    { type: ToastService },
    { type: FwCommonConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertErrorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ToastService }, { type: FwCommonConfig }]; }, null); })();

class FwConfirmationDialogComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    ngOnInit() {
    }
    decline() {
        this.activeModal.dismiss();
    }
    accept() {
        this.activeModal.close(true);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
}
FwConfirmationDialogComponent.ɵfac = function FwConfirmationDialogComponent_Factory(t) { return new (t || FwConfirmationDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgbActiveModal)); };
FwConfirmationDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FwConfirmationDialogComponent, selectors: [["fw-confirmation-dialog"]], inputs: { title: "title", message: "message", btnOkText: "btnOkText", btnCancelText: "btnCancelText" }, decls: 13, vars: 4, consts: [[1, "modal-header"], [1, "modal-title"], ["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], [3, "innerHTML"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["type", "button", 1, "btn", "btn-danger", 3, "click"]], template: function FwConfirmationDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h4", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 2);
        ɵngcc0.ɵɵlistener("click", function FwConfirmationDialogComponent_Template_button_click_3_listener() { return ctx.dismiss(); });
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelement(7, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "button", 7);
        ɵngcc0.ɵɵlistener("click", function FwConfirmationDialogComponent_Template_button_click_9_listener() { return ctx.accept(); });
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 8);
        ɵngcc0.ɵɵlistener("click", function FwConfirmationDialogComponent_Template_button_click_11_listener() { return ctx.decline(); });
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.message, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.btnOkText);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.btnCancelText);
    } }, encapsulation: 2 });
FwConfirmationDialogComponent.ctorParameters = () => [
    { type: NgbActiveModal }
];
FwConfirmationDialogComponent.propDecorators = {
    title: [{ type: Input }],
    message: [{ type: Input }],
    btnOkText: [{ type: Input }],
    btnCancelText: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwConfirmationDialogComponent, [{
        type: Component,
        args: [{
                selector: 'fw-confirmation-dialog',
                template: "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title\">{{ title }}</h4>\r\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"dismiss()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <span [innerHTML]=\"(message)\"></span>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n      <button type=\"button\" class=\"btn btn-primary\" (click)=\"accept()\">{{ btnOkText }}</button>\r\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"decline()\">{{ btnCancelText }}</button>\r\n  </div>\r\n"
            }]
    }], function () { return [{ type: ɵngcc2.NgbActiveModal }]; }, { title: [{
            type: Input
        }], message: [{
            type: Input
        }], btnOkText: [{
            type: Input
        }], btnCancelText: [{
            type: Input
        }] }); })();

/**
 * Extensión de la directiva de routing para poder detectar cuando un componente reutilizado (RouteReuseStrategy)
 * deja de estar visible, y desactivar el scrolling infinito para mejorar el rendimiento.
 * https://github.com/orizens/ngx-infinite-scroll/issues/303
 */
class AppRouterOutletDirective extends RouterOutlet {
    detach() {
        const instance = this.component;
        if (instance && typeof instance.onDetach === 'function') {
            instance.onDetach();
        }
        return super.detach();
    }
    attach(ref, activatedRoute) {
        super.attach(ref, activatedRoute);
        if (ref.instance && typeof ref.instance.onAttach === 'function') {
            ref.instance.onAttach(ref, activatedRoute);
        }
    }
}
AppRouterOutletDirective.ɵfac = function AppRouterOutletDirective_Factory(t) { return ɵAppRouterOutletDirective_BaseFactory(t || AppRouterOutletDirective); };
AppRouterOutletDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AppRouterOutletDirective, selectors: [["fw-router-outlet"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵAppRouterOutletDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AppRouterOutletDirective);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppRouterOutletDirective, [{
        type: Directive,
        args: [{ selector: 'fw-router-outlet' }]
    }], null, null); })();

class BaseUrlGeneratorService {
    constructor(location) {
        this.location = location;
    }
    generateBaseUrl(apiPrefix) {
        let baseHref = this.location.prepareExternalUrl('');
        if (baseHref !== '/') {
            baseHref = baseHref.slice(0, -1);
        }
        return baseHref + apiPrefix;
    }
}
BaseUrlGeneratorService.ɵfac = function BaseUrlGeneratorService_Factory(t) { return new (t || BaseUrlGeneratorService)(ɵngcc0.ɵɵinject(ɵngcc3.Location)); };
BaseUrlGeneratorService.ɵprov = ɵɵdefineInjectable({ factory: function BaseUrlGeneratorService_Factory() { return new BaseUrlGeneratorService(ɵɵinject(Location)); }, token: BaseUrlGeneratorService, providedIn: "root" });
BaseUrlGeneratorService.ctorParameters = () => [
    { type: Location }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseUrlGeneratorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.Location }]; }, null); })();

const identitySerializer = {
    serialize(o) {
        return o;
    },
    deserialize(o) {
        return o;
    }
};
class CustomEndpointContextService {
    constructor(httpClient, baseUrlGeneratorService) {
        this.httpClient = httpClient;
        this.baseUrlGeneratorService = baseUrlGeneratorService;
        this.serializers = {
            any: identitySerializer,
            string: identitySerializer,
            number: identitySerializer,
            boolean: identitySerializer
        };
        this.registerDefaultSerializers();
        this.baseUrl = baseUrlGeneratorService.generateBaseUrl('api');
    }
    request(data) {
        const url = this.buildUrl(data.uriTemplate, data.pathVariables);
        const requestParams = data.requestParams;
        let params = undefined;
        if (requestParams != null) {
            const filteredParams = {};
            for (const key of Object.keys(requestParams)) {
                const value = requestParams[key];
                if (value != null) {
                    filteredParams[key] = value;
                }
            }
            params = new HttpParams({ fromObject: filteredParams });
        }
        return this.httpClient.request(data.method, url, { params, body: data.requestBody })
            .pipe(map(r => data.responseType ? this.deserialize(r, data.responseType) : r));
    }
    buildUrl(uriTemplate, pathVariables) {
        return this.baseUrl + uriTemplate.replace(/{([^}]+)}/g, (match, name) => pathVariables[name]);
    }
    registerDefaultSerializers() {
        this.registerIdentitySerializer('Class');
        this.registerClassSerializer('LanguageDTO', {
            'code': 'string',
            'default': 'boolean',
            'name': 'string',
            'translation': 'string'
        });
    }
    arraySerializer(elementSerializer) {
        function safeMap(value, mapper) {
            if (!value) {
                return value;
            }
            else {
                return value.map(mapper);
            }
        }
        return {
            serialize(value) {
                return safeMap(value, elementSerializer.serialize.bind(elementSerializer));
            },
            deserialize(value) {
                return safeMap(value, elementSerializer.deserialize.bind(elementSerializer));
            }
        };
    }
    serialize(value, type) {
        return this.lookupSerializer(type).serialize(value);
    }
    deserialize(value, type) {
        return this.lookupSerializer(type).deserialize(value);
    }
    registerIdentitySerializer(name) {
        this.registerSerializer(name, identitySerializer);
    }
    registerSerializer(name, serializer) {
        this.serializers[name] = serializer;
    }
    registerClassSerializer(name, fields) {
        this.registerSerializer(name, this.classSerializer(fields));
    }
    classSerializer(fields) {
        function mapProperties(obj, propertyMapper) {
            if (obj === null || obj === undefined) {
                return obj;
            }
            const result = {};
            for (const name in fields) {
                if (fields.hasOwnProperty(name)) {
                    const value = obj[name];
                    const type = fields[name];
                    result[name] = propertyMapper(value, type);
                }
            }
            return result;
        }
        const serialize = this.serialize.bind(this);
        const deserialize = this.deserialize.bind(this);
        return {
            serialize(obj) {
                return mapProperties(obj, serialize);
            },
            deserialize(obj) {
                return mapProperties(obj, deserialize);
            }
        };
    }
    lookupSerializer(type) {
        if (!type) {
            throw new Error('no type given');
        }
        if (type.indexOf('[]', type.length - 2) !== -1) { // type.endsWith('[]')
            const elementType = type.substring(0, type.length - 2);
            const elementSerializer = this.lookupSerializer(elementType);
            return this.arraySerializer(elementSerializer);
        }
        const serializer = this.serializers[type];
        if (serializer) {
            return serializer;
        }
        else {
            throw new Error(`could not find serializer for type '${type}'`);
        }
    }
}
CustomEndpointContextService.ɵfac = function CustomEndpointContextService_Factory(t) { return new (t || CustomEndpointContextService)(ɵngcc0.ɵɵinject(ɵngcc4.HttpClient), ɵngcc0.ɵɵinject(BaseUrlGeneratorService)); };
CustomEndpointContextService.ɵprov = ɵɵdefineInjectable({ factory: function CustomEndpointContextService_Factory() { return new CustomEndpointContextService(ɵɵinject(HttpClient), ɵɵinject(BaseUrlGeneratorService)); }, token: CustomEndpointContextService, providedIn: "root" });
CustomEndpointContextService.ctorParameters = () => [
    { type: HttpClient },
    { type: BaseUrlGeneratorService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomEndpointContextService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc4.HttpClient }, { type: BaseUrlGeneratorService }]; }, null); })();

class LanguageService {
    constructor(context, cookieService) {
        this.context = context;
        this.cookieService = cookieService;
        this.cookieName = 'NG_TRANSLATE_LANG_KEY';
        this.localStorageName = 'locale';
    }
    getCurrentLanguage() {
        return this.context.request({
            'uriTemplate': '/languages/current',
            'method': 'GET',
            'responseType': 'LanguageDTO'
        });
    }
    getCurrentLanguageUrl() {
        return this.context.buildUrl('/languages/current', null);
    }
    getCurrentLanguageLocaleStorage() {
        return localStorage.getItem('locale');
    }
    getCurrentLanguageCookie() {
        return this.cookieService.get(this.cookieName);
    }
    getLanguages() {
        return this.context.request({
            'uriTemplate': '/languages',
            'method': 'GET',
            'responseType': 'LanguageDTO[]'
        });
    }
    getLanguagesUrl() {
        return this.context.buildUrl('/languages', null);
    }
    /**
     * Set language in localStorage and a cookie and unregister serviceWorker.
     * @param lang LanguageDTO
     */
    changeLang(lang) {
        if (lang.default) {
            this.setLanguage(null);
        }
        else {
            this.setLanguage(lang);
        }
        navigator.serviceWorker.getRegistration().then(function (reg) {
            if (reg) {
                reg.unregister().then(function () {
                    window.location.reload();
                });
            }
            else {
                window.location.reload();
            }
        });
    }
    setLanguage(lang) {
        if (lang) {
            localStorage.setItem(this.localStorageName, lang.code.toLowerCase());
            this.cookieService.put(this.cookieName, lang.code.toLowerCase());
        }
        else {
            localStorage.removeItem(this.localStorageName);
            this.cookieService.remove(this.cookieName);
        }
    }
}
LanguageService.ɵfac = function LanguageService_Factory(t) { return new (t || LanguageService)(ɵngcc0.ɵɵinject(CustomEndpointContextService), ɵngcc0.ɵɵinject(ɵngcc5.CookieService)); };
LanguageService.ɵprov = ɵɵdefineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(ɵɵinject(CustomEndpointContextService), ɵɵinject(CookieService)); }, token: LanguageService, providedIn: "root" });
LanguageService.ctorParameters = () => [
    { type: CustomEndpointContextService },
    { type: CookieService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LanguageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: CustomEndpointContextService }, { type: ɵngcc5.CookieService }]; }, null); })();

class SelectorIdiomaComponent {
    constructor(cookieService, languageService) {
        this.cookieService = cookieService;
        this.languageService = languageService;
        this.languages = [];
        this.languageService.getLanguages().subscribe(langs => this.languages = langs);
    }
    ngOnInit() {
        this.locale = this.languageService.getCurrentLanguageLocaleStorage();
    }
    changeLang(lang) {
        this.languageService.changeLang(lang);
    }
}
SelectorIdiomaComponent.ɵfac = function SelectorIdiomaComponent_Factory(t) { return new (t || SelectorIdiomaComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.CookieService), ɵngcc0.ɵɵdirectiveInject(LanguageService)); };
SelectorIdiomaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SelectorIdiomaComponent, selectors: [["fw-selector-idioma"]], decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], ["href", "javascript:void(0);", 3, "click", 4, "ngIf"], ["href", "javascript:void(0);", 3, "click"]], template: function SelectorIdiomaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SelectorIdiomaComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.languages.length > 1);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf], pipes: [ɵngcc3.TitleCasePipe], styles: [""] });
SelectorIdiomaComponent.ctorParameters = () => [
    { type: CookieService },
    { type: LanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectorIdiomaComponent, [{
        type: Component,
        args: [{
                selector: 'fw-selector-idioma',
                template: "<div *ngIf=\"languages.length > 1\">\r\n    <span *ngFor=\"let lang of languages; let i = index\">\r\n        <span *ngIf=\"lang.code.toLowerCase() === locale || lang.default && locale == null\">\r\n            {{lang.name | titlecase}}\r\n        </span>\r\n        <a href=\"javascript:void(0);\" (click)=\"changeLang(lang)\"\r\n           *ngIf=\"(locale != null && lang.default) || (!lang.default &&  lang.code.toLowerCase() !== locale)\">{{lang.name | titlecase}}</a>\r\n        <span *ngIf=\"i < languages.length - 1\"> | </span>\r\n    </span>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc5.CookieService }, { type: LanguageService }]; }, null); })();

class FwCommonModule {
}
FwCommonModule.ɵfac = function FwCommonModule_Factory(t) { return new (t || FwCommonModule)(); };
FwCommonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FwCommonModule });
FwCommonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, NgbAlertModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FwCommonModule, { declarations: function () { return [FwConfirmationDialogComponent, AppRouterOutletDirective, SelectorIdiomaComponent]; }, imports: function () { return [CommonModule, NgbAlertModule]; }, exports: function () { return [FwConfirmationDialogComponent, AppRouterOutletDirective, SelectorIdiomaComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwCommonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NgbAlertModule],
                declarations: [FwConfirmationDialogComponent, AppRouterOutletDirective, SelectorIdiomaComponent],
                entryComponents: [FwConfirmationDialogComponent],
                exports: [FwConfirmationDialogComponent, AppRouterOutletDirective, SelectorIdiomaComponent],
                providers: []
            }]
    }], null, null); })();

/**
 * Hot Module Reloading. Update page without full reload in development.
 */
const hmrBootstrap = (module, bootstrap) => {
    let ngModule;
    module.hot.accept();
    bootstrap().then(mod => ngModule = mod);
    module.hot.dispose(() => {
        const appRef = ngModule.injector.get(ApplicationRef);
        const elements = appRef.components.map(c => c.location.nativeElement);
        const makeVisible = createNewHosts(elements);
        ngModule.destroy();
        makeVisible();
    });
};

class ConfirmationDialogService {
    constructor(modalService, config) {
        this.modalService = modalService;
        this.config = config;
    }
    confirm(title, message, btnOkText = this.config.i18n.confirmOk || 'Yes', btnCancelText = this.config.i18n.confirmCancel || 'No', dialogSize = 'lg') {
        const modalRef = this.modalService.open(FwConfirmationDialogComponent, { size: dialogSize });
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.btnOkText = btnOkText;
        modalRef.componentInstance.btnCancelText = btnCancelText;
        return modalRef.result;
    }
    confirmDelete(message) {
        return this.confirm(this.config.i18n.confirmTitle || 'Delete confirmation', message);
    }
}
ConfirmationDialogService.ɵfac = function ConfirmationDialogService_Factory(t) { return new (t || ConfirmationDialogService)(ɵngcc0.ɵɵinject(ɵngcc2.NgbModal), ɵngcc0.ɵɵinject(FwCommonConfig)); };
ConfirmationDialogService.ɵprov = ɵɵdefineInjectable({ factory: function ConfirmationDialogService_Factory() { return new ConfirmationDialogService(ɵɵinject(NgbModal), ɵɵinject(FwCommonConfig)); }, token: ConfirmationDialogService, providedIn: "root" });
ConfirmationDialogService.ctorParameters = () => [
    { type: NgbModal },
    { type: FwCommonConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfirmationDialogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.NgbModal }, { type: FwCommonConfig }]; }, null); })();

const flattenConPrefijosExceptoElPrimero = function (object, separator = '.') {
    const isValidObject = (value) => {
        if (!value) {
            return false;
        }
        const isArray = Array.isArray(value);
        const isΟbject = Object.prototype.toString.call(value) === '[object Object]';
        const hasKeys = !!Object.keys(value).length;
        return !isArray && isΟbject && hasKeys;
    };
    const walker = (child, path = []) => {
        return Object.assign({}, ...Object.keys(child).map(key => isValidObject(child[key])
            ? walker(child[key], path.length === 0 ? path.concat(['']) : path.concat([key]))
            : { [path.concat([key]).join(separator)]: child[key] }));
    };
    return Object.assign({}, walker(object));
};

class Store {
    constructor(initialState) {
        this._state$ = new BehaviorSubject(initialState);
        this.state$ = this._state$.asObservable();
    }
    get state() {
        return this._state$.getValue();
    }
    setState(nextState) {
        this._state$.next(nextState);
    }
}

class CustomReuseStrategy {
    constructor() {
        /**
         * Object which will store RouteStorageObjects indexed by keys
         * The keys will all be a path (as in route.routeConfig.path)
         * This allows us to see if we've got a route stored for the requested path
         */
        this.storedRoutes = {};
    }
    /* https://github.com/angular/angular/issues/13869#issuecomment-353940101 */
    static getPath(route) {
        const result = route.pathFromRoot
            .map(r => r.routeConfig && r.routeConfig.path)
            .filter(path => !!path)
            .join('/');
        return result;
    }
    /**
     * Decides when the route should be stored
     * If the route should be stored, I believe the boolean is indicating to a controller whether or not to fire this.store
     * _When_ it is called though does not particularly matter, just know that this determines whether or not we store the route
     * An idea of what to do here: check the route.routeConfig.path to see if it is a path you would like to store
     * @param route This is, at least as I understand it, the route that the user is currently on, and we would like to know if we want to store it
     * @returns boolean indicating that we want to (true) or do not want to (false) store that route
     */
    shouldDetach(route) {
        return route.data['cacheable'] === true;
    }
    /**
     * Constructs object of type `RouteStorageObject` to store, and then stores it for later attachment
     * @param route This is stored for later comparison to requested routes, see `this.shouldAttach`
     * @param handle Later to be retrieved by this.retrieve, and offered up to whatever controller is using this class
     */
    store(route, handle) {
        // routes are stored by path - the key is the path name, and the handle is stored under it so that you can only ever have one object stored for a single path
        this.storedRoutes[CustomReuseStrategy.getPath(route)] = {
            params: route.params,
            queryParams: route.queryParams,
            handle
        };
    }
    /**
     * Determines whether or not there is a stored route and, if there is, whether or not it should be rendered in place of requested route
     * @param route The route the user requested
     * @returns boolean indicating whether or not to render the stored route
     */
    shouldAttach(route) {
        // this will be true if the route has been stored before
        const canAttach = !!route.routeConfig && !!this.storedRoutes[CustomReuseStrategy.getPath(route)];
        // this decides whether the route already stored should be rendered in place of the requested route, and is the return value
        // at this point we already know that the paths match because the storedResults key is the route.routeConfig.path
        // so, if the route.params and route.queryParams also match, then we should reuse the component
        if (canAttach) {
            const paramsMatch = isEqual(route.params, this.storedRoutes[CustomReuseStrategy.getPath(route)].params);
            const queryParamsMatch = isEqual(route.queryParams, this.storedRoutes[CustomReuseStrategy.getPath(route)].queryParams);
            return paramsMatch && queryParamsMatch;
        }
        else {
            return false;
        }
    }
    /**
     * Finds the locally stored instance of the requested route, if it exists, and returns it
     * @param route New route the user has requested
     * @returns DetachedRouteHandle object which can be used to render the component
     */
    retrieve(route) {
        // https://github.com/angular/angular/issues/13869
        // return null if the path does not have a routerConfig OR if there is no stored route for that routerConfig
        if (!route.routeConfig || (route.routeConfig.loadChildren) || !this.storedRoutes[CustomReuseStrategy.getPath(route)]) {
            return null;
        }
        /** returns handle when the route.routeConfig.path is already stored */
        return this.storedRoutes[CustomReuseStrategy.getPath(route)].handle;
    }
    /**
     * Determines whether or not the current route should be reused
     * @param future The route the user is going to, as triggered by the router
     * @param curr The route the user is currently on
     * @returns boolean basically indicating true if the user intends to leave the current route
     */
    shouldReuseRoute(future, curr) {
        return future.routeConfig === curr.routeConfig;
    }
}
CustomReuseStrategy.ɵfac = function CustomReuseStrategy_Factory(t) { return new (t || CustomReuseStrategy)(); };
CustomReuseStrategy.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CustomReuseStrategy, factory: CustomReuseStrategy.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomReuseStrategy, [{
        type: Injectable
    }], function () { return []; }, null); })();

/*
 * Public API Surface of fw-common
 */

class FwFormsConfig {
    constructor() {
        this.i18n = {};
    }
}
FwFormsConfig.ɵfac = function FwFormsConfig_Factory(t) { return new (t || FwFormsConfig)(); };
FwFormsConfig.ɵprov = ɵɵdefineInjectable({ factory: function FwFormsConfig_Factory() { return new FwFormsConfig(); }, token: FwFormsConfig, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwFormsConfig, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class FwBaseList {
    constructor() {
        /** Esta función la utilizamos en los bucles para mejorar el rendimiento,
         *  es el equivalente al "track by id"  de angularjs **/
        this.trackIdentity = (index, item) => item.id;
        this.keepOrder = e => 1;
        this.removeEmpty = obj => {
            Object.keys(obj).forEach(key => {
                if (obj[key] && typeof obj[key] === 'object') {
                    this.removeEmpty(obj[key]);
                }
                else if (obj[key] === undefined) {
                    delete obj[key];
                }
            });
            return obj;
        };
    }
}

/**
 * Componente base para formularios que solo tienen modo edición.
 * - Evita submits duplicados
 * - Mantiene el valor submitted del formulario para saber si mostrar los mensajes de error en los inputs
 * - Gestiona un array de subscripciones para eliminarlas al destruir el componente
 * - Fuerza una interfaz común en todos los formularios
 */
class FwSaveForm {
    constructor() {
        this.subForms = new QueryList();
        this.context = {
            sending: false,
            submitted: false,
            editing: true,
            save: this.save.bind(this)
        };
        this.subs = new Subscription(); // Todas las suscripciones que se utilicen en el formulario deben añadirse aquí
        /* Utilidades */
        this.keepOrder = e => 1;
        this.validFieldSet = (x) => {
            const fieldset = x;
            /* Para evitar errores comprobamos primero si la propiedad es un FwFieldset  comprobando que tenga un
             metodo isValid. En caso contrario devolvemos true*/
            if (fieldset.isValid) {
                return fieldset.isValid();
            }
            return true;
        };
    }
    save(form) {
        this.context = Object.assign(Object.assign({}, this.context), { submitted: true });
        if (form.form.valid && (!this.subForms || this.subForms.toArray().every(this.validFieldSet))) {
            this.context = Object.assign(Object.assign({}, this.context), { sending: true });
            this.subs.add(this.onSave().subscribe(() => this.afterSave(), () => this.afterSave()));
        }
    }
    afterSave() {
        this.context = Object.assign(Object.assign({}, this.context), { sending: false });
    }
    trackIdentity(index, item) {
        return item.id;
    }
    /** Compara por id, útil para mantener el estado en los select */
    compareById(item1, item2) {
        return item1 && item2 && item1.id === item2.id;
    }
    /* Al destruirse un componente las suscripciones siguen activas salvo que las destruyamos explícitamente,
      con la excepción de ActivatedRoute  y las llamadas a HTTP (métodos apina), que ya las destruye Angular. */
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
FwSaveForm.ɵfac = function FwSaveForm_Factory(t) { return new (t || FwSaveForm)(); };
FwSaveForm.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FwSaveForm, viewQuery: function FwSaveForm_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.subForms = _t);
    } } });
FwSaveForm.propDecorators = {
    subForms: [{ type: ViewChildren, args: ['fieldset',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwSaveForm, [{
        type: Directive
    }], function () { return []; }, { subForms: [{
            type: ViewChildren,
            args: ['fieldset']
        }] }); })();

/**
 * Componente base para formularios.
 * Tiene varias responsabilidades:
 * - Abstrae el estado del formulario: edición o modo lectura
 * - Abstrae la gestión del estado de envío del formulario para evitar submits duplicados
 * - Implementa una guarda para avisar al user de que abandona un formulario sin guardar
 * - Gestiona un array de subscripciones para eliminarlas al destruir el componente
 * - Evita cargar del nuevo los datos de edición cuando ya se han cargado previamente.
 * - Fuerza una interfaz común en todos los formularios
 */
// tslint:disable-next-line:directive-class-suffix
class FwCreateUpdateForm {
    constructor() {
        this.subs = new Subscription(); // Todas las suscripciones que sean necesarias deben añadirse aquí!
        this.subForms = new QueryList();
        this.edit = () => {
            this.context = Object.assign(Object.assign({}, this.context), { editing: true });
            this.backup = cloneDeep(this.entity);
            if (!this.isFormDataLoaded) {
                this.loadFormData();
                this.isFormDataLoaded = true;
            }
        };
        /* Utilidades */
        this.keepOrder = e => 1;
        this.validFieldSet = (x) => {
            const fieldset = x;
            /* Para evitar errores comprobamos primero si la propiedad es un FwFieldset  comprobando que tenga un
             metodo isValid. En caso contrario devolvemos true*/
            if (fieldset.isValid) {
                return fieldset.isValid();
            }
            return true;
        };
    }
    loadContext(entity, editing, identificador) {
        this.context = {
            sending: false,
            isNew: !entity[identificador || 'id'],
            submitted: false,
            editing: editing || (!entity[identificador || 'id'] && editing !== false),
            edit: this.edit.bind(this),
            cancel: this.cancel.bind(this),
            save: this.save.bind(this),
        };
        this.entity = entity;
        this.backup = cloneDeep(entity);
        if (this.context.isNew) {
            this.loadFormData();
            this.isFormDataLoaded = true;
        }
    }
    /** Compara por id, útil para mantener el estado en los select */
    compareById(item1, item2) {
        return item1 && item2 && item1.id === item2.id;
    }
    save(form) {
        this.context = Object.assign(Object.assign({}, this.context), { submitted: true });
        if (form.form.valid && (!this.subForms || this.subForms.toArray().every(this.validFieldSet))) {
            this.context = Object.assign(Object.assign({}, this.context), { sending: true });
            if (this.context.isNew) {
                this.subs.add(this.onCreate().subscribe(() => this.afterCreate(), () => this.onSaveError()));
            }
            else {
                this.subs.add(this.onUpdate().subscribe(() => this.afterUpdate(), () => this.onSaveError()));
            }
        }
    }
    afterCreate() {
        this.context = Object.assign(Object.assign({}, this.context), { sending: false });
        this.backup = cloneDeep(this.entity);
    }
    afterUpdate() {
        this.context = Object.assign(Object.assign({}, this.context), { editing: false, sending: false });
        this.backup = cloneDeep(this.entity);
    }
    /* Control del estado del formulario */
    onSaveError() {
        this.context = Object.assign(Object.assign({}, this.context), { sending: false });
    }
    cancel() {
        if (this.context.isNew) {
            window.history.back();
        }
        else {
            this.context = Object.assign(Object.assign({}, this.context), { editing: false });
            this.entity = this.backup;
        }
    }
    /* Confirmación de pérdida de cambios */
    canDeactivate() {
        return !(this.context && this.context.editing) || isEqual$1(this.entity, this.backup);
    }
    trackIdentity(index, item) {
        return item.id;
    }
    ngOnDestroy() {
        /* Al destruirse un componente las suscripciones siguen activas salvo que las destruyamos explícitamente,
         con la excepción de ActivatedRoute  y las llamadas a HTTP (métodos apina), que ya las destruye Angular. */
        this.subs.unsubscribe();
    }
}
FwCreateUpdateForm.ɵfac = function FwCreateUpdateForm_Factory(t) { return new (t || FwCreateUpdateForm)(); };
FwCreateUpdateForm.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FwCreateUpdateForm, viewQuery: function FwCreateUpdateForm_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.subForms = _t);
    } } });
FwCreateUpdateForm.propDecorators = {
    subForms: [{ type: ViewChildren, args: ['fieldset',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwCreateUpdateForm, [{
        type: Directive
    }], function () { return []; }, { subForms: [{
            type: ViewChildren,
            args: ['fieldset']
        }] }); })();

/**
 * Componente base para formularios.
 * Tiene varias responsabilidades:
 * - Abstrae el estado del formulario: edición o modo lectura
 * - Abstrae la gestión del estado de envío del formulario para evitar submits duplicados
 * - Implementa una guarda para avisar al user de que abandona un formulario sin guardar
 * - Gestiona un array de subscripciones para eliminarlas al destruir el componente
 * - Evita cargar del nuevo los datos de edición cuando ya se han cargado previamente.
 * - Fuerza una interfaz común en todos los formularios
 */
// tslint:disable-next-line:directive-class-suffix
class FwCreateUpdateContinueForm extends FwCreateUpdateForm {
    loadContext(entity, editing, identificador) {
        super.loadContext(entity, editing, identificador);
        this.context = Object.assign(Object.assign({}, this.context), { continued: this.continuing.bind(this) });
    }
    afterCreate() {
        if (this.context.continuing) {
            this.context = Object.assign(Object.assign({}, this.context), { sending: false, editing: true, continuing: false });
            this.backup = cloneDeep(this.entity);
        }
        else {
            super.afterCreate();
        }
    }
    afterUpdate() {
        if (this.context.continuing) {
            this.context = Object.assign(Object.assign({}, this.context), { editing: true, sending: false, continuing: false });
            this.backup = cloneDeep(this.entity);
        }
        else {
            super.afterUpdate();
        }
    }
    cancel() {
        if (this.context.continuing) {
            this.context = Object.assign(Object.assign({}, this.context), { continuing: false });
        }
        super.cancel();
    }
    onSaveError() {
        if (this.context.continuing) {
            this.context = Object.assign(Object.assign({}, this.context), { sending: false, continuing: false });
        }
        else {
            super.onSaveError();
        }
    }
    continuing() {
        this.context = Object.assign(Object.assign({}, this.context), { continuing: true });
    }
}
FwCreateUpdateContinueForm.ɵfac = function FwCreateUpdateContinueForm_Factory(t) { return ɵFwCreateUpdateContinueForm_BaseFactory(t || FwCreateUpdateContinueForm); };
FwCreateUpdateContinueForm.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FwCreateUpdateContinueForm, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵFwCreateUpdateContinueForm_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(FwCreateUpdateContinueForm);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwCreateUpdateContinueForm, [{
        type: Directive
    }], null, null); })();

class Context {
    constructor(sending, submitted, save, editing = true, isNew, continuing, edit, cancel, continued) {
        this.sending = sending;
        this.submitted = submitted;
        this.save = save;
        this.editing = editing;
        this.isNew = isNew;
        this.continuing = continuing;
        this.edit = edit;
        this.cancel = cancel;
        this.continued = continued;
    }
}

class Store$1 {
    constructor(initialState) {
        this._state$ = new BehaviorSubject(initialState);
        this.state$ = this._state$.asObservable();
    }
    get state() {
        return this._state$.getValue();
    }
    setState(nextState) {
        this._state$.next(nextState);
    }
}

class ContextFormService extends Store$1 {
    constructor() {
        super(new Context(false, false, null, false));
    }
}
ContextFormService.ɵfac = function ContextFormService_Factory(t) { return new (t || ContextFormService)(); };
ContextFormService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ContextFormService, factory: ContextFormService.ɵfac });
ContextFormService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContextFormService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class CustomInputComponent {
    constructor(contextFormService, config) {
        this.contextFormService = contextFormService;
        this.config = config;
        this.editing = true;
        this.required = false;
        this.textRequired = this.config.i18n.validationRequired || 'Required field.';
    }
    ngOnInit() {
        if (this.contextFormService) {
            this.sub = this.contextFormService.state$.subscribe((contexto) => {
                this.editing = contexto.editing;
                this.submitted = contexto.submitted;
            });
        }
    }
    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
CustomInputComponent.ɵfac = function CustomInputComponent_Factory(t) { return new (t || CustomInputComponent)(ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
CustomInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CustomInputComponent, selectors: [["fw-custom-input"]], inputs: { editing: "editing", required: "required", submitted: "submitted", referencia: "referencia", id: "id", label: "label" }, ngContentSelectors: _c2, decls: 5, vars: 5, consts: [[1, "form-group"], ["for", "asasas"], [4, "ngIf"], ["class", "form-text text-danger", 4, "ngIf"], [1, "form-text", "text-danger"], ["ref", ""]], template: function CustomInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "label", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, CustomInputComponent_div_3_Template, 3, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(4, CustomInputComponent_div_4_Template, 5, 1, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.editing && ctx.required ? "required" : "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: [ɵngcc3.NgIf], styles: [""] });
CustomInputComponent.ctorParameters = () => [
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: FwFormsConfig }
];
CustomInputComponent.propDecorators = {
    referencia: [{ type: Input }],
    editing: [{ type: Input }],
    id: [{ type: Input }],
    label: [{ type: Input }],
    submitted: [{ type: Input }],
    required: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomInputComponent, [{
        type: Component,
        args: [{
                selector: 'fw-custom-input',
                template: "<div class=\"form-group\">\r\n    <!--suppress XmlInvalidId -->\r\n    <label for=\"asasas\" [class]=\"editing && required? 'required': ''\">{{label}}</label>\r\n    <div *ngIf=\"editing\">\r\n\r\n        <ng-content></ng-content>\r\n\r\n        <div *ngIf=\"(referencia?.dirty || submitted) && referencia?.invalid\">\r\n            <small class=\"form-text text-danger\" *ngIf=\"referencia.errors.required\">\r\n                {{this.textRequired}}\r\n            </small>\r\n        </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"!editing\">\r\n        <span #ref><ng-content select=\"fw-value\"></ng-content></span>\r\n        <span *ngIf=\"!ref.innerHTML.trim()\">{{referencia || '-'}}</span>\r\n    </div>\r\n\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: FwFormsConfig }]; }, { editing: [{
            type: Input
        }], required: [{
            type: Input
        }], submitted: [{
            type: Input
        }], referencia: [{
            type: Input
        }], id: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();

function provideValueAccessor(type) {
    return {
        provide: NG_VALUE_ACCESSOR,
        useExisting: type,
        multi: true,
    };
}
function provideValidators(type) {
    return {
        provide: NG_VALIDATORS,
        useExisting: type,
        multi: true,
    };
}
class AbstractNgModelComponent extends RequiredValidator {
    constructor() {
        super(...arguments);
        this.cid = this.newGuid();
    }
    set value(value) {
        this._value = value;
        this.notifyValueChange();
    }
    get value() {
        return this._value;
    }
    notifyValueChange() {
        if (this.onChange) {
            this.onChange(this.value);
        }
    }
    writeValue(value) {
        if (this._value) {
            this._value = value;
            this.notifyValueChange();
        }
        else {
            this._value = value;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable-next-line:no-bitwise
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
AbstractNgModelComponent.ɵfac = function AbstractNgModelComponent_Factory(t) { return ɵAbstractNgModelComponent_BaseFactory(t || AbstractNgModelComponent); };
AbstractNgModelComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AbstractNgModelComponent, inputs: { cid: "cid", value: "value", disabled: "disabled" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
AbstractNgModelComponent.propDecorators = {
    cid: [{ type: Input }],
    disabled: [{ type: Input }],
    value: [{ type: Input }]
};
const ɵAbstractNgModelComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AbstractNgModelComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AbstractNgModelComponent, [{
        type: Directive
    }], null, { cid: [{
            type: Input
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class InputService {
    constructor() {
        this.submitted = false;
    }
}
InputService.ɵfac = function InputService_Factory(t) { return new (t || InputService)(); };
InputService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: InputService, factory: InputService.ɵfac });
InputService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const normalizeValidator = (validator) => {
    const func = validator.validate.bind(validator);
    if (typeof func === 'function') {
        return (c) => func(c);
    }
    else {
        return validator;
    }
};
const ɵ0 = normalizeValidator;
const composeValidators = (validators) => {
    if (validators == null || validators.length === 0) {
        return null;
    }
    return Validators.compose(validators.map(normalizeValidator));
};
const validate = (validators, asyncValidators) => {
    return (control) => {
        const synchronousValid = () => composeValidators(validators)(control);
        if (asyncValidators) {
            const asyncValidator = composeValidators(asyncValidators);
            return asyncValidator(control).map(v => {
                const secondary = synchronousValid();
                if (secondary || v) { // compose async and sync validator results
                    return Object.assign({}, secondary, v);
                }
            });
        }
        if (validators) {
            return of(synchronousValid());
        }
        return of(null);
    };
};

class AbstractInputComponent extends AbstractNgModelComponent {
    constructor(validators, asyncValidators, contextFormService, inputService, injector) {
        super();
        this.validators = validators;
        this.asyncValidators = asyncValidators;
        this.contextFormService = contextFormService;
        this.inputService = inputService;
        this.injector = injector;
        this.placeholder = '';
        this.type = 'text';
        this.editing = true;
        this.onBlur = new EventEmitter();
        this.onFocus = new EventEmitter();
    }
    ngOnInit() {
        if (this.contextFormService) {
            this.sub = this.contextFormService.state$.subscribe((context) => {
                this.editing = context.editing;
                this.submitted = context.submitted;
            });
        }
        this.input = this.injector.get(NgControl);
        this.input.name = this.cid;
        /* console.log(this.input.errors); // ¿Funciona=?*/
        this.inputService.input = this.input;
        this.inputService.submitted = this.submitted; // TODO debe captarse del formulario
        this.inputService.failures = this.failures;
        this.inputService.invalid = this.invalid;
    }
    ngOnChanges(changes) {
        if (changes['required'] != null) {
            this.required = changes['required'].currentValue !== null
                && (changes['required'].currentValue === true || changes['required'].currentValue === '');
        }
    }
    validate() {
        return validate(this.validators, this.asyncValidators)(this.input.control);
    }
    get invalid() {
        if (this.editing) {
            return this.validate().pipe(map(v => Object.keys(v || {}).length > 0));
        }
        else {
            return of(false);
        }
    }
    get failures() {
        if (this.editing) {
            return this.validate();
        }
        else {
            return of();
        }
    }
    get notOverridenErrors() {
        return this.failures.pipe(map(e => this.removeOverriden(e)));
    }
    removeOverriden(e) {
        const filtered = Object.keys(e)
            .filter(key => !this.overridenErrors.includes(key))
            .reduce((obj, key) => {
            return Object.assign(Object.assign({}, obj), { [key]: e[key] });
        }, {});
        return filtered;
    }
    setFailures(failures) {
        // FIXME chapuza terrible. Tenemos que encontrar la manera de setear como "errors" de angular
        this.inputService.failures = failures;
    }
    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
AbstractInputComponent.ɵfac = function AbstractInputComponent_Factory(t) { return new (t || AbstractInputComponent)(ɵngcc0.ɵɵdirectiveInject(undefined), ɵngcc0.ɵɵdirectiveInject(undefined), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(InputService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
AbstractInputComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AbstractInputComponent, inputs: { placeholder: "placeholder", type: "type", editing: "editing", submitted: "submitted", label: "label", autoFocus: "autoFocus" }, outputs: { onBlur: "onBlur", onFocus: "onFocus" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature] });
AbstractInputComponent.ctorParameters = () => [
    { type: undefined },
    { type: undefined },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService },
    { type: Injector }
];
AbstractInputComponent.propDecorators = {
    placeholder: [{ type: Input }],
    type: [{ type: Input }],
    editing: [{ type: Input }],
    label: [{ type: Input }],
    submitted: [{ type: Input }],
    autoFocus: [{ type: Input }],
    onBlur: [{ type: Output }],
    onFocus: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AbstractInputComponent, [{
        type: Directive
    }], function () { return [{ type: undefined }, { type: undefined }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: InputService }, { type: ɵngcc0.Injector }]; }, { placeholder: [{
            type: Input
        }], type: [{
            type: Input
        }], editing: [{
            type: Input
        }], onBlur: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], submitted: [{
            type: Input
        }], label: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }] }); })();

class ErrorComponent {
    constructor(inputService) {
        this.inputService = inputService;
    }
    getErrors(failures) {
        return failures.pipe(filter(v => v != null), map(v => Object.keys(v)));
    }
}
ErrorComponent.ɵfac = function ErrorComponent_Factory(t) { return new (t || ErrorComponent)(ɵngcc0.ɵɵdirectiveInject(InputService)); };
ErrorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ErrorComponent, selectors: [["fw-error"]], inputs: { value: "value" }, ngContentSelectors: _c3, decls: 2, vars: 3, consts: [["class", "form-text text-danger", 4, "ngFor", "ngForOf"], [1, "form-text", "text-danger"], [4, "ngIf"]], template: function ErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, ErrorComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.getErrors(ctx.inputService.failures)));
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgIf], pipes: [ɵngcc3.AsyncPipe], styles: [""] });
ErrorComponent.ctorParameters = () => [
    { type: InputService }
];
ErrorComponent.propDecorators = {
    value: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorComponent, [{
        type: Component,
        args: [{
                selector: 'fw-error',
                template: "<div class=\"form-text text-danger\"  *ngFor=\"let error of getErrors(inputService.failures) | async\">\r\n    <small *ngIf=\"error == value\">\r\n        <ng-content></ng-content>\r\n    </small>\r\n</div>\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: InputService }]; }, { value: [{
            type: Input
        }] }); })();

class BooleanComponent extends AbstractInputComponent {
    constructor(required, injector, validators, asyncValidators, contextoFormService, inputService, formsConfig) {
        super(validators, asyncValidators, contextoFormService, inputService, injector);
        this.formsConfig = formsConfig;
    }
    ngAfterContentInit() {
        if (this.contentChildren) {
            this.overridenErrors = this.contentChildren.map(error => error.value);
        }
        else {
            this.overridenErrors = [];
        }
    }
}
BooleanComponent.ɵfac = function BooleanComponent_Factory(t) { return new (t || BooleanComponent)(ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(InputService), ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
BooleanComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BooleanComponent, selectors: [["fw-boolean"]], contentQueries: function BooleanComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ErrorComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildren = _t);
    } }, viewQuery: function BooleanComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgModel, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.model = _t.first);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            provideValueAccessor(BooleanComponent),
            InputService
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c5, decls: 8, vars: 3, consts: [[1, "form-group"], ["ref", ""], [3, "for", "class", 4, "ngIf"], ["type", "checkbox", 3, "id", "name", "disabled", "ngModel", "ngModelChange", 4, "ngIf"], [4, "ngIf"], [3, "for"], ["type", "checkbox", 3, "id", "name", "disabled", "ngModel", "ngModelChange"]], template: function BooleanComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c4);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, BooleanComponent_label_4_Template, 2, 4, "label", 2);
        ɵngcc0.ɵɵelementStart(5, "div");
        ɵngcc0.ɵɵtemplate(6, BooleanComponent_input_6_Template, 1, 4, "input", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, BooleanComponent_div_7_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label && !_r0.innerHTML.trim());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: [ɵngcc3.NgIf, ɵngcc6.CheckboxControlValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel], styles: [""] });
BooleanComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService },
    { type: FwFormsConfig }
];
BooleanComponent.propDecorators = {
    model: [{ type: ViewChild, args: [NgModel, { static: true },] }],
    contentChildren: [{ type: ContentChildren, args: [ErrorComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BooleanComponent, [{
        type: Component,
        args: [{
                selector: 'fw-boolean',
                template: "<div class=\"form-group\">\r\n    <div #ref>\r\n        <ng-content select=\"fw-label\"></ng-content>\r\n    </div>\r\n    <label *ngIf=\"label && !ref.innerHTML.trim()\" for=\"{{cid}}\" [class]=\"editing && required? 'required': ''\">\r\n        {{label}}\r\n    </label>\r\n\r\n    <div>\r\n        <input *ngIf=\"editing\" type=\"checkbox\" id=\"{{cid}}\" name=\"{{cid}}\" [disabled]=\"disabled\" [(ngModel)]=\"value\">\r\n    </div>\r\n    <div *ngIf=\"!editing\">{{value ? (formsConfig.i18n.booleanYes || 'Yes') : (formsConfig.i18n.booleanNo || 'No')}}</div>\r\n</div>\r\n",
                providers: [
                    provideValueAccessor(BooleanComponent),
                    InputService
                ],
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: InputService }, { type: FwFormsConfig }]; }, { model: [{
            type: ViewChild,
            args: [NgModel, { static: true }]
        }], contentChildren: [{
            type: ContentChildren,
            args: [ErrorComponent]
        }] }); })();

class TextareaComponent extends AbstractInputComponent {
    constructor(required, injector, validators, asyncValidators, contextoFormService, inputService) {
        super(validators, asyncValidators, contextoFormService, inputService, injector);
        this.contextoFormService = contextoFormService;
    }
    ngAfterContentInit() {
        if (!this.rows) {
            this.rows = 0;
        }
        if (this.contentChildren) {
            this.overridenErrors = this.contentChildren.map(error => error.value);
        }
        else {
            this.overridenErrors = [];
        }
    }
}
TextareaComponent.ɵfac = function TextareaComponent_Factory(t) { return new (t || TextareaComponent)(ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(InputService)); };
TextareaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TextareaComponent, selectors: [["fw-textarea"]], contentQueries: function TextareaComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ErrorComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildren = _t);
    } }, viewQuery: function TextareaComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, inputs: { rows: "rows", minLength: "minLength", maxLength: "maxLength" }, features: [ɵngcc0.ɵɵProvidersFeature([
            provideValueAccessor(TextareaComponent),
            InputService
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c8, decls: 7, vars: 3, consts: [[1, "form-group"], ["ref", ""], [3, "for", "class", 4, "ngIf"], [4, "ngIf"], [3, "for"], [1, "form-control", 3, "rows", "id", "name", "placeholder", "ngModel", "fwAutofocus", "disabled", "ngModelChange"], ["inputElement", ""], [3, "errores", 4, "ngIf"], [3, "errores"]], template: function TextareaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, TextareaComponent_label_4_Template, 2, 4, "label", 2);
        ɵngcc0.ɵɵtemplate(5, TextareaComponent_div_5_Template, 5, 16, "div", 3);
        ɵngcc0.ɵɵtemplate(6, TextareaComponent_div_6_Template, 5, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label && !_r0.innerHTML.trim());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, AutofocusDirective, ValidationComponent]; }, pipes: function () { return [ɵngcc3.AsyncPipe]; }, styles: ["span[_ngcontent-%COMP%]{white-space:pre-wrap}"] });
TextareaComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService }
];
TextareaComponent.propDecorators = {
    inputElement: [{ type: ViewChild, args: ['inputElement', { static: true },] }],
    contentChildren: [{ type: ContentChildren, args: [ErrorComponent,] }],
    minLength: [{ type: Input }],
    maxLength: [{ type: Input }],
    rows: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaComponent, [{
        type: Component,
        args: [{
                selector: 'fw-textarea',
                template: "<div class=\"form-group\">\r\n    <div #ref>\r\n        <ng-content select=\"fw-label\"></ng-content>\r\n    </div>\r\n    <label *ngIf=\"label && !ref.innerHTML.trim()\" for=\"{{cid}}\"\r\n           [class]=\"editing && required? 'required': ''\">{{label}}</label>\r\n    <div *ngIf=\"editing\">\r\n        <textarea rows=\"{{rows}}\" id=\"{{cid}}\" class=\"form-control\" name=\"{{cid}}\" placeholder=\"{{placeholder}}\"\r\n                  [class.ng-invalid]=\"input.control.invalid\"\r\n                  [class.ng-dirty]=\"input.control.dirty\" [class.ng-touched]=\"input.control.touched\"\r\n                  [class.ng-valid]=\"input.control.valid\"\r\n                  #inputElement\r\n                  [(ngModel)]=\"value\" [fwAutofocus]=\"autoFocus\" [disabled]=\"disabled\"> </textarea>\r\n        <ng-container\r\n                *ngIf=\"((submitted === null || submitted === undefined) && contextoFormService && contextoFormService.state.submitted) || input.dirty || submitted\">\r\n            <fw-validation *ngIf=\"invalid | async\" [errores]=\"notOverridenErrors\">\r\n            </fw-validation>\r\n            <div *ngIf=\"invalid | async\">\r\n                <ng-content></ng-content>\r\n                {{setFailures(failures)}} </div>\r\n        </ng-container>\r\n    </div>\r\n    <div *ngIf=\"!editing\">\r\n        <span #ref><ng-content select=\"fw-value\"></ng-content></span>\r\n        <span *ngIf=\"!ref.innerHTML.trim()\">{{value || '-'}}</span>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    provideValueAccessor(TextareaComponent),
                    InputService
                ],
                styles: ["span{white-space:pre-wrap}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: InputService }]; }, { rows: [{
            type: Input
        }], inputElement: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }], contentChildren: [{
            type: ContentChildren,
            args: [ErrorComponent]
        }], minLength: [{
            type: Input
        }], maxLength: [{
            type: Input
        }] }); })();

class FormEditComponent {
    constructor(contextService, config) {
        this.contextService = contextService;
        this.config = config;
        this.label = this.config.i18n.edit || 'Edit';
    }
    ngOnInit() {
    }
    editar() {
        if (this.contextService) {
            this.contextService.state.edit();
        }
    }
}
FormEditComponent.ɵfac = function FormEditComponent_Factory(t) { return new (t || FormEditComponent)(ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
FormEditComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormEditComponent, selectors: [["fw-form-update"]], inputs: { label: "label" }, decls: 3, vars: 1, consts: [["type", "button", 1, "btn", "btn-primary", "boton-editar", 3, "click"]], template: function FormEditComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function FormEditComponent_Template_button_click_0_listener() { return ctx.editar(); });
        ɵngcc0.ɵɵelementStart(1, "span");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
    } }, styles: [""] });
FormEditComponent.ctorParameters = () => [
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: FwFormsConfig }
];
FormEditComponent.propDecorators = {
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormEditComponent, [{
        type: Component,
        args: [{
                selector: 'fw-form-update',
                template: "<button type=\"button\" class=\"btn btn-primary boton-editar\" (click)=\"editar()\">\r\n    <span>{{label}}</span>\r\n</button>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: FwFormsConfig }]; }, { label: [{
            type: Input
        }] }); })();

class FormHeaderButtonsComponent {
    constructor(contextService) {
        this.contextService = contextService;
    }
    ngOnInit() {
    }
}
FormHeaderButtonsComponent.ɵfac = function FormHeaderButtonsComponent_Factory(t) { return new (t || FormHeaderButtonsComponent)(ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8)); };
FormHeaderButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormHeaderButtonsComponent, selectors: [["fw-form-header-buttons"]], inputs: { editing: "editing" }, ngContentSelectors: _c3, decls: 1, vars: 1, consts: [["class", "botones text-left text-sm-right", 4, "ngIf"], [1, "botones", "text-left", "text-sm-right"]], template: function FormHeaderButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, FormHeaderButtonsComponent_div_0_Template, 2, 0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing === false || ctx.editing === undefined && ctx.contextService && ctx.contextService.state && !ctx.contextService.state.editing);
    } }, directives: [ɵngcc3.NgIf], styles: ["[_nghost-%COMP%]{display:block}"] });
FormHeaderButtonsComponent.ctorParameters = () => [
    { type: ContextFormService, decorators: [{ type: Optional }] }
];
FormHeaderButtonsComponent.propDecorators = {
    editing: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormHeaderButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'fw-form-header-buttons',
                template: "<div class=\"botones text-left text-sm-right\"\r\n     *ngIf=\"editing === false\r\n     || (editing === undefined && contextService && contextService.state && !contextService.state.editing)\">\r\n    <ng-content></ng-content>\r\n</div>\r\n",
                styles: [":host{display:block}"]
            }]
    }], function () { return [{ type: ContextFormService, decorators: [{
                type: Optional
            }] }]; }, { editing: [{
            type: Input
        }] }); })();

class FormSaveComponent {
    constructor(contextFormService, config) {
        this.contextFormService = contextFormService;
        this.config = config;
        this.label = this.config.i18n.save || 'Save';
    }
    ngOnInit() {
    }
}
FormSaveComponent.ɵfac = function FormSaveComponent_Factory(t) { return new (t || FormSaveComponent)(ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
FormSaveComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormSaveComponent, selectors: [["fw-form-save"]], inputs: { label: "label", disabled: "disabled", sending: "sending" }, decls: 6, vars: 4, consts: [["type", "submit", 1, "btn", "btn-primary", 3, "disabled"], ["class", "fa fa-save", 4, "ngIf"], ["class", "fa fa-spinner fa-spin", 4, "ngIf"], [1, "fa", "fa-save"], [1, "fa", "fa-spinner", "fa-spin"]], template: function FormSaveComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵtemplate(1, FormSaveComponent_span_1_Template, 1, 0, "span", 1);
        ɵngcc0.ɵɵtemplate(2, FormSaveComponent_span_2_Template, 1, 0, "span", 2);
        ɵngcc0.ɵɵtext(3, "\u00A0 ");
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled || ctx.sending || (ctx.contextFormService == null ? null : ctx.contextFormService.state == null ? null : ctx.contextFormService.state.sending) && ctx.sending === undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.sending && !((ctx.contextFormService == null ? null : ctx.contextFormService.state == null ? null : ctx.contextFormService.state.sending) && ctx.sending === undefined));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sending || (ctx.contextFormService == null ? null : ctx.contextFormService.state == null ? null : ctx.contextFormService.state.sending) && ctx.sending === undefined);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
    } }, directives: [ɵngcc3.NgIf], styles: ["button[_ngcontent-%COMP%]{margin-right:5px}"] });
FormSaveComponent.ctorParameters = () => [
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: FwFormsConfig }
];
FormSaveComponent.propDecorators = {
    disabled: [{ type: Input }],
    sending: [{ type: Input }],
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormSaveComponent, [{
        type: Component,
        args: [{
                selector: 'fw-form-save',
                template: "<button type=\"submit\"\r\n        [disabled]=\"disabled || sending || (contextFormService?.state?.sending && sending === undefined)\"\r\n        class=\"btn btn-primary\">\r\n    <span class=\"fa fa-save\"\r\n          *ngIf=\"!sending && !(contextFormService?.state?.sending && sending === undefined)\">\r\n    </span>\r\n    <span class=\"fa fa-spinner fa-spin\"\r\n          *ngIf=\"sending || (contextFormService?.state?.sending && sending === undefined)\">\r\n    </span>&nbsp;\r\n    <span>{{label}}</span>\r\n</button>\r\n",
                styles: ["button{margin-right:5px}"]
            }]
    }], function () { return [{ type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: FwFormsConfig }]; }, { label: [{
            type: Input
        }], disabled: [{
            type: Input
        }], sending: [{
            type: Input
        }] }); })();

class FormCancelComponent {
    constructor(contextService, config) {
        this.contextService = contextService;
        this.config = config;
        this.label = this.config.i18n.cancel || 'Cancel';
    }
    ngOnInit() {
    }
    cancel() {
        if (this.contextService) {
            this.contextService.state.cancel();
        }
    }
}
FormCancelComponent.ɵfac = function FormCancelComponent_Factory(t) { return new (t || FormCancelComponent)(ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
FormCancelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormCancelComponent, selectors: [["fw-form-cancel"]], inputs: { label: "label" }, decls: 3, vars: 1, consts: [["type", "button", 1, "btn", "btn-secondary", 3, "click"], [1, "fa", "fa-ban"]], template: function FormCancelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function FormCancelComponent_Template_button_click_0_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("\u00A0", ctx.label, "\n");
    } }, styles: [""] });
FormCancelComponent.ctorParameters = () => [
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: FwFormsConfig }
];
FormCancelComponent.propDecorators = {
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormCancelComponent, [{
        type: Component,
        args: [{
                selector: 'fw-form-cancel',
                template: "<button type=\"button\" class=\"btn btn-secondary\" (click)=\"cancel()\">\r\n    <span class=\"fa fa-ban\"></span>&nbsp;{{label}}\r\n</button>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: FwFormsConfig }]; }, { label: [{
            type: Input
        }] }); })();

class FormFooterButtonsComponent {
    constructor(contextService) {
        this.contextService = contextService;
    }
    ngOnInit() {
    }
}
FormFooterButtonsComponent.ɵfac = function FormFooterButtonsComponent_Factory(t) { return new (t || FormFooterButtonsComponent)(ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8)); };
FormFooterButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormFooterButtonsComponent, selectors: [["fw-form-update-buttons"]], inputs: { editing: "editing" }, ngContentSelectors: _c3, decls: 1, vars: 1, consts: [["class", "col-12", 4, "ngIf"], [1, "col-12"]], template: function FormFooterButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, FormFooterButtonsComponent_div_0_Template, 2, 0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing === true || ctx.editing === undefined && ctx.contextService && ctx.contextService.state && ctx.contextService.state.editing);
    } }, directives: [ɵngcc3.NgIf], styles: ["[_nghost-%COMP%]{display:block;flex:0 0 100%;max-width:100%}"] });
FormFooterButtonsComponent.ctorParameters = () => [
    { type: ContextFormService, decorators: [{ type: Optional }] }
];
FormFooterButtonsComponent.propDecorators = {
    editing: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormFooterButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'fw-form-update-buttons',
                template: "<div class=\"col-12\"\r\n     *ngIf=\"editing === true|| (editing === undefined && contextService\r\n     && contextService.state && contextService.state.editing)\">\r\n    <ng-content></ng-content>\r\n</div>\r\n\r\n",
                styles: [":host{display:block;flex:0 0 100%;max-width:100%}"]
            }]
    }], function () { return [{ type: ContextFormService, decorators: [{
                type: Optional
            }] }]; }, { editing: [{
            type: Input
        }] }); })();

class FormComponent {
    constructor(contextFormService) {
        this.contextFormService = contextFormService;
        this.fwSubmit = new EventEmitter();
    }
    ngAfterViewInit() {
        const ngContentModels = this.models.toArray();
        ngContentModels.forEach(model => {
            this.ngForm.addControl(model);
        });
    }
    save(editForm) {
        this.fwSubmit.emit(editForm);
        if (this.contextFormService != null && !this.manualSubmit) {
            this.contextFormService.state.save(editForm);
        }
    }
}
FormComponent.ɵfac = function FormComponent_Factory(t) { return new (t || FormComponent)(ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8)); };
FormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormComponent, selectors: [["fw-form"]], contentQueries: function FormComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgModel, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.models = _t);
    } }, viewQuery: function FormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngForm = _t.first);
    } }, inputs: { submitted: "submitted", manualSubmit: "manualSubmit" }, outputs: { fwSubmit: "fwSubmit" }, ngContentSelectors: _c3, decls: 3, vars: 1, consts: [["name", "editForm", "role", "form", "novalidate", "", 3, "className", "ngSubmit"], ["editForm", "ngForm"]], template: function FormComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "form", 0, 1);
        ɵngcc0.ɵɵlistener("ngSubmit", function FormComponent_Template_form_ngSubmit_0_listener() { ɵngcc0.ɵɵrestoreView(_r1); const _r0 = ɵngcc0.ɵɵreference(1); return ctx.save(_r0); });
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵproperty("className", ctx.submitted || ctx.submitted === undefined && _r0.submitted ? "ng-submitted" : "");
    } }, directives: [ɵngcc6.ɵangular_packages_forms_forms_ba, ɵngcc6.NgControlStatusGroup, ɵngcc6.NgForm], styles: [""] });
FormComponent.ctorParameters = () => [
    { type: ContextFormService, decorators: [{ type: Optional }] }
];
FormComponent.propDecorators = {
    models: [{ type: ContentChildren, args: [NgModel, { descendants: true },] }],
    fwSubmit: [{ type: Output }],
    submitted: [{ type: Input }],
    manualSubmit: [{ type: Input }],
    ngForm: [{ type: ViewChild, args: ['editForm', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormComponent, [{
        type: Component,
        args: [{
                selector: 'fw-form',
                template: "<form name=\"editForm\" role=\"form\" novalidate [className]=\"submitted || (submitted === undefined && editForm.submitted) ? 'ng-submitted' : ''\"\r\n      (ngSubmit)=\"save(editForm)\" #editForm=\"ngForm\">\r\n    <ng-content></ng-content>\r\n</form>\r\n\r\n\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ContextFormService, decorators: [{
                type: Optional
            }] }]; }, { fwSubmit: [{
            type: Output
        }], models: [{
            type: ContentChildren,
            args: [NgModel, { descendants: true }]
        }], submitted: [{
            type: Input
        }], manualSubmit: [{
            type: Input
        }], ngForm: [{
            type: ViewChild,
            args: ['editForm', { static: true }]
        }] }); })();

class FormWrapperComponent {
    constructor(contextFormService) {
        this.contextFormService = contextFormService;
    }
    set context(value) {
        this._context = value;
        this.contextFormService.setState(value);
    }
    get contexto() {
        return this._context;
    }
    ngOnInit() {
    }
}
FormWrapperComponent.ɵfac = function FormWrapperComponent_Factory(t) { return new (t || FormWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(ContextFormService)); };
FormWrapperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormWrapperComponent, selectors: [["fw-form-wrapper"]], inputs: { context: "context" }, features: [ɵngcc0.ɵɵProvidersFeature([ContextFormService])], ngContentSelectors: _c3, decls: 1, vars: 0, template: function FormWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:block}"] });
FormWrapperComponent.ctorParameters = () => [
    { type: ContextFormService }
];
FormWrapperComponent.propDecorators = {
    context: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'fw-form-wrapper',
                template: "<ng-content></ng-content>\r\n\r\n",
                providers: [ContextFormService],
                styles: [":host{display:block}"]
            }]
    }], function () { return [{ type: ContextFormService }]; }, { context: [{
            type: Input
        }] }); })();

class LabelComponent {
    constructor() { }
    ngOnInit() {
    }
}
LabelComponent.ɵfac = function LabelComponent_Factory(t) { return new (t || LabelComponent)(); };
LabelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LabelComponent, selectors: [["fw-label"]], ngContentSelectors: _c3, decls: 1, vars: 0, template: function LabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
LabelComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LabelComponent, [{
        type: Component,
        args: [{
                selector: 'fw-label',
                template: "<ng-content></ng-content>\r\n"
            }]
    }], function () { return []; }, null); })();

class SelectComponent extends AbstractInputComponent {
    /* @Input()
     trackByFn: (o: any) => any;*/
    constructor(required, injector, validators, asyncValidators, contextoFormService, inputService, config) {
        super(validators, asyncValidators, contextoFormService, inputService, injector);
        this.config = config;
        this.compareWith = this.compareById;
        this.placeholder = this.config.i18n.selectAllOptions || '-- All options --';
        this.valueFn = (o) => o;
        this.labelFn = o => o['label'] || o.toString();
        this.keepOrder = e => 1;
        this.required = required !== null; // Si ponemos "required" el valor es undefined.
    }
    ngAfterContentInit() {
        if (this.contentChildren) {
            this.overridenErrors = this.contentChildren.map(error => error.value);
        }
        else {
            this.overridenErrors = [];
        }
    }
    /** Compara por id, útil para mantener el estado en los select */
    compareById(item1, item2) {
        return item1 && item2 && (item1 === item2 || item1.id === item2.id);
    }
    // Sin este fix, al seleccionar el placeholder angular setea la cadena 'undefined'
    selectItem($event) {
        if ($event === 'undefined') {
            this.value = undefined;
        }
    }
}
SelectComponent.ɵfac = function SelectComponent_Factory(t) { return new (t || SelectComponent)(ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(InputService), ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
SelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SelectComponent, selectors: [["fw-select"]], contentQueries: function SelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ErrorComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildren = _t);
    } }, viewQuery: function SelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgModel, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { compareWith: "compareWith", placeholder: "placeholder", valueFn: "valueFn", labelFn: "labelFn", multiple: "multiple", options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([
            provideValueAccessor(SelectComponent),
            InputService
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c8, decls: 7, vars: 3, consts: [[1, "form-group"], ["ref", ""], [3, "for", "class", 4, "ngIf"], [4, "ngIf"], [3, "for"], ["class", "form-control", 3, "id", "name", "disabled", "ngModel", "compareWith", "ng-invalid", "ng-dirty", "ng-touched", "ng-valid", "fwAutofocus", "ngModelChange", 4, "ngIf"], ["class", "form-control", "multiple", "", 3, "id", "name", "disabled", "ngModel", "ng-invalid", "ng-dirty", "ng-touched", "ng-valid", "ngModelChange", 4, "ngIf"], [1, "form-control", 3, "id", "name", "disabled", "ngModel", "compareWith", "fwAutofocus", "ngModelChange"], [3, "value", 4, "ngIf"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "value"], [3, "ngValue"], ["multiple", "", 1, "form-control", 3, "id", "name", "disabled", "ngModel", "ngModelChange"], [3, "errores", 4, "ngIf"], [3, "errores"]], template: function SelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, SelectComponent_label_4_Template, 2, 4, "label", 2);
        ɵngcc0.ɵɵtemplate(5, SelectComponent_div_5_Template, 4, 3, "div", 3);
        ɵngcc0.ɵɵtemplate(6, SelectComponent_div_6_Template, 5, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label && !_r0.innerHTML.trim());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc6.SelectControlValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, AutofocusDirective, ɵngcc3.NgForOf, ɵngcc6.NgSelectOption, ɵngcc6.ɵangular_packages_forms_forms_z, ɵngcc6.SelectMultipleControlValueAccessor, ValidationComponent]; }, pipes: function () { return [ɵngcc3.AsyncPipe, ɵngcc3.JsonPipe]; }, styles: [""] });
SelectComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService },
    { type: FwFormsConfig }
];
SelectComponent.propDecorators = {
    compareWith: [{ type: Input }],
    placeholder: [{ type: Input }],
    multiple: [{ type: Input }],
    input: [{ type: ViewChild, args: [NgModel, { static: true },] }],
    contentChildren: [{ type: ContentChildren, args: [ErrorComponent,] }],
    options: [{ type: Input }],
    valueFn: [{ type: Input }],
    labelFn: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectComponent, [{
        type: Component,
        args: [{
                selector: 'fw-select',
                template: "<div class=\"form-group\">\r\n    <div #ref>\r\n        <ng-content select=\"fw-label\"></ng-content>\r\n    </div>\r\n    <label *ngIf=\"label && !ref.innerHTML.trim()\" for=\"{{cid}}\" [class]=\"editing && required? 'required': ''\">\r\n        {{label}}\r\n    </label>\r\n\r\n    <div *ngIf=\"editing\">\r\n        <select id=\"{{cid}}\" class=\"form-control\" name=\"{{cid}}\" *ngIf=\"!multiple\" [disabled]=\"disabled\"\r\n                [(ngModel)]=\"value\" [compareWith]=\"compareWith\" (ngModelChange)=\"selectItem($event)\"\r\n                [class.ng-invalid]=\"input.control.invalid\"\r\n                [class.ng-dirty]=\"input.control.dirty\" [class.ng-touched]=\"input.control.touched\"\r\n                [class.ng-valid]=\"input.control.valid\" [fwAutofocus]=\"autoFocus\">\r\n            <option [value]=\"undefined\" *ngIf=\"!required\">{{placeholder}}</option>\r\n            <option *ngFor=\"let opcion of options\" [ngValue]=\"this.valueFn(opcion)\">{{this.labelFn(opcion)}}</option>\r\n        </select>\r\n\r\n        <select id=\"{{cid}}\" class=\"form-control\" name=\"{{cid}}\" *ngIf=\"multiple\" multiple [disabled]=\"disabled\"\r\n                [(ngModel)]=\"value\" [class.ng-invalid]=\"input.control.invalid\" (ngModelChange)=\"selectItem($event)\"\r\n                [class.ng-dirty]=\"input.control.dirty\" [class.ng-touched]=\"input.control.touched\"\r\n                [class.ng-valid]=\"input.control.valid\">\r\n            <option [value]=\"undefined\" *ngIf=\"!required\">{{placeholder}}</option>\r\n            <option *ngFor=\"let opcion of options\" [ngValue]=\"this.valueFn(opcion)\">{{this.labelFn(opcion)}}</option>\r\n        </select>\r\n\r\n        <ng-container *ngIf=\"(contextFormService && contextFormService.state.submitted) || input.dirty\">\r\n\r\n            <fw-validation *ngIf=\"invalid | async\" [errores]=\"notOverridenErrors\">\r\n            </fw-validation>\r\n            <div *ngIf=\"invalid | async\">\r\n                <ng-content></ng-content>\r\n                {{setFailures(failures)}} </div>\r\n        </ng-container>\r\n    </div>\r\n\r\n    <div *ngIf=\"!editing\">\r\n        <span #ref><ng-content select=\"fw-value\"></ng-content></span>\r\n        <!--If a fw-value is provided we wont show '-' even if the value is null, same behaviour as fw-text, fw-number...-->\r\n        <p *ngIf=\"!ref.innerHTML.trim()\">{{ value != null ? (value['label'] || (value | json)) : '-'}}</p>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    provideValueAccessor(SelectComponent),
                    InputService
                ],
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: InputService }, { type: FwFormsConfig }]; }, { compareWith: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], valueFn: [{
            type: Input
        }], labelFn: [{
            type: Input
        }], multiple: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: [NgModel, { static: true }]
        }], contentChildren: [{
            type: ContentChildren,
            args: [ErrorComponent]
        }], options: [{
            type: Input
        }] }); })();

class DebounceDirective {
    constructor(elementRef, model) {
        this.elementRef = elementRef;
        this.model = model;
        this.delay = 200;
    }
    ngOnInit() {
        const eventStream = fromEvent(this.elementRef.nativeElement, 'keyup').pipe(map(() => {
            return this.model.value;
        }), debounceTime(this.delay));
        this.model.viewToModelUpdate = () => {
        };
        eventStream.subscribe(input => {
            this.model.viewModel = input;
            this.model.update.emit(input);
        });
    }
}
DebounceDirective.ɵfac = function DebounceDirective_Factory(t) { return new (t || DebounceDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.NgModel)); };
DebounceDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DebounceDirective, selectors: [["", "ngModel", "", "fwDebounce", ""]], inputs: { delay: "delay" } });
DebounceDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgModel }
];
DebounceDirective.propDecorators = {
    delay: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DebounceDirective, [{
        type: Directive,
        args: [{
                selector: '[ngModel][fwDebounce]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc6.NgModel }]; }, { delay: [{
            type: Input
        }] }); })();

class ValidationComponent {
    constructor(config) {
        this.config = config;
        this.message = (validator, key) => {
            switch (key) {
                case 'required':
                    return [key, this.config.i18n.validationRequired || 'Required field'];
                case 'pattern':
                    return [key, this.config.i18n.validationInvalidPattern || 'Invalid pattern'];
                case 'minlength':
                    return [key, (this.config.i18n.validationMinLength1 || 'Length must be at least ') +
                            validator.minlength['requiredLength'] + (this.config.i18n.validationMinLength2 || ' characters')];
                case 'maxlength':
                    return [key, (this.config.i18n.validationMaxLength1 || 'Maximum ') +
                            validator.maxlength['requiredLength'] + (this.config.i18n.validationMaxLength2 || ' characters')];
                case 'validateMaxlengthHtml':
                    return [key, (this.config.i18n.validationMaxLength1 || 'Maximum ') +
                            validator.validateMaxlengthHtml['requiredLength'] + (this.config.i18n.validationMaxLength2 || ' characters')];
                case 'email':
                    return [key, this.config.i18n.validationEmail || 'Invalid email'];
            }
            switch (typeof validator[key]) {
                case 'string':
                    return [key, validator[key]];
                default:
                    return [key, (this.config.i18n.validationDefault || 'Validation error: ') + `${key}`];
            }
        };
    }
    getMensajes(errores) {
        return errores.pipe(map(v => Object.keys(v).map(k => this.message(v, k))));
    }
}
ValidationComponent.ɵfac = function ValidationComponent_Factory(t) { return new (t || ValidationComponent)(ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
ValidationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ValidationComponent, selectors: [["fw-validation"]], inputs: { errores: "errores" }, decls: 3, vars: 3, consts: [[1, "validation"], ["class", "form-text text-danger", 4, "ngFor", "ngForOf"], [1, "form-text", "text-danger"]], template: function ValidationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ValidationComponent_small_1_Template, 2, 1, "small", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx.getMensajes(ctx.errores)));
    } }, directives: [ɵngcc3.NgForOf], pipes: [ɵngcc3.AsyncPipe], encapsulation: 2 });
ValidationComponent.ctorParameters = () => [
    { type: FwFormsConfig }
];
ValidationComponent.propDecorators = {
    errores: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidationComponent, [{
        type: Component,
        args: [{
                selector: 'fw-validation',
                template: `
        <div class="validation">
            <small class="form-text text-danger" *ngFor="let message of getMensajes(errores) | async">{{message[1]}}</small>
        </div>
    `
            }]
    }], function () { return [{ type: FwFormsConfig }]; }, { errores: [{
            type: Input
        }] }); })();

class TextComponent extends AbstractInputComponent {
    constructor(required, maxlength, injector, validators, asyncValidators, contextoFormService, inputService) {
        super(validators, asyncValidators, contextoFormService, inputService, injector);
        this.contextoFormService = contextoFormService;
        this.type = 'text';
        this.required = required !== null; // Si ponemos "required" el valor es undefined.
        this.maxlength = maxlength;
    }
    ngAfterContentInit() {
        if (this.contentChildren) {
            this.overridenErrors = this.contentChildren.map(error => error.value);
        }
        else {
            this.overridenErrors = [];
        }
    }
    propagateValue($event) {
        this.value = $event.target.value;
    }
}
TextComponent.ɵfac = function TextComponent_Factory(t) { return new (t || TextComponent)(ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵinjectAttribute('maxlength'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(InputService)); };
TextComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TextComponent, selectors: [["fw-text"]], contentQueries: function TextComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ErrorComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildren = _t);
    } }, viewQuery: function TextComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, inputs: { type: "type" }, features: [ɵngcc0.ɵɵProvidersFeature([
            provideValueAccessor(TextComponent),
            InputService
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c8, decls: 10, vars: 20, consts: [[1, "form-group"], ["ref", ""], [3, "for", "class", 4, "ngIf"], [3, "hidden"], [1, "form-control", 3, "id", "type", "name", "placeholder", "disabled", "value", "fwAutofocus", "change", "keyup"], ["inputElement", ""], [4, "ngIf"], [3, "for"], [3, "errores", 4, "ngIf"], [3, "errores"]], template: function TextComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, TextComponent_label_4_Template, 2, 4, "label", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "input", 4, 5);
        ɵngcc0.ɵɵlistener("change", function TextComponent_Template_input_change_6_listener($event) { return ctx.propagateValue($event); })("keyup", function TextComponent_Template_input_keyup_6_listener($event) { return ctx.propagateValue($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, TextComponent_ng_container_8_Template, 5, 6, "ng-container", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, TextComponent_div_9_Template, 5, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label && !_r0.innerHTML.trim());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("ng-invalid", ctx.input.control.invalid)("ng-dirty", ctx.input.control.dirty)("ng-touched", ctx.input.control.touched)("ng-valid", ctx.input.control.valid);
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.cid);
        ɵngcc0.ɵɵpropertyInterpolate("type", ctx.type);
        ɵngcc0.ɵɵpropertyInterpolate("name", ctx.cid);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("value", ctx.value || "")("fwAutofocus", ctx.autoFocus);
        ɵngcc0.ɵɵattribute("maxlength", ctx.maxlength);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.submitted === null || ctx.submitted === undefined) && ctx.contextoFormService && ctx.contextoFormService.state.submitted || ctx.input.dirty || ctx.submitted);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: function () { return [ɵngcc3.NgIf, AutofocusDirective, ValidationComponent]; }, pipes: function () { return [ɵngcc3.AsyncPipe]; }, encapsulation: 2 });
TextComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: undefined, decorators: [{ type: Attribute, args: ['maxlength',] }] },
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService }
];
TextComponent.propDecorators = {
    inputElement: [{ type: ViewChild, args: ['inputElement', { static: true },] }],
    type: [{ type: Input }],
    contentChildren: [{ type: ContentChildren, args: [ErrorComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextComponent, [{
        type: Component,
        args: [{
                selector: 'fw-text',
                template: "<div class=\"form-group\">\r\n    <div #ref>\r\n        <ng-content select=\"fw-label\"></ng-content>\r\n    </div>\r\n    <label *ngIf=\"label && !ref.innerHTML.trim()\" for=\"{{cid}}\" [class]=\"editing && required ? 'required': ''\">\r\n        {{label}}\r\n    </label>\r\n    <div [hidden]=\"!editing\">\r\n        <input id=\"{{cid}}\" type=\"{{type}}\" [attr.maxlength]=\"maxlength\" class=\"form-control\" name=\"{{cid}}\"\r\n               placeholder=\"{{placeholder}}\" [disabled]=\"disabled\"\r\n               [class.ng-invalid]=\"input.control.invalid\"\r\n               [class.ng-dirty]=\"input.control.dirty\" [class.ng-touched]=\"input.control.touched\"\r\n               [class.ng-valid]=\"input.control.valid\" #inputElement\r\n               [value]=\"value || ''\" (change)=\"propagateValue($event)\" (keyup)=\"propagateValue($event)\"\r\n               [fwAutofocus]=\"autoFocus\">\r\n        <ng-container\r\n                *ngIf=\"((submitted === null || submitted === undefined) && contextoFormService && contextoFormService.state.submitted) || input.dirty || submitted\">\r\n            <fw-validation *ngIf=\"invalid | async\" [errores]=\"notOverridenErrors\">\r\n            </fw-validation>\r\n            <div *ngIf=\"invalid | async\">\r\n                <ng-content></ng-content>\r\n                {{setFailures(failures)}} </div>\r\n        </ng-container>\r\n    </div>\r\n    <div *ngIf=\"!editing\">\r\n        <span #ref><ng-content select=\"fw-value\"></ng-content></span>\r\n        <span *ngIf=\"!ref.innerHTML.trim()\">{{value || '-'}}</span>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    provideValueAccessor(TextComponent),
                    InputService
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['maxlength']
            }] }, { type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: InputService }]; }, { type: [{
            type: Input
        }], inputElement: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }], contentChildren: [{
            type: ContentChildren,
            args: [ErrorComponent]
        }] }); })();

class SelectEnumComponent extends AbstractInputComponent {
    constructor(required, injector, validators, asyncValidators, contextoFormService, inputService, config) {
        super(validators, asyncValidators, contextoFormService, inputService, injector);
        this.config = config;
        this.placeholder = this.config.i18n.selectAllOptions || '-- All options --';
        this.keepOrder = e => 1;
        this.required = required !== null; // Si ponemos "required" el valor es undefined.
    }
    ngAfterContentInit() {
        if (this.contentChildren) {
            this.overridenErrors = this.contentChildren.map(error => error.value);
        }
        else {
            this.overridenErrors = [];
        }
    }
    // Sin este fix, al seleccionar el placeholder angular setea la cadena 'undefined'
    selectItem($event) {
        if ($event === 'undefined') {
            this.value = undefined;
        }
    }
}
SelectEnumComponent.ɵfac = function SelectEnumComponent_Factory(t) { return new (t || SelectEnumComponent)(ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(InputService), ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
SelectEnumComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SelectEnumComponent, selectors: [["fw-select-enum"]], contentQueries: function SelectEnumComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ErrorComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildren = _t);
    } }, viewQuery: function SelectEnumComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgModel, 3);
        ɵngcc0.ɵɵviewQuery(NgModel, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.model = _t.first);
    } }, inputs: { placeholder: "placeholder", elements: "elements" }, features: [ɵngcc0.ɵɵProvidersFeature([
            provideValueAccessor(SelectEnumComponent),
            InputService
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c8, decls: 7, vars: 3, consts: [[1, "form-group"], ["ref", ""], [3, "for", "class", 4, "ngIf"], [4, "ngIf"], [3, "for"], [1, "form-control", 3, "id", "name", "disabled", "ngModel", "required", "fwAutofocus", "ngModelChange"], ["input", "ngModel"], ["selected", "", 3, "value", 4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf"], ["selected", "", 3, "value"], [3, "value"], [3, "errores", 4, "ngIf"], [3, "errores"]], template: function SelectEnumComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, SelectEnumComponent_label_4_Template, 2, 4, "label", 2);
        ɵngcc0.ɵɵtemplate(5, SelectEnumComponent_div_5_Template, 7, 12, "div", 3);
        ɵngcc0.ɵɵtemplate(6, SelectEnumComponent_div_6_Template, 6, 2, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label && !_r0.innerHTML.trim());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc6.SelectControlValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc6.RequiredValidator, AutofocusDirective, ɵngcc3.NgForOf, ɵngcc6.NgSelectOption, ɵngcc6.ɵangular_packages_forms_forms_z, ValidationComponent]; }, pipes: function () { return [ɵngcc3.KeyValuePipe, ɵngcc3.AsyncPipe]; }, encapsulation: 2 });
SelectEnumComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService },
    { type: FwFormsConfig }
];
SelectEnumComponent.propDecorators = {
    input: [{ type: ViewChild, args: [NgModel, { static: true },] }],
    contentChildren: [{ type: ContentChildren, args: [ErrorComponent,] }],
    placeholder: [{ type: Input }],
    model: [{ type: ViewChild, args: [NgModel, { static: true },] }],
    elements: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectEnumComponent, [{
        type: Component,
        args: [{
                selector: 'fw-select-enum',
                template: "<div class=\"form-group\">\r\n    <div #ref>\r\n        <ng-content select=\"fw-label\"></ng-content>\r\n    </div>\r\n    <label *ngIf=\"label && !ref.innerHTML.trim()\" for=\"{{cid}}\" [class]=\"editing && required? 'required': ''\">\r\n        {{label}}\r\n    </label>\r\n    <div *ngIf=\"editing\">\r\n        <select id=\"{{cid}}\" class=\"form-control\" name=\"{{cid}}\" [disabled]=\"disabled\"\r\n                [(ngModel)]=\"value\" [required]=\"required\" (ngModelChange)=\"selectItem($event)\"\r\n                #input=\"ngModel\" [fwAutofocus]=\"autoFocus\">\r\n            <option [value]=\"undefined\" selected *ngIf=\"!required\">{{placeholder}}</option>\r\n            <option [value]=\"enumerado.key\" *ngFor=\"let enumerado of elements | keyvalue : keepOrder\">\r\n                {{enumerado.value}}\r\n            </option>\r\n        </select>\r\n        <ng-container *ngIf=\"(contextFormService && contextFormService.state.submitted) || input.dirty\">\r\n\r\n            <fw-validation *ngIf=\"invalid | async\" [errores]=\"notOverridenErrors\">\r\n            </fw-validation>\r\n            <div *ngIf=\"invalid | async\">\r\n                <ng-content></ng-content>\r\n                {{setFailures(failures)}} </div>\r\n        </ng-container>\r\n    </div>\r\n    <div *ngIf=\"!editing\">\r\n        <span #ref><ng-content select=\"fw-value\"></ng-content></span>\r\n        <p *ngIf=\"elements && value && !ref.innerHTML.trim()\">{{elements[value] ? elements[value] : '-'}}</p>\r\n        <p *ngIf=\"!elements || !value\">-</p>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    provideValueAccessor(SelectEnumComponent),
                    InputService
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: InputService }, { type: FwFormsConfig }]; }, { placeholder: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: [NgModel, { static: true }]
        }], contentChildren: [{
            type: ContentChildren,
            args: [ErrorComponent]
        }], model: [{
            type: ViewChild,
            args: [NgModel, { static: true }]
        }], elements: [{
            type: Input
        }] }); })();

class NumberComponent extends AbstractInputComponent {
    constructor(required, injector, validators, asyncValidators, contextFormService, inputService) {
        super(validators, asyncValidators, contextFormService, inputService, injector);
        this.required = required !== null; // If we put only "required" (without value) the value is undefined.
    }
    ngAfterContentInit() {
        if (this.contentChildren) {
            this.overridenErrors = this.contentChildren.map(error => error.value);
        }
        else {
            this.overridenErrors = [];
        }
    }
}
NumberComponent.ɵfac = function NumberComponent_Factory(t) { return new (t || NumberComponent)(ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(InputService)); };
NumberComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NumberComponent, selectors: [["fw-number"]], contentQueries: function NumberComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ErrorComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildren = _t);
    } }, viewQuery: function NumberComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, inputs: { min: "min", max: "max", gt: "gt", step: "step" }, features: [ɵngcc0.ɵɵProvidersFeature([
            provideValueAccessor(NumberComponent),
            InputService
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c8, decls: 10, vars: 22, consts: [[1, "form-group"], ["ref", ""], [3, "for", "class", 4, "ngIf"], [3, "hidden"], ["type", "number", 1, "form-control", 3, "step", "disabled", "max", "min", "placeholder", "id", "name", "ngModel", "value", "fwAutofocus", "ngModelChange"], ["inputElement", ""], [4, "ngIf"], [3, "for"], [3, "errores", 4, "ngIf"], [3, "errores"]], template: function NumberComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, NumberComponent_label_4_Template, 2, 4, "label", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "input", 4, 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function NumberComponent_Template_input_ngModelChange_6_listener($event) { return ctx.value = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, NumberComponent_ng_container_8_Template, 5, 6, "ng-container", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, NumberComponent_div_9_Template, 5, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label && !_r0.innerHTML.trim());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("ng-invalid", ctx.input.control.invalid)("ng-dirty", ctx.input.control.dirty)("ng-touched", ctx.input.control.touched)("ng-valid", ctx.input.control.valid);
        ɵngcc0.ɵɵpropertyInterpolate("step", ctx.step);
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.cid);
        ɵngcc0.ɵɵpropertyInterpolate("name", ctx.cid);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("max", ctx.max)("min", ctx.min)("placeholder", ctx.placeholder)("ngModel", ctx.value)("value", ctx.value || "")("fwAutofocus", ctx.autoFocus);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.submitted === null || ctx.submitted === undefined) && ctx.contextFormService && ctx.contextFormService.state.submitted || ctx.input.dirty || ctx.submitted);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc6.NumberValueAccessor, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, AutofocusDirective, ValidationComponent]; }, pipes: function () { return [ɵngcc3.AsyncPipe]; }, encapsulation: 2 });
NumberComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService }
];
NumberComponent.propDecorators = {
    contentChildren: [{ type: ContentChildren, args: [ErrorComponent,] }],
    inputElement: [{ type: ViewChild, args: ['inputElement', { static: true },] }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    gt: [{ type: Input }],
    step: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumberComponent, [{
        type: Component,
        args: [{
                selector: 'fw-number',
                template: "<div class=\"form-group\">\r\n    <div #ref>\r\n        <ng-content select=\"fw-label\"></ng-content>\r\n    </div>\r\n    <label *ngIf=\"label && !ref.innerHTML.trim()\" for=\"{{cid}}\" [class]=\"editing && required? 'required': ''\">\r\n        {{label}}\r\n    </label>\r\n\r\n    <div [hidden]=\"!editing\">\r\n        <input type=\"number\" step=\"{{step}}\" class=\"form-control\" [disabled]=\"disabled\"\r\n               [class.ng-invalid]=\"input.control.invalid\"\r\n               [class.ng-dirty]=\"input.control.dirty\" [class.ng-touched]=\"input.control.touched\"\r\n               [class.ng-valid]=\"input.control.valid\"\r\n               [max]=\"max\"\r\n               [min]=\"min\"\r\n               #inputElement [placeholder]=\"this.placeholder\" id=\"{{cid}}\" name=\"{{cid}}\" [(ngModel)]=\"value\"\r\n               [value]=\"value || ''\"\r\n               [fwAutofocus]=\"autoFocus\">\r\n        <ng-container\r\n                *ngIf=\"((submitted === null || submitted === undefined) && contextFormService && contextFormService.state.submitted) || input.dirty || submitted\">\r\n            <fw-validation *ngIf=\"invalid | async\" [errores]=\"notOverridenErrors\">\r\n            </fw-validation>\r\n            <div *ngIf=\"invalid | async\">\r\n                <ng-content></ng-content>\r\n                {{setFailures(failures)}} </div>\r\n        </ng-container>\r\n\r\n    </div>\r\n    <div *ngIf=\"!editing\">\r\n        <span #ref><ng-content select=\"fw-value\"></ng-content></span>\r\n        <span *ngIf=\"!ref.innerHTML.trim()\">{{value || '-'}}</span>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    provideValueAccessor(NumberComponent),
                    InputService
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: InputService }]; }, { contentChildren: [{
            type: ContentChildren,
            args: [ErrorComponent]
        }], inputElement: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], gt: [{
            type: Input
        }], step: [{
            type: Input
        }] }); })();

class ValueComponent {
}
ValueComponent.ɵfac = function ValueComponent_Factory(t) { return new (t || ValueComponent)(); };
ValueComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ValueComponent, selectors: [["fw-value"]], ngContentSelectors: _c3, decls: 1, vars: 0, template: function ValueComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValueComponent, [{
        type: Component,
        args: [{
                selector: 'fw-value',
                template: '<ng-content></ng-content>'
            }]
    }], null, null); })();

class MultipleSelection {
    constructor() {
        this.ids = new Set();
        this.excludedIds = new Set();
        this.all = false;
    }
}

class SelectionService extends Store$1 {
    constructor() {
        super(new MultipleSelection());
    }
    selectAll(value) {
        this.setState(Object.assign(Object.assign({}, this.state), { all: value, ids: new Set(), excludedIds: new Set() }));
    }
    addElement(element, checked) {
        if (this.state.all) {
            if (!checked) {
                this.setState(Object.assign(Object.assign({}, this.state), { excludedIds: this.state.excludedIds.add(element) }));
            }
            else {
                this.state.excludedIds.delete(element);
                this.setState(Object.assign({}, this.state));
            }
        }
        else {
            if (checked) {
                this.setState(Object.assign(Object.assign({}, this.state), { ids: this.state.ids.add(element) }));
            }
            else {
                this.state.ids.delete(element);
                this.setState(Object.assign({}, this.state));
            }
        }
    }
    existElement(element) {
        return this.state.ids.has(element) || (this.state.all && !this.state.excludedIds.has(element));
    }
}
SelectionService.ɵfac = function SelectionService_Factory(t) { return new (t || SelectionService)(); };
SelectionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SelectionService, factory: SelectionService.ɵfac });
SelectionService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectionService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class MultipleSelectionComponent {
    constructor(selectionService) {
        this.selectionService = selectionService;
        this.onSeleccion = new EventEmitter();
    }
    // List with marked initial ids
    set initalIds(ids) {
        if (ids && ids.size > 0) {
            ids.forEach(id => {
                this.selectionService.addElement(id, true);
            });
        }
    }
    ngOnInit() {
        this.sub = this.selectionService.state$.subscribe((selection) => {
            this.onSeleccion.emit(selection);
        });
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
MultipleSelectionComponent.ɵfac = function MultipleSelectionComponent_Factory(t) { return new (t || MultipleSelectionComponent)(ɵngcc0.ɵɵdirectiveInject(SelectionService)); };
MultipleSelectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MultipleSelectionComponent, selectors: [["fw-multiple-selection"]], inputs: { initalIds: "initalIds" }, outputs: { onSeleccion: "onSeleccion" }, features: [ɵngcc0.ɵɵProvidersFeature([SelectionService])], ngContentSelectors: _c3, decls: 1, vars: 0, template: function MultipleSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
MultipleSelectionComponent.ctorParameters = () => [
    { type: SelectionService }
];
MultipleSelectionComponent.propDecorators = {
    onSeleccion: [{ type: Output }],
    initalIds: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultipleSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'fw-multiple-selection',
                template: "<ng-content></ng-content>\r\n",
                providers: [SelectionService]
            }]
    }], function () { return [{ type: SelectionService }]; }, { onSeleccion: [{
            type: Output
        }], initalIds: [{
            type: Input
        }] }); })();

class SelectAllComponent {
    constructor(selectionService) {
        this.selectionService = selectionService;
    }
    ngOnInit() {
    }
    checked(e) {
        this.selectionService.selectAll(e.target.checked);
    }
}
SelectAllComponent.ɵfac = function SelectAllComponent_Factory(t) { return new (t || SelectAllComponent)(ɵngcc0.ɵɵdirectiveInject(SelectionService)); };
SelectAllComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SelectAllComponent, selectors: [["fw-select-all"]], decls: 1, vars: 0, consts: [["type", "checkbox", 1, "align-middle", 3, "change"]], template: function SelectAllComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0);
        ɵngcc0.ɵɵlistener("change", function SelectAllComponent_Template_input_change_0_listener($event) { return ctx.checked($event); });
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
SelectAllComponent.ctorParameters = () => [
    { type: SelectionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectAllComponent, [{
        type: Component,
        args: [{
                selector: 'fw-select-all',
                template: "<input type=\"checkbox\" class=\"align-middle\" (change)=\"checked($event)\">\r\n"
            }]
    }], function () { return [{ type: SelectionService }]; }, null); })();

class SelectElementComponent {
    constructor(selectionService) {
        this.selectionService = selectionService;
    }
    ngOnInit() {
    }
    changeSelection(event) {
        this.selectionService.addElement(this.id, event.target.checked);
    }
    isChecked() {
        return this.selectionService.existElement(this.id);
    }
}
SelectElementComponent.ɵfac = function SelectElementComponent_Factory(t) { return new (t || SelectElementComponent)(ɵngcc0.ɵɵdirectiveInject(SelectionService)); };
SelectElementComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SelectElementComponent, selectors: [["fw-select-element"]], inputs: { id: "id" }, decls: 1, vars: 1, consts: [["type", "checkbox", 3, "checked", "change"]], template: function SelectElementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0);
        ɵngcc0.ɵɵlistener("change", function SelectElementComponent_Template_input_change_0_listener($event) { return ctx.changeSelection($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("checked", ctx.isChecked());
    } }, encapsulation: 2 });
SelectElementComponent.ctorParameters = () => [
    { type: SelectionService }
];
SelectElementComponent.propDecorators = {
    id: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectElementComponent, [{
        type: Component,
        args: [{
                selector: 'fw-select-element',
                template: "<input type=\"checkbox\" (change)=\"changeSelection($event)\" [checked]=\"isChecked()\"/>\r\n"
            }]
    }], function () { return [{ type: SelectionService }]; }, { id: [{
            type: Input
        }] }); })();

class EmptyListComponent {
    constructor(formsConfig) {
        this.formsConfig = formsConfig;
    }
    ngOnInit() {
    }
}
EmptyListComponent.ɵfac = function EmptyListComponent_Factory(t) { return new (t || EmptyListComponent)(ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
EmptyListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EmptyListComponent, selectors: [["fw-empty-list"]], decls: 2, vars: 1, consts: [[1, "alert", "alert-info"]], template: function EmptyListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.formsConfig.i18n.emptyList || "The list is empty", "\n");
    } }, styles: [""] });
EmptyListComponent.ctorParameters = () => [
    { type: FwFormsConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EmptyListComponent, [{
        type: Component,
        args: [{
                selector: 'fw-empty-list',
                template: "<div class=\"alert alert-info\">\r\n    {{formsConfig.i18n.emptyList || 'The list is empty'}}\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: FwFormsConfig }]; }, null); })();

class TableComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
TableComponent.ɵfac = function TableComponent_Factory(t) { return new (t || TableComponent)(); };
TableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TableComponent, selectors: [["fw-table"]], inputs: { list: "list" }, ngContentSelectors: _c3, decls: 2, vars: 2, consts: [["class", "table-responsive", 4, "ngIf"], [4, "ngIf"], [1, "table-responsive"], [1, "table", "table-striped", "tabla-gestion", "table-sm"]], template: function TableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TableComponent_div_0_Template, 3, 0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TableComponent_fw_empty_list_1_Template, 1, 0, "fw-empty-list", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", (ctx.list == null ? null : ctx.list.length) > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.list == null ? null : ctx.list.length) === 0);
    } }, directives: [ɵngcc3.NgIf, EmptyListComponent], styles: [""] });
TableComponent.ctorParameters = () => [];
TableComponent.propDecorators = {
    list: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableComponent, [{
        type: Component,
        args: [{
                selector: 'fw-table',
                template: "<div class=\"table-responsive\" *ngIf=\"list?.length > 0\">\r\n    <table class=\"table table-striped tabla-gestion table-sm\">\r\n        <ng-content></ng-content>\r\n    </table>\r\n</div>\r\n\r\n<fw-empty-list *ngIf=\"list?.length === 0\"></fw-empty-list>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { list: [{
            type: Input
        }] }); })();

class DateFormatService {
    constructor() {
        this.dayExpr = '(0[1-9]|[12][0-9]|3[01])';
        this.monthExpr = '(0[1-9]|1[012])';
        this.yearExpr = "(19|20)\\d\\d";
    }
    analizarFormato(inputDateFormat, componente) {
        const formatParts = inputDateFormat.split(RegExp('\/|-')); // '/' o '-'as separator
        const positions = { year: -1, month: -1, day: -1 };
        positions.year = this.findIndex(formatParts, 'yyyy');
        positions.month = this.findIndex(formatParts, 'mm');
        positions.day = this.findIndex(formatParts, 'dd');
        if (positions.year === -1 || positions.month === -1 || positions.day === -1) {
            console.error(componente + ': formato especificado no válido(' + inputDateFormat
                + '). The date format must use yyyy, MM, dd (in whatever order).' +
                'Default format will be used: dd-mm-yyyy');
        }
        return positions;
    }
    generarExpresionRegularFecha(yearPosition, monthPosition, dayPosition) {
        const exprRegular = new Array(3);
        exprRegular.splice(yearPosition, 1, this.yearExpr);
        exprRegular.splice(monthPosition, 1, this.monthExpr);
        exprRegular.splice(dayPosition, 1, this.dayExpr);
        return RegExp(exprRegular.join('[- /.]') + '$');
    }
    mostrarSegundos(inputTimeFormat) {
        return inputTimeFormat.split(':').length === 3;
    }
    findIndex(parts, str) {
        return parts.findIndex(p => p.toLowerCase() === str);
    }
}
DateFormatService.ɵfac = function DateFormatService_Factory(t) { return new (t || DateFormatService)(); };
DateFormatService.ɵprov = ɵɵdefineInjectable({ factory: function DateFormatService_Factory() { return new DateFormatService(); }, token: DateFormatService, providedIn: "root" });
DateFormatService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateFormatService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class DateComponent extends AbstractInputComponent {
    constructor(fechaFormatoService, required, injector, validators, asyncValidators, contextoFormService, inputService, formsConfig) {
        super(validators, asyncValidators, contextoFormService, inputService, injector);
        this.fechaFormatoService = fechaFormatoService;
        this.contextoFormService = contextoFormService;
        this.formsConfig = formsConfig;
        this.inputDateFormat = 'dd-MM-yyyy';
        this.expresionRegularFecha = RegExp('(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\\d\\d$');
        this.yearPosition = 2;
        this.monthPosition = 1;
        this.dayPosition = 0;
        // FIXME Estamos usando este required para saber si mostrar el asterisco... ¿funciona el attribute si es una valor dinámico?
        this.required = required !== null; // Si ponemos "required" el valor es undefined.
        this.overridenErrors = [];
    }
    ngAfterContentInit() {
        // Each time the value of the input changes (in the UI or programmatically) we set the date to start the calendar to the current value
        this.input.valueChanges.subscribe(() => this.buildStartDate());
        if (this.contentChildren) {
            this.overridenErrors = this.contentChildren.map(error => error.value);
        }
        else {
            this.overridenErrors = [];
        }
        if (!this.placeholder) {
            this.placeholder = this.inputDateFormat.toLowerCase();
        }
        this.analizarFormato();
        this.expresionRegularFecha = this.fechaFormatoService.generarExpresionRegularFecha(this.yearPosition, this.monthPosition, this.dayPosition);
        this.formControl = new FormControl(this.cid);
    }
    analizarFormato() {
        const formato = this.fechaFormatoService.analizarFormato(this.inputDateFormat, 'fecha');
        if (formato.year === -1 || formato.month === -1 || formato.day === -1) {
            this.inputDateFormat = 'dd-MM-yyyy';
            this.placeholder = 'dd-mm-yyyy';
        }
        else {
            // formato reconocido
            this.yearPosition = formato.year;
            this.monthPosition = formato.month;
            this.dayPosition = formato.day;
        }
    }
    manualPattern(date) {
        if (date) { // Value selected with datepicker
            if (!this.expresionRegularFecha.test(this.invertirFecha(date))) {
                this.buildStartDate();
                this.clearErrors();
            }
            return;
        }
        if (this.ngModel && this.ngModel !== '' && !this.expresionRegularFecha.test(this.ngModel)) {
            this.input.control.setErrors({ 'incorrect': true });
            this.input.control.markAsDirty();
            this.formControl.setErrors({ 'pattern': true });
        }
        else {
            this.clearErrors();
        }
    }
    clearErrors() {
        this.input.control.setErrors(null);
        this.formControl.setErrors(null);
    }
    /********** Eventos fecha ********/
    onSelect(date) {
        this.value = date.year + '-' + padStart(date.month.toString(), 2, '0') + '-' + padStart(date.day.toString(), 2, '0');
        this.manualPattern(this.value);
    }
    // 19-12-1990 <-> 1990-12-19
    invertirFecha(value) {
        const dateArray = value.split(/[+-/*]+/);
        return dateArray[this.yearPosition] + '-' + dateArray[this.monthPosition] + '-' + dateArray[this.dayPosition];
    }
    propagateValue($event, resetearSiNoEsValido) {
        const valor = $event.target.value;
        if (!valor) {
            this.value = '';
            this.startDate = null;
        }
        else if (valor.match(this.expresionRegularFecha)) {
            this.value = this.invertirFecha($event.target.value);
            this.buildStartDate();
        }
        else if (resetearSiNoEsValido) {
            this.value = '';
            this.ngModel = null;
            this.startDate = null;
        }
        if (!this.value || this.value === '') {
            this.formControl.setErrors(Object.assign(Object.assign({}, this.formControl.errors), { 'pattern': false }));
        }
    }
    buildStartDate() {
        if (this.value !== null) {
            const date = new Date(this.value);
            this.startDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
        }
    }
}
DateComponent.ɵfac = function DateComponent_Factory(t) { return new (t || DateComponent)(ɵngcc0.ɵɵdirectiveInject(DateFormatService), ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(InputService), ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
DateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateComponent, selectors: [["fw-date"]], contentQueries: function DateComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ErrorComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildren = _t);
    } }, viewQuery: function DateComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, inputs: { inputDateFormat: "inputDateFormat", placeholder: "placeholder" }, features: [ɵngcc0.ɵɵProvidersFeature([
            provideValueAccessor(DateComponent),
            InputService
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c8, decls: 20, vars: 35, consts: [[1, "form-group"], ["ref", ""], [3, "for", "class", 4, "ngIf"], [3, "hidden"], [1, "input-group"], ["ngbDatepicker", "", 1, "form-control", 3, "id", "name", "formControl", "value", "placeholder", "ngModel", "fwAutofocus", "disabled", "startDate", "dateSelect", "input", "blur", "ngModelChange"], ["d1", "ngbDatepicker", "inputElement", ""], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-outline-secondary", "calendar", 3, "ngStyle", "click"], [1, "fa", "fa-calendar"], [4, "ngIf"], ["class", "text-danger", 4, "ngIf"], [3, "for"], [3, "errores", 4, "ngIf"], [3, "errores"], [1, "text-danger"]], template: function DateComponent_Template(rf, ctx) { if (rf & 1) {
        const _r11 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, DateComponent_label_4_Template, 2, 4, "label", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "input", 5, 6);
        ɵngcc0.ɵɵlistener("dateSelect", function DateComponent_Template_input_dateSelect_7_listener($event) { return ctx.onSelect($event); })("input", function DateComponent_Template_input_input_7_listener($event) { return ctx.propagateValue($event, false); })("blur", function DateComponent_Template_input_blur_7_listener($event) { ctx.propagateValue($event, false); return ctx.manualPattern(null); })("ngModelChange", function DateComponent_Template_input_ngModelChange_7_listener($event) { return ctx.ngModel = $event; });
        ɵngcc0.ɵɵpipe(10, "async");
        ɵngcc0.ɵɵpipe(11, "async");
        ɵngcc0.ɵɵpipe(12, "date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 7);
        ɵngcc0.ɵɵelementStart(14, "button", 8);
        ɵngcc0.ɵɵlistener("click", function DateComponent_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r11); const _r2 = ɵngcc0.ɵɵreference(8); return _r2.toggle(); });
        ɵngcc0.ɵɵpipe(15, "async");
        ɵngcc0.ɵɵelement(16, "i", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(17, DateComponent_ng_container_17_Template, 5, 6, "ng-container", 10);
        ɵngcc0.ɵɵtemplate(18, DateComponent_div_18_Template, 3, 1, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, DateComponent_div_19_Template, 5, 1, "div", 10);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label && !_r0.innerHTML.trim());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.editing);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("ng-invalid", ɵngcc0.ɵɵpipeBind1(10, 25, ctx.invalid) || (ctx.formControl.errors == null ? null : ctx.formControl.errors.pattern))("border-right-0", ɵngcc0.ɵɵpipeBind1(11, 27, ctx.invalid) && ctx.submitted || (ctx.formControl.errors == null ? null : ctx.formControl.errors.pattern))("ng-dirty", ctx.input.control.dirty)("ng-touched", ctx.input.control.touched)("ng-valid", ctx.input.control.valid);
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.cid);
        ɵngcc0.ɵɵpropertyInterpolate("name", ctx.cid);
        ɵngcc0.ɵɵproperty("formControl", ctx.formControl)("value", ɵngcc0.ɵɵpipeBind2(12, 29, ctx.value, ctx.inputDateFormat) || "")("placeholder", ctx.placeholder)("ngModel", ctx.ngModel)("fwAutofocus", ctx.autoFocus)("disabled", ctx.disabled)("startDate", ctx.startDate);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpipeBind1(15, 32, ctx.invalid) && ctx.submitted || (ctx.formControl.errors == null ? null : ctx.formControl.errors.pattern) ? ɵngcc0.ɵɵpureFunction0(34, _c10) : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.formControl.errors == null ? null : ctx.formControl.errors.pattern) && ((ctx.submitted === null || ctx.submitted === undefined) && ctx.contextoFormService && ctx.contextoFormService.state.submitted || ctx.input.dirty || ctx.submitted));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formControl.errors == null ? null : ctx.formControl.errors.pattern);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc2.NgbInputDatepicker, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.FormControlDirective, AutofocusDirective, ɵngcc3.NgStyle, ValidationComponent]; }, pipes: function () { return [ɵngcc3.AsyncPipe, ɵngcc3.DatePipe]; }, encapsulation: 2 });
DateComponent.ctorParameters = () => [
    { type: DateFormatService },
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService },
    { type: FwFormsConfig }
];
DateComponent.propDecorators = {
    inputDateFormat: [{ type: Input }],
    placeholder: [{ type: Input }],
    inputElement: [{ type: ViewChild, args: ['inputElement', { static: true },] }],
    contentChildren: [{ type: ContentChildren, args: [ErrorComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateComponent, [{
        type: Component,
        args: [{
                selector: 'fw-date',
                template: "<div class=\"form-group\">\r\n    <div #ref>\r\n        <ng-content select=\"fw-label\"></ng-content>\r\n    </div>\r\n    <label *ngIf=\"label && !ref.innerHTML.trim()\" for=\"{{cid}}\" [class]=\"editing && required? 'required': ''\">\r\n        {{label}}\r\n    </label>\r\n    <div [hidden]=\"!editing\">\r\n        <div class=\"input-group\">\r\n            <input #d1=\"ngbDatepicker\" id=\"{{cid}}\" class=\"form-control\" name=\"{{cid}}\"\r\n                   [class.ng-invalid]=\"(invalid | async) || formControl.errors?.pattern\"\r\n                   [class.border-right-0]=\"((invalid | async) && submitted)|| formControl.errors?.pattern\"\r\n                   [class.ng-dirty]=\"input.control.dirty\" [class.ng-touched]=\"input.control.touched\"\r\n                   [class.ng-valid]=\"input.control.valid\"\r\n                   [formControl]=\"formControl\"\r\n                   #inputElement\r\n                   (dateSelect)=\"onSelect($event)\"\r\n                   (input)=\"propagateValue($event, false)\"\r\n                   [value]=\"(value | date:inputDateFormat) || ''\"\r\n                   (blur)=\"propagateValue($event, false); manualPattern(null)\"\r\n                   ngbDatepicker [placeholder]=\"placeholder\" [(ngModel)]=\"ngModel\" [fwAutofocus]=\"autoFocus\"\r\n                   [disabled]=\"disabled\"\r\n                   [startDate]=\"startDate\">\r\n            <div class=\"input-group-append\">\r\n                <button (click)=\"d1.toggle()\" class=\"btn btn-outline-secondary calendar\"\r\n                        [ngStyle]=\" ((invalid | async) && (submitted))  || formControl.errors?.pattern  ? { 'border-left-color': '#f86c6b'} : null\"\r\n                        type=\"button\">\r\n                    <i class=\"fa fa-calendar\"></i>\r\n                </button>\r\n            </div>\r\n        </div>\r\n\r\n        <ng-container\r\n                *ngIf=\"!formControl.errors?.pattern && (((submitted === null || submitted === undefined) && contextoFormService && contextoFormService.state.submitted) || input.dirty || submitted)\">\r\n            <fw-validation *ngIf=\"invalid | async\" [errores]=\"notOverridenErrors\">\r\n            </fw-validation>\r\n            <div *ngIf=\"invalid | async\">\r\n                <ng-content></ng-content>\r\n                {{setFailures(failures)}} </div>\r\n        </ng-container>\r\n        <div *ngIf=\"formControl.errors?.pattern\" class=\"text-danger\">\r\n            <small>{{(formsConfig.i18n.validationInvalidPattern || 'Invalid pattern') + ' (' + inputDateFormat + ')'}}</small>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"!editing\">\r\n        <span #ref><ng-content select=\"fw-value\"></ng-content></span>\r\n        <span *ngIf=\"!ref.innerHTML.trim()\">{{value && value.length > 0 ? (value | date:inputDateFormat) : '-'}}</span>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    provideValueAccessor(DateComponent),
                    InputService
                ]
            }]
    }], function () { return [{ type: DateFormatService }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: InputService }, { type: FwFormsConfig }]; }, { inputDateFormat: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], inputElement: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }], contentChildren: [{
            type: ContentChildren,
            args: [ErrorComponent]
        }] }); })();

class DatetimeComponent extends AbstractInputComponent {
    constructor(fechaFormatoService, required, injector, validators, asyncValidators, contextoFormService, inputService) {
        super(validators, asyncValidators, contextoFormService, inputService, injector);
        this.fechaFormatoService = fechaFormatoService;
        this.contextoFormService = contextoFormService;
        this.inputDatetimeFormat = 'dd-MM-yyyy HH:mm:ss';
        this.mostrarSegundos = true;
        this.expresionRegularFecha = RegExp('(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\\d\\d$');
        this.yearPosition = 2;
        this.monthPosition = 1;
        this.dayPosition = 0;
        // FIXME Estamos usando este required para saber si mostrar el asterisco... ¿funciona el attribute si es una valor dinámico?
        this.required = required !== null; // Si ponemos "required" el valor es undefined.
    }
    ngAfterContentInit() {
        // Each time the value of the input changes (in the UI or programmatically) we set the date to start the calendar to the current value
        this.input.valueChanges.subscribe(() => this.buildStartDate());
        if (this.contentChildren) {
            this.overridenErrors = this.contentChildren.map(error => error.value);
        }
        else {
            this.overridenErrors = [];
        }
        if (!this.placeholder) {
            this.placeholder = this.inputDatetimeFormat.toLowerCase();
        }
        this.analizarFormato();
        this.expresionRegularFecha = this.fechaFormatoService.generarExpresionRegularFecha(this.yearPosition, this.monthPosition, this.dayPosition);
    }
    analizarFormato() {
        const dateParts = this.inputDatetimeFormat.split(' ');
        this.mostrarSegundos = this.fechaFormatoService.mostrarSegundos(dateParts[1]);
        const formato = this.fechaFormatoService.analizarFormato(dateParts[0], 'fecha-hora');
        if (formato.year === -1 || formato.month === -1 || formato.day === -1) {
            this.inputDatetimeFormat = 'dd-MM-yyyy HH:mm:ss';
            this.placeholder = 'dd-mm-yyyy hh:mm:ss';
        }
        else {
            // formato reconocido
            this.yearPosition = formato.year;
            this.monthPosition = formato.month;
            this.dayPosition = formato.day;
        }
    }
    /********** Eventos fecha ********/
    onSelect(date) {
        let fechaDate = new Date(date.year, date.month - 1, date.day, 0, 0, 0);
        this.value = fechaDate.toISOString();
    }
    // 19-12-1990 <-> 1990-12-19
    invertirFecha(value) {
        const dateArray = value.split(/[+-/*]+/);
        return dateArray[this.yearPosition] + "-" + dateArray[this.monthPosition] + "-" + dateArray[this.dayPosition];
    }
    propagateValue($event, resetearSiNoEsValido) {
        const arrayFechaHora = $event.target.value.split(" ");
        const fecha = arrayFechaHora[0];
        if (!fecha) {
            this.value = '';
            this.startDate = null;
        }
        else if (fecha.match(this.expresionRegularFecha)) {
            let fechaDate = new Date(this.invertirFecha(fecha));
            if (arrayFechaHora[1]) {
                const arrayHora = arrayFechaHora[1].split(":");
                if (arrayHora.length === 3 || (!this.mostrarSegundos && arrayHora.length === 2)) {
                    if (arrayHora.length === 2) {
                        arrayHora.push('00');
                    }
                    const noFaltaNingunCaracter = arrayHora[0].length === 2 && arrayHora[1].length === 2 && arrayHora[2].length === 2;
                    if (noFaltaNingunCaracter || resetearSiNoEsValido) {
                        fechaDate.setHours(Number(arrayHora[0]));
                        fechaDate.setMinutes(Number(arrayHora[1]));
                        fechaDate.setSeconds(Number(arrayHora[2]));
                        this.value = fechaDate.toISOString();
                        this.buildStartDate();
                    }
                }
                else {
                    if (resetearSiNoEsValido) {
                        if (arrayHora.length === 2) {
                            fechaDate.setHours(Number(arrayHora[0]));
                            fechaDate.setMinutes(Number(arrayHora[1]));
                            fechaDate.setSeconds(0);
                        }
                        else if (arrayHora.length === 1) {
                            fechaDate.setHours(Number(arrayHora[0]));
                            fechaDate.setMinutes(0);
                            fechaDate.setSeconds(0);
                        }
                        else {
                            fechaDate.setHours(0);
                            fechaDate.setMinutes(0);
                            fechaDate.setSeconds(0);
                        }
                        this.value = fechaDate.toISOString();
                        this.buildStartDate();
                    }
                }
            }
        }
        else if (resetearSiNoEsValido) {
            this.value = '';
            this.startDate = null;
        }
    }
    buildStartDate() {
        if (this.value !== null) {
            const date = new Date(this.value);
            this.startDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
        }
    }
}
DatetimeComponent.ɵfac = function DatetimeComponent_Factory(t) { return new (t || DatetimeComponent)(ɵngcc0.ɵɵdirectiveInject(DateFormatService), ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(InputService)); };
DatetimeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DatetimeComponent, selectors: [["fw-datetime"]], contentQueries: function DatetimeComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ErrorComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildren = _t);
    } }, inputs: { inputDatetimeFormat: "inputDatetimeFormat", placeholder: "placeholder" }, features: [ɵngcc0.ɵɵProvidersFeature([
            provideValueAccessor(DatetimeComponent),
            InputService
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c8, decls: 16, vars: 28, consts: [[1, "form-group"], ["ref", ""], [3, "for", "class", 4, "ngIf"], [3, "hidden"], [1, "input-group"], ["ngbDatepicker", "", 1, "form-control", 3, "id", "name", "disabled", "value", "placeholder", "fwAutofocus", "startDate", "dateSelect", "input", "blur"], ["d1", "ngbDatepicker"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-outline-secondary", "calendar", 3, "ngStyle", "click"], [1, "fa", "fa-calendar"], [4, "ngIf"], [3, "for"], [3, "errores", 4, "ngIf"], [3, "errores"]], template: function DatetimeComponent_Template(rf, ctx) { if (rf & 1) {
        const _r9 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, DatetimeComponent_label_4_Template, 2, 4, "label", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "input", 5, 6);
        ɵngcc0.ɵɵlistener("dateSelect", function DatetimeComponent_Template_input_dateSelect_7_listener($event) { return ctx.onSelect($event); })("input", function DatetimeComponent_Template_input_input_7_listener($event) { return ctx.propagateValue($event, false); })("blur", function DatetimeComponent_Template_input_blur_7_listener($event) { return ctx.propagateValue($event, true); });
        ɵngcc0.ɵɵpipe(9, "date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵelementStart(11, "button", 8);
        ɵngcc0.ɵɵlistener("click", function DatetimeComponent_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r9); const _r2 = ɵngcc0.ɵɵreference(8); return _r2.toggle(); });
        ɵngcc0.ɵɵpipe(12, "async");
        ɵngcc0.ɵɵelement(13, "i", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, DatetimeComponent_ng_container_14_Template, 5, 6, "ng-container", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(15, DatetimeComponent_div_15_Template, 5, 1, "div", 10);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label && !_r0.innerHTML.trim());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.editing);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("ng-invalid", ctx.input.control.invalid)("border-right-0", ctx.input.control.invalid && ctx.submitted)("ng-dirty", ctx.input.control.dirty)("ng-touched", ctx.input.control.touched)("ng-valid", ctx.input.control.valid);
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.cid);
        ɵngcc0.ɵɵpropertyInterpolate("name", ctx.cid);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("value", ɵngcc0.ɵɵpipeBind2(9, 22, ctx.value, ctx.inputDatetimeFormat) || "")("placeholder", ctx.placeholder)("fwAutofocus", ctx.autoFocus)("startDate", ctx.startDate);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpipeBind1(12, 25, ctx.invalid) && ctx.submitted ? ɵngcc0.ɵɵpureFunction0(27, _c10) : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.contextoFormService && ctx.contextoFormService.state.submitted || ctx.input.dirty);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc2.NgbInputDatepicker, AutofocusDirective, ɵngcc3.NgStyle, ValidationComponent]; }, pipes: function () { return [ɵngcc3.DatePipe, ɵngcc3.AsyncPipe]; }, encapsulation: 2 });
DatetimeComponent.ctorParameters = () => [
    { type: DateFormatService },
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService }
];
DatetimeComponent.propDecorators = {
    inputDatetimeFormat: [{ type: Input }],
    placeholder: [{ type: Input }],
    contentChildren: [{ type: ContentChildren, args: [ErrorComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatetimeComponent, [{
        type: Component,
        args: [{
                selector: 'fw-datetime',
                template: "<div class=\"form-group\">\r\n    <div #ref>\r\n        <ng-content select=\"fw-label\"></ng-content>\r\n    </div>\r\n    <label *ngIf=\"label && !ref.innerHTML.trim()\" for=\"{{cid}}\" [class]=\"editing && required? 'required': ''\">\r\n        {{label}}\r\n    </label>\r\n    <div [hidden]=\"!editing\">\r\n        <div class=\"input-group\">\r\n            <input #d1=\"ngbDatepicker\" id=\"{{cid}}\" class=\"form-control\" name=\"{{cid}}\"\r\n                   [class.ng-invalid]=\"input.control.invalid\"\r\n                   [class.border-right-0]=\"input.control.invalid && (submitted)\"\r\n                   [class.ng-dirty]=\"input.control.dirty\" [class.ng-touched]=\"input.control.touched\"\r\n                   [disabled]=\"disabled\"\r\n                   [class.ng-valid]=\"input.control.valid\" (dateSelect)=\"onSelect($event)\"\r\n                   (input)=\"propagateValue($event, false)\"\r\n                   [value]=\"(value | date:inputDatetimeFormat) || ''\" (blur)=\"propagateValue($event, true)\"\r\n                   ngbDatepicker\r\n                   [placeholder]=\"placeholder\" [fwAutofocus]=\"autoFocus\"\r\n                   [startDate]=\"startDate\"\r\n            >\r\n            <div class=\"input-group-append\">\r\n                <button (click)=\"d1.toggle()\" class=\"btn btn-outline-secondary calendar\" type=\"button\"\r\n                        [ngStyle]=\" ((invalid | async) && (submitted))  ? { 'border-left-color': '#f86c6b'} : null\">\r\n                    <i class=\"fa fa-calendar\"></i>\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <ng-container *ngIf=\"(contextoFormService && contextoFormService.state.submitted) || input.dirty\">\r\n            <fw-validation *ngIf=\"invalid | async\" [errores]=\"notOverridenErrors\">\r\n            </fw-validation>\r\n            <div *ngIf=\"invalid | async\">\r\n                <ng-content></ng-content>\r\n                {{setFailures(failures)}} </div>\r\n        </ng-container>\r\n    </div>\r\n    <div *ngIf=\"!editing\">\r\n        <span #ref><ng-content select=\"fw-value\"></ng-content></span>\r\n        <span *ngIf=\"!ref.innerHTML.trim()\">{{(value | date:inputDatetimeFormat) || '-'}}</span>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    provideValueAccessor(DatetimeComponent),
                    InputService
                ]
            }]
    }], function () { return [{ type: DateFormatService }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: InputService }]; }, { inputDatetimeFormat: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], contentChildren: [{
            type: ContentChildren,
            args: [ErrorComponent]
        }] }); })();

class AutofocusDirective {
    constructor(elementRef, contextFormService) {
        this.elementRef = elementRef;
        this.contextFormService = contextFormService;
    }
    ngAfterViewInit() {
        if (this.fwAutofocus) {
            this.elementRef.nativeElement.focus();
        }
        if (this.contextFormService) {
            this.contextFormService.state$.subscribe(state => {
                if (state.editing && this.fwAutofocus) {
                    setTimeout(() => this.elementRef.nativeElement.focus(), 0);
                }
            });
        }
    }
}
AutofocusDirective.ɵfac = function AutofocusDirective_Factory(t) { return new (t || AutofocusDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8)); };
AutofocusDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AutofocusDirective, selectors: [["", "fwAutofocus", ""]], inputs: { fwAutofocus: "fwAutofocus" } });
AutofocusDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ContextFormService, decorators: [{ type: Optional }] }
];
AutofocusDirective.propDecorators = {
    fwAutofocus: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutofocusDirective, [{
        type: Directive,
        args: [{
                selector: '[fwAutofocus]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }]; }, { fwAutofocus: [{
            type: Input
        }] }); })();

var RichEditorConfig;
(function (RichEditorConfig) {
    RichEditorConfig[RichEditorConfig["SIMPLE"] = 0] = "SIMPLE";
    RichEditorConfig[RichEditorConfig["FULL"] = 1] = "FULL";
    RichEditorConfig[RichEditorConfig["FULL_TEXT"] = 2] = "FULL_TEXT";
})(RichEditorConfig || (RichEditorConfig = {}));

// Default formats
const FORMATS_CONFIG = {
    underline: { inline: 'u', exact: true }
};
const FULL_CONFIG = {
    menubar: false,
    formats: FORMATS_CONFIG,
    plugins: [
        'lists advlist autolink link image charmap print preview anchor',
        'searchreplace code fullscreen',
        'insertdatetime media table paste help wordcount'
    ],
    toolbar: 'undo redo | formatselect | bold italic underline backcolor link' +
        ' | alignleft aligncenter alignright alignjustify' +
        ' | bullist numlist outdent indent table' +
        ' | image media removeformat code fullscreen | help'
};
const SIMPLE_CONFIG = {
    menubar: false,
    formats: FORMATS_CONFIG,
    plugins: [
        'code wordcount'
    ],
    toolbar: 'undo redo | bold italic underline link | code'
};
const FULL_TEXT_CONFIG = {
    menubar: false,
    formats: FORMATS_CONFIG,
    plugins: [
        'lists advlist autolink link preview anchor',
        'searchreplace code fullscreen',
        'help wordcount'
    ],
    toolbar: 'undo redo | formatselect | bold italic underline link' +
        ' | alignleft aligncenter alignright alignjustify' +
        ' | bullist numlist outdent indent | removeformat code fullscreen | help'
};

class RichEditorComponent extends AbstractInputComponent {
    constructor(required, injector, validators, asyncValidators, contextFormService, inputService) {
        super(validators, asyncValidators, contextFormService, inputService, injector);
        this.contextFormService = contextFormService;
        this.height = 200;
    }
    ngAfterContentInit() {
        this.toolbar = this.customToolbarConstant != null ? this.customToolbarConstant : this.checkConfig(this.presetToolbar);
        this.config = Object.assign({ height: this.height }, this.toolbar);
        if (this.contentChildren) {
            this.overridenErrors = this.contentChildren.map(error => error.value);
        }
        else {
            this.overridenErrors = [];
        }
    }
    checkConfig(presetToolbar) {
        switch (presetToolbar) {
            case RichEditorConfig.SIMPLE: {
                return SIMPLE_CONFIG;
            }
            case RichEditorConfig.FULL_TEXT: {
                return FULL_TEXT_CONFIG;
            }
            case RichEditorConfig.FULL: {
                return FULL_CONFIG;
            }
            default: {
                return FULL_CONFIG;
            }
        }
    }
}
RichEditorComponent.ɵfac = function RichEditorComponent_Factory(t) { return new (t || RichEditorComponent)(ɵngcc0.ɵɵinjectAttribute('required'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NG_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(NG_ASYNC_VALIDATORS, 8), ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(InputService)); };
RichEditorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RichEditorComponent, selectors: [["fw-rich-editor"]], contentQueries: function RichEditorComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ErrorComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildren = _t);
    } }, viewQuery: function RichEditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgModel, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { height: "height", toolbar: "toolbar", maxLength: "maxLength", presetToolbar: "presetToolbar", customToolbarConstant: "customToolbarConstant" }, features: [ɵngcc0.ɵɵProvidersFeature([
            provideValueAccessor(RichEditorComponent),
            InputService
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c8, decls: 7, vars: 3, consts: [[1, "form-group"], ["ref", ""], [3, "for", "class", 4, "ngIf"], [4, "ngIf"], [3, "for"], [1, "editor", 3, "id", "ngModel", "init", "ngModelChange"], [3, "errores", 4, "ngIf"], [3, "errores"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"]], template: function RichEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, RichEditorComponent_label_4_Template, 2, 4, "label", 2);
        ɵngcc0.ɵɵtemplate(5, RichEditorComponent_div_5_Template, 3, 12, "div", 3);
        ɵngcc0.ɵɵtemplate(6, RichEditorComponent_div_6_Template, 5, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label && !_r0.innerHTML.trim());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, directives: [ɵngcc3.NgIf, ɵngcc7.EditorComponent, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ValidationComponent], pipes: [ɵngcc3.AsyncPipe], styles: ["[_nghost-%COMP%] .editor.invalid div{border-color:red}"] });
RichEditorComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Attribute, args: ['required',] }] },
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] }] },
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: InputService }
];
RichEditorComponent.propDecorators = {
    maxLength: [{ type: Input }],
    height: [{ type: Input }],
    presetToolbar: [{ type: Input }],
    toolbar: [{ type: Input }],
    customToolbarConstant: [{ type: Input }],
    input: [{ type: ViewChild, args: [NgModel, { static: true },] }],
    contentChildren: [{ type: ContentChildren, args: [ErrorComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RichEditorComponent, [{
        type: Component,
        args: [{
                selector: 'fw-rich-editor',
                template: "<div class=\"form-group\">\r\n    <div #ref>\r\n        <ng-content select=\"fw-label\"></ng-content>\r\n    </div>\r\n    <label *ngIf=\"label && !ref.innerHTML.trim()\" for=\"{{cid}}\" [class]=\"editing && required? 'required': ''\">\r\n        {{label}}\r\n    </label>\r\n    <div *ngIf=\"editing\">\r\n        <editor id=\"{{cid}}\" [(ngModel)]=\"value\" [init]=\"config\"\r\n                [class.invalid]=\"(contextFormService && contextFormService.state.submitted || input.dirty || submitted) && input.control.invalid\"\r\n                class=\"editor\"\r\n                [class.ng-dirty]=\"input.control.dirty\" [class.ng-touched]=\"input.control.touched\"\r\n                [class.valid]=\"input.control.valid\"></editor>\r\n        <ng-container\r\n                *ngIf=\"((submitted === null || submitted === undefined) && contextFormService && contextFormService.state.submitted) || input.dirty || submitted\">\r\n            <fw-validation *ngIf=\"invalid | async\" [errores]=\"notOverridenErrors\">\r\n            </fw-validation>\r\n            <div *ngIf=\"invalid | async\">\r\n                <ng-content></ng-content>\r\n                {{setFailures(failures)}} </div>\r\n        </ng-container>\r\n    </div>\r\n\r\n    <div *ngIf=\"!editing\">\r\n        <span #ref><ng-content select=\"fw-value\"></ng-content></span>\r\n        <span *ngIf=\"!ref.innerHTML.trim()\" [innerHTML]=\"value || '-'\"></span>\r\n    </div>\r\n</div>\r\n",
                providers: [
                    provideValueAccessor(RichEditorComponent),
                    InputService
                ],
                styles: [":host::ng-deep.editor.invalid div{border-color:red}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Attribute,
                args: ['required']
            }] }, { type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_VALIDATORS]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NG_ASYNC_VALIDATORS]
            }] }, { type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: InputService }]; }, { height: [{
            type: Input
        }], toolbar: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], presetToolbar: [{
            type: Input
        }], customToolbarConstant: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: [NgModel, { static: true }]
        }], contentChildren: [{
            type: ContentChildren,
            args: [ErrorComponent]
        }] }); })();

class FormSaveContinueComponent {
    constructor(contextFormService, config) {
        this.contextFormService = contextFormService;
        this.config = config;
        this.label = this.config.i18n.saveContinue || 'Save and continue';
    }
    ngOnInit() {
    }
    continue() {
        if (this.contextFormService) {
            this.contextFormService.state.continued();
        }
    }
}
FormSaveContinueComponent.ɵfac = function FormSaveContinueComponent_Factory(t) { return new (t || FormSaveContinueComponent)(ɵngcc0.ɵɵdirectiveInject(ContextFormService, 8), ɵngcc0.ɵɵdirectiveInject(FwFormsConfig)); };
FormSaveContinueComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormSaveContinueComponent, selectors: [["fw-form-save-continue"]], inputs: { label: "label", disabled: "disabled", sending: "sending" }, decls: 6, vars: 4, consts: [["type", "submit", 1, "btn", "btn-primary", 3, "disabled", "click"], ["class", "fas fa-arrow-alt-circle-right", 4, "ngIf"], ["class", "fa fa-spinner fa-spin", 4, "ngIf"], [1, "fas", "fa-arrow-alt-circle-right"], [1, "fa", "fa-spinner", "fa-spin"]], template: function FormSaveContinueComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function FormSaveContinueComponent_Template_button_click_0_listener() { return ctx.continue(); });
        ɵngcc0.ɵɵtemplate(1, FormSaveContinueComponent_span_1_Template, 1, 0, "span", 1);
        ɵngcc0.ɵɵtemplate(2, FormSaveContinueComponent_span_2_Template, 1, 0, "span", 2);
        ɵngcc0.ɵɵtext(3, "\u00A0 ");
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled || ctx.sending || (ctx.contextFormService == null ? null : ctx.contextFormService.state == null ? null : ctx.contextFormService.state.sending) && ctx.sending === undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.sending && !((ctx.contextFormService == null ? null : ctx.contextFormService.state == null ? null : ctx.contextFormService.state.sending) && ctx.sending === undefined));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sending || (ctx.contextFormService == null ? null : ctx.contextFormService.state == null ? null : ctx.contextFormService.state.sending) && ctx.sending === undefined);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
    } }, directives: [ɵngcc3.NgIf], styles: ["button[_ngcontent-%COMP%]{margin-right:5px}"] });
FormSaveContinueComponent.ctorParameters = () => [
    { type: ContextFormService, decorators: [{ type: Optional }] },
    { type: FwFormsConfig }
];
FormSaveContinueComponent.propDecorators = {
    disabled: [{ type: Input }],
    sending: [{ type: Input }],
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormSaveContinueComponent, [{
        type: Component,
        args: [{
                selector: 'fw-form-save-continue',
                template: "<button (click)=\"continue()\"\r\n        [disabled]=\"disabled || sending || (contextFormService?.state?.sending && sending === undefined)\"\r\n        class=\"btn btn-primary\"\r\n        type=\"submit\">\r\n    <span *ngIf=\"!sending && !(contextFormService?.state?.sending && sending === undefined)\"\r\n          class=\"fas fa-arrow-alt-circle-right\">\r\n    </span>\r\n    <span *ngIf=\"sending || (contextFormService?.state?.sending && sending === undefined)\"\r\n          class=\"fa fa-spinner fa-spin\">\r\n    </span>&nbsp;\r\n    <span>{{label}}</span>\r\n</button>\r\n",
                styles: ["button{margin-right:5px}"]
            }]
    }], function () { return [{ type: ContextFormService, decorators: [{
                type: Optional
            }] }, { type: FwFormsConfig }]; }, { label: [{
            type: Input
        }], disabled: [{
            type: Input
        }], sending: [{
            type: Input
        }] }); })();

class ValidateIbanDirective {
    constructor() {
        this.active = true;
        this.letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        this.onlyLetterRegex = /^[A-Z]+$/;
    }
    set fwValidateIban(value) {
        this.active = value;
        if (this._onChange) {
            this._onChange();
        }
    }
    validate(control) {
        if (this.active && control.value) {
            let iban = control.value;
            iban = iban.toUpperCase().replace(/\s/g, '');
            if (!this.onlyLetterRegex.test(iban.substring(0, 2))) {
                return { validateIbanError: true };
            }
            const spanishIban = iban.startsWith('ES');
            if (spanishIban && iban.length !== 24) {
                // check ES lenght
                return { validateIbanError: true };
            }
            let ibanaux = this.ibanToIntegerString(iban);
            ibanaux = ibanaux.substring(6) + ibanaux.substring(0, 6);
            if (!this.validateMod97(ibanaux)) {
                return { validateIbanError: true };
            }
            if (spanishIban && !this.validateChecksum(iban)) {
                return { validateIbanError: true };
            }
        }
        return null;
    }
    /**
     * Registers a callback function to call when the validator inputs change.
     * @nodoc
     */
    registerOnValidatorChange(fn) {
        this._onChange = fn;
    }
    ibanToIntegerString(iban) {
        return iban.split('').map(c => this.letterToNumber(c)).join('');
    }
    letterToNumber(letter) {
        const letterNum = this.letters.search(letter);
        if (letterNum === -1) {
            return letter;
        }
        return (letterNum + 10).toString();
    }
    validateMod97(iban) {
        let n = iban.substring(0, 9);
        iban = iban.substring(9);
        while (iban.length) {
            const digits = Number.parseInt(n, 10) % 97;
            if (iban.length < 7) {
                n = iban;
                iban = '';
            }
            else {
                n = iban.substring(0, 7);
                iban = iban.substring(7);
            }
            n = digits + n;
            console.log(iban);
            console.log(n);
        }
        return Number.parseInt(n, 10) % 97 === 1;
    }
    validateChecksum(iban) {
        const bban = iban.substring(4);
        const cd = bban.substring(8, 10);
        const bankBranch = bban.substring(0, 8);
        const cd1 = this.getPartialCD(bankBranch);
        const cd2 = this.getPartialCD(bban.substring(10));
        const checksum = cd1 + cd2;
        return cd === checksum;
    }
    getPartialCD(s) {
        const weights = [6, 3, 7, 9, 10, 5, 8, 4, 2, 1];
        let sum = 0;
        for (let i = 0; i < s.length; i++) {
            sum += (Number.parseInt(s.charAt(s.length - i - 1), 10) * weights[i]);
        }
        const partialCD = (11 - (sum % 11));
        if (partialCD === 11) {
            return '0';
        }
        else if (partialCD === 10) {
            return '1';
        }
        return partialCD.toString();
    }
}
ValidateIbanDirective.ɵfac = function ValidateIbanDirective_Factory(t) { return new (t || ValidateIbanDirective)(); };
ValidateIbanDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ValidateIbanDirective, selectors: [["", "fwValidateIban", ""]], inputs: { fwValidateIban: "fwValidateIban" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateIbanDirective), multi: true }
        ])] });
ValidateIbanDirective.ctorParameters = () => [];
ValidateIbanDirective.propDecorators = {
    fwValidateIban: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidateIbanDirective, [{
        type: Directive,
        args: [{
                selector: '[fwValidateIban]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateIbanDirective), multi: true }
                ]
            }]
    }], function () { return []; }, { fwValidateIban: [{
            type: Input
        }] }); })();

class ValidateMinValueDirective {
    constructor() {
        this.fwMin = 0;
    }
    validate(control) {
        if (isNaN(+control.value)) {
            return { isNaN: true };
        }
        if (control.value < this.fwMin) {
            return { fwMin: true };
        }
        return null;
    }
}
ValidateMinValueDirective.ɵfac = function ValidateMinValueDirective_Factory(t) { return new (t || ValidateMinValueDirective)(); };
ValidateMinValueDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ValidateMinValueDirective, selectors: [["", "fwMin", ""]], inputs: { fwMin: "fwMin" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateMinValueDirective), multi: true }
        ])] });
ValidateMinValueDirective.propDecorators = {
    fwMin: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidateMinValueDirective, [{
        type: Directive,
        args: [{
                selector: '[fwMin]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateMinValueDirective), multi: true }
                ]
            }]
    }], function () { return []; }, { fwMin: [{
            type: Input
        }] }); })();

class ValidateMaxlengthHtmlDirective {
    validate(c) {
        if (this.value && c && c.value && c.value.replace(/<[^>]*>/g, '').length > this.value) {
            return {
                validateMaxlengthHtml: {
                    value: true,
                    requiredLength: this.value
                },
            };
        }
        return null;
    }
}
ValidateMaxlengthHtmlDirective.ɵfac = function ValidateMaxlengthHtmlDirective_Factory(t) { return new (t || ValidateMaxlengthHtmlDirective)(); };
ValidateMaxlengthHtmlDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ValidateMaxlengthHtmlDirective, selectors: [["", "fwValidateMaxlengthHtml", "", "formControlName", ""], ["", "fwValidateMaxlengthHtml", "", "formControl", ""], ["", "fwValidateMaxlengthHtml", "", "ngModel", ""]], inputs: { value: ["fwValidateMaxlengthHtml", "value"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateMaxlengthHtmlDirective), multi: true }
        ])] });
ValidateMaxlengthHtmlDirective.propDecorators = {
    value: [{ type: Input, args: ['fwValidateMaxlengthHtml',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidateMaxlengthHtmlDirective, [{
        type: Directive,
        args: [{
                selector: '[fwValidateMaxlengthHtml][formControlName],[fwValidateMaxlengthHtml][formControl],[fwValidateMaxlengthHtml][ngModel]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateMaxlengthHtmlDirective), multi: true }
                ]
            }]
    }], null, { value: [{
            type: Input,
            args: ['fwValidateMaxlengthHtml']
        }] }); })();

class ValidateEqualDirective {
    validate(c) {
        if (this.value && this.value.length > 0 && c.value && c.value !== this.value) {
            return {
                validateEqual: false
            };
        }
        return null;
    }
}
ValidateEqualDirective.ɵfac = function ValidateEqualDirective_Factory(t) { return new (t || ValidateEqualDirective)(); };
ValidateEqualDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ValidateEqualDirective, selectors: [["", "fwValidateEqual", "", "formControlName", ""], ["", "fwValidateEqual", "", "formControl", ""], ["", "fwValidateEqual", "", "ngModel", ""]], inputs: { value: ["fwValidateEqual", "value"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateEqualDirective), multi: true }
        ])] });
ValidateEqualDirective.propDecorators = {
    value: [{ type: Input, args: ['fwValidateEqual',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidateEqualDirective, [{
        type: Directive,
        args: [{
                selector: '[fwValidateEqual][formControlName],[fwValidateEqual][formControl],[fwValidateEqual][ngModel]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateEqualDirective), multi: true }
                ]
            }]
    }], null, { value: [{
            type: Input,
            args: ['fwValidateEqual']
        }] }); })();

/**
 * Valida el formato de los códigos de identificación CIF/NIF/NIE
 */
class IdentificationService {
    constructor() {
    }
    isNieValido(identificador) {
        let valido;
        if (identificador) {
            // test and set the validity after update.
            let numero;
            let letraAux;
            let letra;
            const expresion_regular_dni = /^[XYZ]{1}[0-9]{7}[A-Z]{1}$/;
            // Patrón anterior común NIF/NIE => /^[XYZ]?\d{5,8}[A-Z]$/;
            const dni = identificador.toUpperCase();
            if (expresion_regular_dni.test(dni) === true) {
                numero = dni.substr(0, dni.length - 1);
                numero = numero.replace('X', 0);
                numero = numero.replace('Y', 1);
                numero = numero.replace('Z', 2);
                letraAux = dni.substr(dni.length - 1, 1);
                numero = numero % 23;
                letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
                letra = letra.substring(numero, numero + 1);
                if (letra !== letraAux) {
                    valido = false;
                }
                else {
                    valido = true;
                }
            }
            else {
                valido = false;
            }
        }
        else {
            valido = true;
        }
        // if it's valid, return the value to the model,
        // otherwise return undefined.
        return valido;
    }
    isNifValido(identificador) {
        let valido;
        if (identificador) {
            // test and set the validity after update.
            let numero;
            let letraAux;
            let letra;
            const expresion_regular_dni = /^\d{8}[A-Z]$/;
            const dni = identificador.toUpperCase();
            if (expresion_regular_dni.test(dni) === true) {
                numero = dni.substr(0, dni.length - 1);
                numero = numero.replace('X', 0);
                numero = numero.replace('Y', 1);
                numero = numero.replace('Z', 2);
                letraAux = dni.substr(dni.length - 1, 1);
                numero = numero % 23;
                letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
                letra = letra.substring(numero, numero + 1);
                if (letra !== letraAux) {
                    valido = false;
                }
                else {
                    valido = true;
                }
            }
            else {
                valido = false;
            }
        }
        else {
            valido = true;
        }
        // if it's valid, return the value to the model,
        // otherwise return undefined.
        return valido;
    }
    isCifValido(identificador) {
        let valido;
        if (identificador) {
            // test and set the validity after update.
            const expresion_regular_1 = /^[ABEH][0-9]{8}$/i;
            const expresion_regular_2 = /^[KPQS][0-9]{7}[A-J]$/i;
            const expresion_regular_3 = /^[CDFGJLMNRUVW][0-9]{7}[0-9A-J]$/i;
            const cif = identificador.toUpperCase();
            if ((expresion_regular_1.test(cif) === true) ||
                (expresion_regular_2.test(cif) === true) ||
                (expresion_regular_3.test(cif) === true)) {
                const control = cif[cif.length - 1];
                let sum_a = 0;
                let sum_b = 0;
                for (let i = 1; i < 8; i++) {
                    if (i % 2 == 0) {
                        sum_a += parseInt(cif[i], 10);
                    }
                    else {
                        const aux_a = parseInt(cif[i], 10) * 2;
                        let aux_b = 0;
                        if (aux_a > 9) {
                            aux_b = 1 + (aux_a - 10);
                        }
                        else {
                            aux_b = aux_a;
                        }
                        sum_b += aux_b;
                    }
                }
                const sum_c = (parseInt((sum_a + sum_b).toString(), 10)) + '';
                const sum_d = (10 - (parseInt(sum_c[sum_c.length - 1], 10))) % 10;
                const letters = 'JABCDEFGHI';
                if (control >= 0 && control <= '9') {
                    valido = (control == sum_d);
                }
                else {
                    valido = ((control.toUpperCase()) == letters[sum_d]);
                }
            }
            else {
                valido = false;
            }
        }
        else {
            valido = true;
        }
        return valido;
    }
}
IdentificationService.ɵfac = function IdentificationService_Factory(t) { return new (t || IdentificationService)(); };
IdentificationService.ɵprov = ɵɵdefineInjectable({ factory: function IdentificationService_Factory() { return new IdentificationService(); }, token: IdentificationService, providedIn: "root" });
IdentificationService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IdentificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ValidateCifNifNieDirective {
    constructor(identificationService) {
        this.identificationService = identificationService;
        /**
         * Accepted values (as string or as list): 'CIF', 'NIF', 'NIE'.
         *
         * With any other string, value is always valid.
         *
         * Default: validates NIF, NIE or CIF.
         */
        this.documents = [];
    }
    validate(c) {
        const error = {
            validateCifNifNie: true,
        };
        const documentsToValidate = typeof this.documents === 'string' && this.documents ? [this.documents] : this.documents;
        if (documentsToValidate && documentsToValidate.filter(Boolean).length > 0) {
            // check indicated types of document
            let oneIsValid = false;
            for (const documentType of documentsToValidate) {
                switch (documentType.toUpperCase()) {
                    case 'CIF':
                        oneIsValid = this.identificationService.isCifValido(c.value);
                        break;
                    case 'NIF':
                        oneIsValid = this.identificationService.isNifValido(c.value);
                        break;
                    case 'NIE':
                        oneIsValid = this.identificationService.isNieValido(c.value);
                        break;
                    default:
                        oneIsValid = true;
                        break;
                }
                if (oneIsValid) { // at least one validator is correct
                    return null;
                }
            }
            return error;
        }
        else {
            /// check all options
            if (!this.identificationService.isCifValido(c.value)
                && !this.identificationService.isNifValido(c.value)
                && !this.identificationService.isNieValido(c.value)) {
                return error;
            }
        }
        return null;
    }
}
ValidateCifNifNieDirective.ɵfac = function ValidateCifNifNieDirective_Factory(t) { return new (t || ValidateCifNifNieDirective)(ɵngcc0.ɵɵdirectiveInject(IdentificationService)); };
ValidateCifNifNieDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ValidateCifNifNieDirective, selectors: [["", "fwValidateCifNifNie", ""]], inputs: { documents: ["fwValidateCifNifNie", "documents"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateCifNifNieDirective), multi: true }
        ])] });
ValidateCifNifNieDirective.ctorParameters = () => [
    { type: IdentificationService }
];
ValidateCifNifNieDirective.propDecorators = {
    documents: [{ type: Input, args: ['fwValidateCifNifNie',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidateCifNifNieDirective, [{
        type: Directive,
        args: [{
                selector: '[fwValidateCifNifNie]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateCifNifNieDirective), multi: true }
                ]
            }]
    }], function () { return [{ type: IdentificationService }]; }, { documents: [{
            type: Input,
            args: ['fwValidateCifNifNie']
        }] }); })();

class FwValidatorModule {
}
FwValidatorModule.ɵfac = function FwValidatorModule_Factory(t) { return new (t || FwValidatorModule)(); };
FwValidatorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FwValidatorModule });
FwValidatorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FwValidatorModule, { declarations: [ValidateCifNifNieDirective, ValidateIbanDirective, ValidateMinValueDirective, ValidateMaxlengthHtmlDirective, ValidateEqualDirective], exports: [ValidateCifNifNieDirective, ValidateIbanDirective, ValidateMinValueDirective, ValidateMaxlengthHtmlDirective, ValidateEqualDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwValidatorModule, [{
        type: NgModule,
        args: [{
                declarations: [ValidateCifNifNieDirective, ValidateIbanDirective, ValidateMinValueDirective,
                    ValidateMaxlengthHtmlDirective, ValidateEqualDirective],
                imports: [],
                exports: [ValidateCifNifNieDirective, ValidateIbanDirective, ValidateMinValueDirective,
                    ValidateMaxlengthHtmlDirective, ValidateEqualDirective]
            }]
    }], null, null); })();

class FwFormsModule {
}
FwFormsModule.ɵfac = function FwFormsModule_Factory(t) { return new (t || FwFormsModule)(); };
FwFormsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FwFormsModule });
FwFormsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
    ], imports: [[
            CommonModule, FormsModule, NgbDatepickerModule, ReactiveFormsModule, EditorModule, FwValidatorModule
        ], FwValidatorModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FwFormsModule, { declarations: function () { return [MultipleSelectionComponent, SelectAllComponent, SelectElementComponent, TextComponent, DateComponent, SelectEnumComponent, NumberComponent, ValueComponent, CustomInputComponent, BooleanComponent, TextareaComponent, FormEditComponent, FormHeaderButtonsComponent, FormSaveComponent, FormSaveContinueComponent, FormCancelComponent, FormFooterButtonsComponent, FormComponent, FormWrapperComponent, LabelComponent, ErrorComponent, ValidationComponent, DatetimeComponent, SelectComponent, EmptyListComponent, TableComponent, DebounceDirective, AutofocusDirective, RichEditorComponent]; }, imports: function () { return [CommonModule, FormsModule, NgbDatepickerModule, ReactiveFormsModule, EditorModule, FwValidatorModule]; }, exports: function () { return [MultipleSelectionComponent, SelectAllComponent, TableComponent, DateComponent, SelectElementComponent, TextComponent, EmptyListComponent, DatetimeComponent, SelectEnumComponent, NumberComponent, ValueComponent, CustomInputComponent, BooleanComponent, TextareaComponent, FormCancelComponent, FormSaveComponent, FormSaveContinueComponent, FormEditComponent, FormHeaderButtonsComponent, FormFooterButtonsComponent, FormComponent, FormWrapperComponent, LabelComponent, ValidationComponent, ErrorComponent, SelectComponent, DebounceDirective, AutofocusDirective, RichEditorComponent, FwValidatorModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwFormsModule, [{
        type: NgModule,
        args: [{
                declarations: [MultipleSelectionComponent, SelectAllComponent,
                    SelectElementComponent, TextComponent, DateComponent,
                    SelectEnumComponent, NumberComponent, ValueComponent, CustomInputComponent, BooleanComponent,
                    TextareaComponent, FormEditComponent, FormHeaderButtonsComponent, FormSaveComponent, FormSaveContinueComponent,
                    FormCancelComponent, FormFooterButtonsComponent, FormComponent, FormWrapperComponent, LabelComponent, ErrorComponent,
                    ValidationComponent, DatetimeComponent,
                    SelectComponent, EmptyListComponent, TableComponent,
                    DebounceDirective, AutofocusDirective, RichEditorComponent],
                imports: [
                    CommonModule, FormsModule, NgbDatepickerModule, ReactiveFormsModule, EditorModule, FwValidatorModule
                ],
                exports: [
                    MultipleSelectionComponent, SelectAllComponent, TableComponent, DateComponent,
                    SelectElementComponent, TextComponent, EmptyListComponent, DatetimeComponent,
                    SelectEnumComponent, NumberComponent, ValueComponent, CustomInputComponent, BooleanComponent,
                    TextareaComponent, FormCancelComponent, FormSaveComponent, FormSaveContinueComponent, FormEditComponent,
                    FormHeaderButtonsComponent, FormFooterButtonsComponent, FormComponent, FormWrapperComponent, LabelComponent,
                    ValidationComponent, ErrorComponent, SelectComponent, DebounceDirective,
                    AutofocusDirective, RichEditorComponent,
                    FwValidatorModule
                ],
                providers: [
                    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
                ]
            }]
    }], null, null); })();

/**
 * Angular bootstrap Date adapter
 */
class NgbDateStringAdapter extends NgbDateAdapter {
    fromModel(date) {
        if (date != null) {
            const dateFragments = date.toString().split('-');
            return { year: +dateFragments[0], month: +dateFragments[1], day: +dateFragments[2] };
        }
        return null;
    }
    toModel(date) {
        return date ? this.pad(date.year, 4) + '-' + this.pad(date.month, 2) + '-' + this.pad(date.day, 2) : null;
    }
    pad(num, size) {
        let s = num + '';
        while (s.length < size) {
            s = '0' + s;
        }
        return s;
    }
}
NgbDateStringAdapter.ɵfac = function NgbDateStringAdapter_Factory(t) { return ɵNgbDateStringAdapter_BaseFactory(t || NgbDateStringAdapter); };
NgbDateStringAdapter.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NgbDateStringAdapter, factory: NgbDateStringAdapter.ɵfac });
const ɵNgbDateStringAdapter_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(NgbDateStringAdapter);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgbDateStringAdapter, [{
        type: Injectable
    }], null, null); })();

/*
 * Public API Surface of forms
 */

// Angular makes it impossible to make modules optional :(
// try {
//   const _ = r('lodash');
//   _template = _.template;
//   _templateSettings = _.templateSetting
// } catch (e) {
//   try {
//     _template = r('lodash.template');
//     _templateSettings = r('lodash.templatesettings');
//   } catch (e) {
//     _template = (y) => (x) => y;
//     _templateSettings = {};
//   }
// } finally {
//   _templateSettings.interpolate = /{{([\s\S]+?)}}/g;
// }
const _ = {
    template: template,
    templateSettings: templateSettings
};
_.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
function stringFormat(template, binding) {
    const compiled = _.template(template);
    return compiled(binding);
}
function isPromise(value) {
    return value && (typeof value.then === 'function');
}
function wrapIntoObservable(value) {
    if (value instanceof Observable) {
        return value;
    }
    if (isPromise(value)) {
        return from(Promise.resolve(value));
    }
    return of(value);
}

class FwBreadcrumbsConfig {
}
FwBreadcrumbsConfig.ɵfac = function FwBreadcrumbsConfig_Factory(t) { return new (t || FwBreadcrumbsConfig)(); };
FwBreadcrumbsConfig.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FwBreadcrumbsConfig, factory: FwBreadcrumbsConfig.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwBreadcrumbsConfig, [{
        type: Injectable
    }], null, null); })();

class FwBreadcrumbsResolver {
    resolve(route, state) {
        const data = route.routeConfig.data;
        const path = this.getFullPath(route);
        let text = typeof (data.breadcrumbs) === 'string' ? data.breadcrumbs : data.breadcrumbs.text || data.text || path;
        text = stringFormat(text, route.data);
        const crumbs = [{
                text: text,
                path: path
            }];
        return of(crumbs);
    }
    getFullPath(route) {
        const relativePath = (segments) => segments.reduce((a, v) => a += '/' + v.path, '');
        const fullPath = (routes) => routes.reduce((a, v) => a += relativePath(v.url), '');
        return fullPath(route.pathFromRoot);
    }
}

class FwBreadcrumbsService {
    constructor(_router, route, _config, _injector) {
        this._router = _router;
        this._config = _config;
        this._injector = _injector;
        this._breadcrumbs = new BehaviorSubject([]);
        this._defaultResolver = new FwBreadcrumbsResolver();
        this._router.events
            .pipe(filter((x) => x instanceof NavigationEnd))
            .subscribe((event) => {
            const currentRoot = _router.routerState.snapshot.root;
            // Observable.of(this._config.prefixCrumbs)
            this._resolveCrumbs(currentRoot).pipe(flatMap((x) => x), distinct((x) => x.text), toArray(), flatMap((x) => {
                if (this._config.postProcess) {
                    const y = this._config.postProcess(x);
                    return wrapIntoObservable(y).pipe(first());
                }
                else {
                    return of(x);
                }
            }))
                .subscribe((x) => {
                this._breadcrumbs.next(x);
            });
        });
    }
    get crumbs$() {
        return this._breadcrumbs;
    }
    _resolveCrumbs(route) {
        let crumbs$;
        const data = route.routeConfig &&
            route.routeConfig.data;
        if (data && data.breadcrumbs) {
            let resolver;
            if (data.breadcrumbs.prototype instanceof FwBreadcrumbsResolver) {
                resolver = this._injector.get(data.breadcrumbs);
            }
            else {
                resolver = this._defaultResolver;
            }
            const result = resolver.resolve(route, this._router.routerState.snapshot);
            crumbs$ = wrapIntoObservable(result).pipe(first());
        }
        else {
            crumbs$ = of([]);
        }
        if (route.firstChild) {
            crumbs$ = crumbs$.pipe(concat(this._resolveCrumbs(route.firstChild)));
        }
        return crumbs$;
    }
}
FwBreadcrumbsService.ɵfac = function FwBreadcrumbsService_Factory(t) { return new (t || FwBreadcrumbsService)(ɵngcc0.ɵɵinject(ɵngcc8.Router), ɵngcc0.ɵɵinject(ɵngcc8.ActivatedRoute), ɵngcc0.ɵɵinject(FwBreadcrumbsConfig), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
FwBreadcrumbsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FwBreadcrumbsService, factory: FwBreadcrumbsService.ɵfac });
FwBreadcrumbsService.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute },
    { type: FwBreadcrumbsConfig },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwBreadcrumbsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Router }, { type: ɵngcc8.ActivatedRoute }, { type: FwBreadcrumbsConfig }, { type: ɵngcc0.Injector }]; }, null); })();

class BreadcrumbsComponent {
    constructor(service) {
        this.service = service;
        this.subscriptions = new Array();
    }
    ngOnInit() {
        const s = this.service.crumbs$.subscribe((x) => {
            this.crumbs = x;
        });
    }
    ngOnDestroy() {
        this.subscriptions.forEach((x) => x.unsubscribe());
    }
}
BreadcrumbsComponent.ɵfac = function BreadcrumbsComponent_Factory(t) { return new (t || BreadcrumbsComponent)(ɵngcc0.ɵɵdirectiveInject(FwBreadcrumbsService)); };
BreadcrumbsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbsComponent, selectors: [["fw-breadcrumbs"]], decls: 1, vars: 1, consts: [["class", "breadcrumb mt-0 mb-0", 4, "ngIf"], [1, "breadcrumb", "mt-0", "mb-0"], ["class", "breadcrumb-item", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "breadcrumb-item", 3, "ngClass"], [3, "routerLink", "queryParams", 4, "ngIf"], [4, "ngIf"], [3, "routerLink", "queryParams"]], template: function BreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BreadcrumbsComponent_ol_0_Template, 2, 1, "ol", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.crumbs.length);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc3.NgClass, ɵngcc8.RouterLinkWithHref], encapsulation: 2 });
BreadcrumbsComponent.ctorParameters = () => [
    { type: FwBreadcrumbsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'fw-breadcrumbs',
                template: "<ol *ngIf=\"crumbs.length\" class=\"breadcrumb mt-0 mb-0\">\r\n  <li *ngFor=\"let crumb of crumbs; let last = last\" [ngClass]=\"{ 'active': last }\" class=\"breadcrumb-item\">\r\n    <a  *ngIf=\"!last && crumb.path\" [routerLink]=\"crumb.path\" [queryParams]=\"crumb.params\">{{ crumb.text }}</a>\r\n      <span *ngIf=\"last || !crumb.path\">{{ crumb.text }}</span>\r\n  </li>\r\n</ol>\r\n"
            }]
    }], function () { return [{ type: FwBreadcrumbsService }]; }, null); })();

class FwBreadcrumbsModule {
    static forRoot() {
        return {
            ngModule: FwBreadcrumbsModule,
            providers: [
                FwBreadcrumbsService,
                FwBreadcrumbsConfig
            ]
        };
    }
}
FwBreadcrumbsModule.ɵfac = function FwBreadcrumbsModule_Factory(t) { return new (t || FwBreadcrumbsModule)(); };
FwBreadcrumbsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FwBreadcrumbsModule });
FwBreadcrumbsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ToastrModule.forRoot(), RouterModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FwBreadcrumbsModule, { declarations: function () { return [BreadcrumbsComponent]; }, imports: function () { return [CommonModule, ɵngcc1.ToastrModule, RouterModule]; }, exports: function () { return [BreadcrumbsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwBreadcrumbsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ToastrModule.forRoot(), RouterModule],
                declarations: [BreadcrumbsComponent],
                exports: [BreadcrumbsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of breadcrumbs
 */

class FwPaginationConfig {
    constructor() {
        this.pageSize = 20;
        this.classesOrderAscIcon = 'fas fa-sort-up';
        this.classesOrderDescIcon = 'fas fa-sort-down';
        this.i18n = {};
    }
}
FwPaginationConfig.ɵfac = function FwPaginationConfig_Factory(t) { return new (t || FwPaginationConfig)(); };
FwPaginationConfig.ɵprov = ɵɵdefineInjectable({ factory: function FwPaginationConfig_Factory() { return new FwPaginationConfig(); }, token: FwPaginationConfig, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwPaginationConfig, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class Order {
    constructor(field, direction) {
        this.field = field;
        this.direction = direction;
    }
}
var Direction;
(function (Direction) {
    Direction["ASC"] = "asc";
    Direction["DESC"] = "desc";
})(Direction || (Direction = {}));

class FwOrderDirective {
    constructor(el) {
        this.orderChange = new EventEmitter();
        this.orderChildChange = new EventEmitter();
        this.element = el.nativeElement;
    }
    sort(field) {
        this.resetClasses();
        if (field[0].field !== this.order[0].field) {
            this.order = field;
        }
        else {
            for (const orden of this.order) {
                if (orden.direction === Direction.ASC) {
                    orden.direction = Direction.DESC;
                }
                else {
                    orden.direction = Direction.ASC;
                }
            }
            this.order = [...this.order];
        }
        this.orderChange.emit(this.order);
    }
    resetClasses() {
        const allThIcons = this.element.querySelectorAll('.icono-orden');
        // Use normal loop instead of forEach because IE does not support forEach on NodeList.
        for (let i = 0; i < allThIcons.length; i++) {
            allThIcons[i].remove();
        }
    }
    ngOnChanges(changes) {
        this.resetClasses();
        this.orderChildChange.emit();
    }
}
FwOrderDirective.ɵfac = function FwOrderDirective_Factory(t) { return new (t || FwOrderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FwOrderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FwOrderDirective, selectors: [["", "fwOrder", ""]], inputs: { order: ["fwOrder", "order"] }, outputs: { orderChange: "fwOrderChange", orderChildChange: "fwOrderChildChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
FwOrderDirective.ctorParameters = () => [
    { type: ElementRef }
];
FwOrderDirective.propDecorators = {
    order: [{ type: Input, args: ['fwOrder',] }],
    orderChange: [{ type: Output, args: ['fwOrderChange',] }],
    orderChildChange: [{ type: Output, args: ['fwOrderChildChange',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwOrderDirective, [{
        type: Directive,
        args: [{
                selector: '[fwOrder]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { orderChange: [{
            type: Output,
            args: ['fwOrderChange']
        }], orderChildChange: [{
            type: Output,
            args: ['fwOrderChildChange']
        }], order: [{
            type: Input,
            args: ['fwOrder']
        }] }); })();

class FwOrdenByDirective {
    constructor(fwOrder, el, renderer, renderer2, config) {
        this.el = el;
        this.renderer = renderer;
        this.renderer2 = renderer2;
        this.config = config;
        this._fwOrderBy = [];
        this.fwOrder = fwOrder;
    }
    set fwOrderBy(valor) {
        if (this.isOrder(valor)) {
            this._fwOrderBy = valor;
        }
        else { // Es string
            this._fwOrderBy = valor.split(',').map(s => new Order(s, Direction.ASC));
        }
    }
    isOrder(valor) {
        return valor.keys !== undefined;
    }
    ngAfterViewInit() {
        this.renderer2.setStyle(this.el.nativeElement, 'cursor', 'pointer');
        this.renderer2.setStyle(this.el.nativeElement, 'color', 'black');
        if (this.fwOrder.order[0].field && this.fwOrder.order[0].field === this._fwOrderBy[0].field) {
            this.applyClass();
        }
        this.fwOrder.orderChildChange.subscribe(data => {
            if (this.fwOrder.order[0].field === this._fwOrderBy[0].field) {
                this.applyClass();
            }
        });
    }
    onClick() {
        if (this.fwOrder.order[0].field && this.fwOrder.order[0].field !== '_score') {
            this.fwOrder.sort(this._fwOrderBy);
            this.applyClass();
        }
    }
    applyClass() {
        const childSpan = this.el.nativeElement;
        let add = '<span class="icono-orden"><span class="' + this.config.classesOrderAscIcon + '" style="margin-left:5px"></span></span>';
        if (this.fwOrder.order[0].direction === Direction.DESC) {
            add = '<span class="icono-orden"><span class="' + this.config.classesOrderDescIcon + '" style="margin-left:5px"></span></span>';
        }
        childSpan.insertAdjacentHTML('beforeend', add);
    }
}
FwOrdenByDirective.ɵfac = function FwOrdenByDirective_Factory(t) { return new (t || FwOrdenByDirective)(ɵngcc0.ɵɵdirectiveInject(FwOrderDirective, 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(FwPaginationConfig)); };
FwOrdenByDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FwOrdenByDirective, selectors: [["", "fwOrderBy", ""]], hostBindings: function FwOrdenByDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FwOrdenByDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { fwOrderBy: "fwOrderBy" } });
FwOrdenByDirective.ctorParameters = () => [
    { type: FwOrderDirective, decorators: [{ type: Host }] },
    { type: ElementRef },
    { type: Renderer2 },
    { type: Renderer2 },
    { type: FwPaginationConfig }
];
FwOrdenByDirective.propDecorators = {
    fwOrderBy: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwOrdenByDirective, [{
        type: Directive,
        args: [{
                selector: '[fwOrderBy]'
            }]
    }], function () { return [{ type: FwOrderDirective, decorators: [{
                type: Host
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.Renderer2 }, { type: FwPaginationConfig }]; }, { fwOrderBy: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

/**
 * An utility service for pagination
 */
class FwPaginacionUtil {
    /**
     * Method to find whether the sort is defined
     */
    parseDireccion(sort) {
        let sortArray = sort.split(',');
        sortArray = sortArray.length > 1 ? sortArray : sort.split('%2C');
        if (sortArray.length > 1) {
            if (sortArray.slice(-1)[0] === 'asc') {
                return Direction.ASC;
            }
            else {
                return Direction.DESC;
            }
        }
        // default to DESC if no sort is defined
        return Direction.ASC;
    }
    /**
     * Method to sort can be in the format `id,asc` or `id`
     */
    parsePredicate(sort) {
        return sort.split(',')[0].split('%2C')[0];
    }
    sort(ordenes) {
        if (ordenes) {
            const result = [];
            let incluyeId = false;
            ordenes.forEach(function (orden) {
                if (orden.field === 'id') {
                    incluyeId = true;
                }
                result.push(orden.field + ',' + orden.direction);
            });
            if (!incluyeId) {
                result.push('id');
            }
            return result;
        }
    }
}
FwPaginacionUtil.ɵfac = function FwPaginacionUtil_Factory(t) { return new (t || FwPaginacionUtil)(); };
FwPaginacionUtil.ɵprov = ɵɵdefineInjectable({ factory: function FwPaginacionUtil_Factory() { return new FwPaginacionUtil(); }, token: FwPaginacionUtil, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwPaginacionUtil, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class Pageable {
    constructor(page, size, sort) {
        this.page = page;
        this.size = size;
        this.sort = sort;
    }
}

/**
 * Directiva de paginación: Sincroniza la url con el número de página, filtro y orden de forma transparente
 * para el desarrollador. TODO refactorizar...
 */
class FwPaginacionComponent {
    constructor(activatedRoute, router, paginationUtil, config) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.paginationUtil = paginationUtil;
        this.config = config;
        this.filter = {}; // TODO ¿Hacer parametrizable?
        this.showTotalElements = true;
        this.maxSize = 5;
        this.textShowingFrom = this.config.i18n.showingFrom || 'Showing results from';
        this.textShowingTo = this.config.i18n.showingTo || 'to';
        this.textShowingOf = this.config.i18n.showingOf || 'of';
        this.pageChange = new EventEmitter();
        this.orderChange = new EventEmitter();
        this.filterChange = new EventEmitter();
        this.inicializado = false;
        // TODO Mover a una clase de utilidades o similar
        this.hasOwnNestedProperty = function (obj, propertyPath) {
            if (!propertyPath) {
                return false;
            }
            const properties = propertyPath.split('.');
            for (let i = 0; i < properties.length; i++) {
                const prop = properties[i];
                if (!obj || !obj.hasOwnProperty(prop)) {
                    return false;
                }
                else {
                    obj = obj[prop];
                }
            }
            return true;
        };
        this.assign = function assign(obj, prop, value) {
            if (typeof prop === 'string') {
                prop = prop.split('.');
            }
            if (prop.length > 1 && value != undefined) {
                const e = prop.shift();
                assign(obj[e] =
                    Object.prototype.toString.call(obj[e]) === '[object Object]'
                        ? obj[e]
                        : {}, prop, value);
            }
            else {
                obj[prop[0]] = value;
            }
        };
        this.getDescendantProp = function (obj, desc) {
            const arr = desc.split('.');
            while (arr.length && (obj = obj[arr.shift()])) {
            }
            return obj;
        };
    }
    ngOnChanges(changes) {
        const cambiaOrden = changes.order && this.orderSent !== changes.order.currentValue;
        const cambiaFiltro = changes.filter != null;
        if (this.inicializado && this.totalElements !== null && (cambiaOrden || cambiaFiltro)) {
            this.page = 1;
            this.previousPage = this.page;
            this.transition();
        }
    }
    /**
     * Solamente se obtendrán nuevos elementos cuando cambie la url. Este método se encarga de procesar la url y
     * extraer los párametros.
     */
    ngOnInit() {
        this.itemsPerPage = this.pageSize || this.config.pageSize; // TODO esto lo sacaremos de la configuración
        this.filtroCopia = cloneDeep(this.filter);
        this.routeData = this.activatedRoute.queryParams.subscribe(data => {
            this.handleParamChange(data);
        });
    }
    reload() {
        this.itemsPerPage = this.pageSize || this.config.pageSize; // TODO esto lo sacaremos de la configuración
        this.filtroCopia = cloneDeep(this.filter);
        this.handleParamChange(this.activatedRoute.snapshot.queryParams);
    }
    handleParamChange(data) {
        // Cargar contexto a partir de la url
        const filtroPlano2 = this.flattenConPrefijos(this.filter);
        for (const key of Object.keys(data)) {
            if (key === 'sort') { // Orden
                this.order = [];
                if (Array.isArray(data.sort)) {
                    for (const sort of data.sort) {
                        this.order.push({
                            field: this.paginationUtil.parsePredicate(sort),
                            direction: this.paginationUtil.parseDireccion(sort)
                        });
                    }
                }
                else {
                    this.order.push({
                        field: this.paginationUtil.parsePredicate(data.sort),
                        direction: this.paginationUtil.parseDireccion(data.sort)
                    });
                }
            }
            else if (key === 'page') { // Página
                this.page = data.page;
                this.previousPage = data.page;
            }
            else { // Filtro (o no) : enlazamos como podamos
                if (String(filtroPlano2[key]) !== data[key]) {
                    if (Array.isArray(this.getDescendantProp(this.filter, key)) && data[key] !== '') { // FIX ME chapuza para arreglar valoresCaracteristica
                        this.assign(this.filter, key, data[key].split(','));
                    }
                    else {
                        this.assign(this.filter, key, data[key]);
                    }
                }
            }
        }
        this.page = data.page || 1;
        // Las propiedades del filtro que no estén ni en el filtro inicial ni en la ruta las borramos
        const filtroPlano = this.flattenConPrefijos(this.filter);
        const filtroCopiaPlano = this.flattenConPrefijos(this.filtroCopia);
        for (const key of Object.keys(filtroPlano)) {
            if (filtroPlano[key] !== null && filtroPlano[key] !== filtroCopiaPlano[key] && String(filtroPlano[key]) !== String(data[key])) {
                this.assign(this.filter, key, undefined);
            }
        }
        // Propagar cambios
        setTimeout(() => {
            // Propagación de eventos
            this.orderChange.emit(this.order);
            this.orderSent = this.order;
            this.inicializado = true;
            this.pageChange.emit([this.getCurrentPageable(), this.filter]);
        }, 0);
    }
    ngOnDestroy() {
        if (this.routeData) {
            this.routeData.unsubscribe();
        }
    }
    loadPage(page) {
        if (this.previousPage !== page) {
            this.previousPage = page;
            this.transition();
        }
        else {
            this.previousPage = page;
        }
    }
    transition() {
        let queryParams = {};
        if (this.page && this.page > 1) {
            queryParams['page'] = this.page;
        }
        if (this.order && this.order.length > 0) {
            const listaAux = [];
            this.order.forEach(function (orden) {
                listaAux.push(orden.field + ',' + orden.direction);
            });
            queryParams['sort'] = listaAux;
        }
        // Las propiedades iniciales del filtro no deben saler en la url
        const filtroPlano = this.flattenConPrefijos(this.filter);
        for (const key of Object.keys(filtroPlano)) {
            if (filtroPlano[key] === this.getDescendantProp(this.filtroCopia, key)) {
                filtroPlano[key] = null;
            }
        }
        queryParams = Object.assign(queryParams, filtroPlano);
        this.router.navigate([], {
            queryParams
        });
    }
    getCurrentPageable() {
        return new Pageable(this.page - 1, this.itemsPerPage, this.paginationUtil.sort(this.order));
    }
    flattenConPrefijos(object, separator = '.') {
        const isValidObject = (value) => {
            if (!value) {
                return false;
            }
            const isArray = Array.isArray(value);
            const isΟbject = Object.prototype.toString.call(value) === '[object Object]';
            const hasKeys = !!Object.keys(value).length;
            return !isArray && isΟbject && hasKeys;
        };
        const walker = (child, path = []) => {
            return Object.assign({}, ...Object.keys(child).map(key => {
                if (isValidObject(child[key])) {
                    return walker(child[key], path.concat([key]));
                }
                else {
                    if (!Array.isArray(child[key])) {
                        return { [path.concat([key]).join(separator)]: child[key] };
                    }
                    else {
                        return { [path.concat([key]).join(separator)]: child[key].join() };
                    }
                }
            }));
        };
        const removeEmpty = obj => {
            Object.keys(obj).forEach(key => (obj[key] == null || obj[key] === '') && delete obj[key]);
        };
        const flatted = Object.assign({}, walker(object));
        removeEmpty(flatted);
        return flatted;
    }
}
FwPaginacionComponent.ɵfac = function FwPaginacionComponent_Factory(t) { return new (t || FwPaginacionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc8.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.Router), ɵngcc0.ɵɵdirectiveInject(FwPaginacionUtil), ɵngcc0.ɵɵdirectiveInject(FwPaginationConfig)); };
FwPaginacionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FwPaginacionComponent, selectors: [["fw-pagination"]], inputs: { filter: "filter", showTotalElements: "showTotalElements", maxSize: "maxSize", textShowingFrom: "textShowingFrom", textShowingTo: "textShowingTo", textShowingOf: "textShowingOf", order: "order", totalElements: "totalElements", pageSize: "pageSize" }, outputs: { pageChange: "pageChange", orderChange: "orderChange", filterChange: "filterChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "row pagination-wrapper", 4, "ngIf"], [1, "row", "pagination-wrapper"], ["class", "col-12 col-sm-6 pagination-results", 4, "ngIf"], ["class", "col-12 col-sm-6", 4, "ngIf"], [1, "col-12", "col-sm-6", "pagination-results"], [4, "ngIf"], [1, "col-12", "col-sm-6"], [1, "float-right", 3, "collectionSize", "page", "pageSize", "maxSize", "rotate", "boundaryLinks", "directionLinks", "pageChange"]], template: function FwPaginacionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FwPaginacionComponent_div_0_Template, 3, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.totalElements);
    } }, directives: [ɵngcc3.NgIf, ɵngcc2.NgbPagination], styles: [".pagination-wrapper[_ngcontent-%COMP%]{margin-top:20px}.pagination-results[_ngcontent-%COMP%]{margin-bottom:10px}"] });
FwPaginacionComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: FwPaginacionUtil },
    { type: FwPaginationConfig }
];
FwPaginacionComponent.propDecorators = {
    totalElements: [{ type: Input }],
    filter: [{ type: Input }],
    order: [{ type: Input }],
    pageSize: [{ type: Input }],
    showTotalElements: [{ type: Input }],
    maxSize: [{ type: Input }],
    textShowingFrom: [{ type: Input }],
    textShowingTo: [{ type: Input }],
    textShowingOf: [{ type: Input }],
    pageChange: [{ type: Output }],
    orderChange: [{ type: Output }],
    filterChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwPaginacionComponent, [{
        type: Component,
        args: [{
                selector: 'fw-pagination',
                template: "<div class=\"row pagination-wrapper\" *ngIf=\"totalElements\">\r\n    <div class=\"col-12 col-sm-6 pagination-results\" *ngIf=\"showTotalElements\">\r\n        <ng-container>{{textShowingFrom}}</ng-container>\r\n        {{(page - 1) * itemsPerPage + 1}}\r\n        <ng-container> {{textShowingTo}} </ng-container>\r\n        <span *ngIf=\"(page * itemsPerPage) >=  totalElements\">{{totalElements}}</span>\r\n        <span *ngIf=\"(page * itemsPerPage) <  totalElements\">{{page * itemsPerPage}} </span>\r\n        <ng-container> {{textShowingOf}} </ng-container>\r\n        {{totalElements}}\r\n    </div>\r\n\r\n    <div class=\"col-12 col-sm-6\" *ngIf=\"totalElements > itemsPerPage\">\r\n        <ngb-pagination class=\"float-right\" [collectionSize]=\"totalElements\" [(page)]=\"page\" [pageSize]=\"itemsPerPage\"\r\n                        [maxSize]=\"maxSize\" [rotate]=\"true\" [boundaryLinks]=\"true\" [directionLinks]=\"false\"\r\n                        (pageChange)=\"loadPage(page)\"></ngb-pagination>\r\n    </div>\r\n</div>\r\n",
                styles: [".pagination-wrapper{margin-top:20px}.pagination-results{margin-bottom:10px}"]
            }]
    }], function () { return [{ type: ɵngcc8.ActivatedRoute }, { type: ɵngcc8.Router }, { type: FwPaginacionUtil }, { type: FwPaginationConfig }]; }, { filter: [{
            type: Input
        }], showTotalElements: [{
            type: Input
        }], maxSize: [{
            type: Input
        }], textShowingFrom: [{
            type: Input
        }], textShowingTo: [{
            type: Input
        }], textShowingOf: [{
            type: Input
        }], pageChange: [{
            type: Output
        }], orderChange: [{
            type: Output
        }], filterChange: [{
            type: Output
        }], order: [{
            type: Input
        }], totalElements: [{
            type: Input
        }], pageSize: [{
            type: Input
        }] }); })();

class FwPaginacionSiguienteComponent {
    constructor(config) {
        this.config = config;
        this.pageSize = this.config.pageSize;
        this.textLoadMore = this.config.i18n.loadMore || 'Load more';
        this.page = 1;
        this.change = new EventEmitter();
        this.hasNextPage = true;
    }
    ngOnInit() {
        this.checkHasNextPage();
    }
    ngOnChanges(changes) {
        this.page = 1;
        this.checkHasNextPage();
    }
    loadNext() {
        this.page++;
        this.checkHasNextPage();
        this.change.emit(Number(this.page - 1));
    }
    checkHasNextPage() {
        const pageTotal = Math.trunc((this.totalElements / this.pageSize));
        if (this.page > pageTotal || (this.totalElements % this.pageSize === 0 && this.page === pageTotal)) {
            this.hasNextPage = false;
        }
        else {
            this.hasNextPage = true;
        }
    }
}
FwPaginacionSiguienteComponent.ɵfac = function FwPaginacionSiguienteComponent_Factory(t) { return new (t || FwPaginacionSiguienteComponent)(ɵngcc0.ɵɵdirectiveInject(FwPaginationConfig)); };
FwPaginacionSiguienteComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FwPaginacionSiguienteComponent, selectors: [["fw-show-more"]], inputs: { pageSize: "pageSize", textLoadMore: "textLoadMore", totalElements: "totalElements", orderByChange: "orderByChange" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[1, "d-flex", "justify-content-center"], ["class", "btn btn-outline-dark btn-lg secondary-style my-5", 3, "click", 4, "ngIf"], [1, "btn", "btn-outline-dark", "btn-lg", "secondary-style", "my-5", 3, "click"]], template: function FwPaginacionSiguienteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FwPaginacionSiguienteComponent_button_1_Template, 2, 1, "button", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasNextPage);
    } }, directives: [ɵngcc3.NgIf], styles: [".informacion-lista[_ngcontent-%COMP%]{color:grey;font-size:12px;text-align:center}"] });
FwPaginacionSiguienteComponent.ctorParameters = () => [
    { type: FwPaginationConfig }
];
FwPaginacionSiguienteComponent.propDecorators = {
    totalElements: [{ type: Input }],
    pageSize: [{ type: Input }],
    orderByChange: [{ type: Input }],
    textLoadMore: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwPaginacionSiguienteComponent, [{
        type: Component,
        args: [{
                selector: 'fw-show-more',
                template: "<div class=\"d-flex justify-content-center\">\r\n    <button class=\"btn btn-outline-dark btn-lg secondary-style my-5\" (click)=\"loadNext()\" *ngIf=\"hasNextPage\">\r\n        {{textLoadMore}}\r\n    </button>\r\n</div>\r\n\r\n\r\n",
                styles: [".informacion-lista{color:grey;font-size:12px;text-align:center}"]
            }]
    }], function () { return [{ type: FwPaginationConfig }]; }, { pageSize: [{
            type: Input
        }], textLoadMore: [{
            type: Input
        }], change: [{
            type: Output
        }], totalElements: [{
            type: Input
        }], orderByChange: [{
            type: Input
        }] }); })();

class FwFilterDirective {
    constructor() {
        this.fwFilterChange = new EventEmitter();
    }
    emitirCambios() {
        this.fwFilterChange.emit(Object.assign({}, this.fwFilter));
    }
}
FwFilterDirective.ɵfac = function FwFilterDirective_Factory(t) { return new (t || FwFilterDirective)(); };
FwFilterDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FwFilterDirective, selectors: [["", "fwFilter", ""]], inputs: { fwFilter: "fwFilter" }, outputs: { fwFilterChange: "fwFilterChange" } });
FwFilterDirective.ctorParameters = () => [];
FwFilterDirective.propDecorators = {
    fwFilter: [{ type: Input }],
    fwFilterChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwFilterDirective, [{
        type: Directive,
        args: [{
                selector: '[fwFilter]'
            }]
    }], function () { return []; }, { fwFilterChange: [{
            type: Output
        }], fwFilter: [{
            type: Input
        }] }); })();

class FwFilterByDirective {
    constructor(fwFilter) {
        this.fwFilter = fwFilter;
        if (!fwFilter) {
            console.error('fwFilterBy must have a parent with de fwFiltro directive');
        }
    }
    emitirCambios() {
        if (this.fwFilter) {
            this.fwFilter.emitirCambios();
        }
    }
}
FwFilterByDirective.ɵfac = function FwFilterByDirective_Factory(t) { return new (t || FwFilterByDirective)(ɵngcc0.ɵɵdirectiveInject(FwFilterDirective, 9)); };
FwFilterByDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FwFilterByDirective, selectors: [["", "ngModel", "", "fwFilterBy", ""]], hostBindings: function FwFilterByDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("ngModelChange", function FwFilterByDirective_ngModelChange_HostBindingHandler() { return ctx.emitirCambios(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([NgModel])] });
FwFilterByDirective.ctorParameters = () => [
    { type: FwFilterDirective, decorators: [{ type: Optional }, { type: Host }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwFilterByDirective, [{
        type: Directive,
        args: [{
                selector: '[ngModel][fwFilterBy]',
                providers: [NgModel],
                host: {
                    '(ngModelChange)': 'emitirCambios()'
                }
            }]
    }], function () { return [{ type: FwFilterDirective, decorators: [{
                type: Optional
            }, {
                type: Host
            }] }]; }, null); })();

class FwPaginationModule {
}
FwPaginationModule.ɵfac = function FwPaginationModule_Factory(t) { return new (t || FwPaginationModule)(); };
FwPaginationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FwPaginationModule });
FwPaginationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule, InfiniteScrollModule, NgbPaginationModule], InfiniteScrollModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FwPaginationModule, { declarations: function () { return [FwOrdenByDirective, FwOrderDirective, FwFilterDirective, FwFilterByDirective, FwPaginacionComponent, FwPaginacionSiguienteComponent]; }, imports: function () { return [CommonModule, FormsModule, InfiniteScrollModule, NgbPaginationModule]; }, exports: function () { return [InfiniteScrollModule, FwOrdenByDirective, FwFilterDirective, FwFilterByDirective, FwOrderDirective, FwPaginacionComponent, FwPaginacionSiguienteComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwPaginationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, InfiniteScrollModule, NgbPaginationModule],
                declarations: [FwOrdenByDirective, FwOrderDirective, FwFilterDirective, FwFilterByDirective,
                    FwPaginacionComponent, FwPaginacionSiguienteComponent],
                exports: [InfiniteScrollModule, FwOrdenByDirective, FwFilterDirective, FwFilterByDirective,
                    FwOrderDirective, FwPaginacionComponent, FwPaginacionSiguienteComponent]
            }]
    }], null, null); })();

class Sort {
}

class Page {
}

class Filter {
    constructor() {
        this.equals = null;
    }
}
class RangeFilter {
    constructor() {
        this.greaterThan = null;
        this.greaterOrEqualThan = null;
        this.lessThan = null;
        this.lessOrEqualThan = null;
        this.equals = ''; // TODO Fix temporal! Buscar solución mejor al --Todas las opciones--
        this.specified = null;
        this.in = null;
    }
}
class DoubleFilter {
    constructor() {
        this.greaterThan = null;
        this.greaterOrEqualThan = null;
        this.lessThan = null;
        this.lessOrEqualThan = null;
        this.equals = ''; // TODO Fix temporal! Buscar solución mejor al --Todas las opciones--
        this.specified = null;
        this.in = null;
    }
}
class FloatFilter {
    constructor() {
        this.greaterThan = null;
        this.greaterOrEqualThan = null;
        this.lessThan = null;
        this.lessOrEqualThan = null;
        this.equals = ''; // TODO Fix temporal! Buscar solución mejor al --Todas las opciones--
        this.specified = null;
        this.in = null;
    }
}
class StringFilter {
    constructor() {
        this.contains = '';
        this.equals = '';
        this.specified = null;
        this.in = null;
    }
}
class BooleanFilter {
    constructor() {
        this.equals = null;
        this.specified = null;
        this.in = null;
    }
}
class LongFilter {
    constructor() {
        this.greaterThan = null;
        this.greaterOrEqualThan = null;
        this.lessThan = null;
        this.lessOrEqualThan = null;
        this.equals = ''; // TODO Fix temporal! Buscar solución mejor al --Todas las opciones--
        this.specified = null;
        this.in = null;
    }
}
class IntegerFilter {
    constructor() {
        this.greaterThan = null;
        this.greaterOrEqualThan = null;
        this.lessThan = null;
        this.lessOrEqualThan = null;
        this.equals = ''; // TODO Fix temporal! Buscar solución mejor al --Todas las opciones--
        this.specified = null;
        this.in = null;
    }
}
class ShortFilter {
    constructor() {
        this.greaterThan = null;
        this.greaterOrEqualThan = null;
        this.lessThan = null;
        this.lessOrEqualThan = null;
        this.equals = ''; // TODO Fix temporal! Buscar solución mejor al --Todas las opciones--
        this.specified = null;
        this.in = null;
    }
}
class LocalDateFilter {
    constructor() {
        this.greaterThan = null;
        this.greaterOrEqualThan = null;
        this.lessThan = null;
        this.lessOrEqualThan = null;
        this.equals = null;
        this.specified = null;
        this.in = null;
    }
}
class InstantFilter {
    constructor() {
        this.greaterThan = null;
        this.greaterOrEqualThan = null;
        this.lessThan = null;
        this.lessOrEqualThan = null;
        this.equals = null;
        this.specified = null;
        this.in = null;
    }
}
class BigDecimalFilter {
    constructor() {
        this.greaterThan = null;
        this.greaterOrEqualThan = null;
        this.lessThan = null;
        this.lessOrEqualThan = null;
        this.equals = null;
        this.specified = null;
        this.in = null;
    }
}

/*
 * Public API Surface of fw-pagination
 */

class Store$2 {
    constructor(initialState) {
        this._state$ = new BehaviorSubject(initialState);
        this.state$ = this._state$.asObservable();
    }
    get state() {
        return this._state$.getValue();
    }
    setState(nextState) {
        this._state$.next(nextState);
    }
}
class FwPrincipalService extends Store$2 {
}

/**
 * @whatItDoes Conditionally includes an HTML element if current user has NOT any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *fwDoesntHaveAnyAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *fwDoesntHaveAnyAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
class FwDoesntHaveAnyAuthorityDirective {
    constructor(principal, templateRef, viewContainerRef) {
        this.principal = principal;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
    }
    set fwDoesntHaveAnyAuthority(value) {
        this.authorities = typeof value === 'string' ? [value] : value;
        this.updateView();
        // Get notified each time authentication state changes.
        this.principal.state$.subscribe(identity => this.updateView());
    }
    updateView() {
        this.principal.hasAnyAuthority(this.authorities).then(result => {
            this.viewContainerRef.clear();
            if (!result) {
                this.viewContainerRef.createEmbeddedView(this.templateRef);
            }
        });
    }
}
FwDoesntHaveAnyAuthorityDirective.ɵfac = function FwDoesntHaveAnyAuthorityDirective_Factory(t) { return new (t || FwDoesntHaveAnyAuthorityDirective)(ɵngcc0.ɵɵdirectiveInject(FwPrincipalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
FwDoesntHaveAnyAuthorityDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FwDoesntHaveAnyAuthorityDirective, selectors: [["", "fwDoesntHaveAnyAuthority", ""]], inputs: { fwDoesntHaveAnyAuthority: "fwDoesntHaveAnyAuthority" } });
FwDoesntHaveAnyAuthorityDirective.ctorParameters = () => [
    { type: FwPrincipalService },
    { type: TemplateRef },
    { type: ViewContainerRef }
];
FwDoesntHaveAnyAuthorityDirective.propDecorators = {
    fwDoesntHaveAnyAuthority: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwDoesntHaveAnyAuthorityDirective, [{
        type: Directive,
        args: [{
                selector: '[fwDoesntHaveAnyAuthority]'
            }]
    }], function () { return [{ type: FwPrincipalService }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { fwDoesntHaveAnyAuthority: [{
            type: Input
        }] }); })();

/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *fwHasAnyAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *fwHasAnyAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
class FwHasAnyAuthorityDirective {
    constructor(principal, templateRef, viewContainerRef) {
        this.principal = principal;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
    }
    set fwHasAnyAuthority(value) {
        this.authorities = typeof value === 'string' ? [value] : value;
        this.updateView();
        // Get notified each time authentication state changes.
        this.principal.state$.subscribe(identity => this.updateView());
    }
    updateView() {
        this.principal.hasAnyAuthority(this.authorities).then(result => {
            this.viewContainerRef.clear();
            if (result) {
                this.viewContainerRef.createEmbeddedView(this.templateRef);
            }
        });
    }
}
FwHasAnyAuthorityDirective.ɵfac = function FwHasAnyAuthorityDirective_Factory(t) { return new (t || FwHasAnyAuthorityDirective)(ɵngcc0.ɵɵdirectiveInject(FwPrincipalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
FwHasAnyAuthorityDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FwHasAnyAuthorityDirective, selectors: [["", "fwHasAnyAuthority", ""]], inputs: { fwHasAnyAuthority: "fwHasAnyAuthority" } });
FwHasAnyAuthorityDirective.ctorParameters = () => [
    { type: FwPrincipalService },
    { type: TemplateRef },
    { type: ViewContainerRef }
];
FwHasAnyAuthorityDirective.propDecorators = {
    fwHasAnyAuthority: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwHasAnyAuthorityDirective, [{
        type: Directive,
        args: [{
                selector: '[fwHasAnyAuthority]'
            }]
    }], function () { return [{ type: FwPrincipalService }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { fwHasAnyAuthority: [{
            type: Input
        }] }); })();

class FwAnchorComponent {
    constructor() { }
    ngOnInit() {
    }
}
FwAnchorComponent.ɵfac = function FwAnchorComponent_Factory(t) { return new (t || FwAnchorComponent)(); };
FwAnchorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FwAnchorComponent, selectors: [["fw-anchor"]], inputs: { authorities: "authorities", link: "link" }, ngContentSelectors: _c3, decls: 4, vars: 2, consts: [[4, "fwHasAnyAuthority"], [4, "fwDoesntHaveAnyAuthority"], ["contentTpl", ""], [3, "routerLink"], [4, "ngTemplateOutlet"]], template: function FwAnchorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, FwAnchorComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, FwAnchorComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, FwAnchorComponent_ng_template_2_Template, 1, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("fwHasAnyAuthority", ctx.authorities);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("fwDoesntHaveAnyAuthority", ctx.authorities);
    } }, directives: [FwHasAnyAuthorityDirective, FwDoesntHaveAnyAuthorityDirective, ɵngcc8.RouterLinkWithHref, ɵngcc3.NgTemplateOutlet], encapsulation: 2 });
FwAnchorComponent.ctorParameters = () => [];
FwAnchorComponent.propDecorators = {
    authorities: [{ type: Input }],
    link: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwAnchorComponent, [{
        type: Component,
        args: [{
                selector: 'fw-anchor',
                template: "\r\n<ng-container *fwHasAnyAuthority=\"authorities\">\r\n<a [routerLink]=\"link\">\r\n\t<ng-container *ngTemplateOutlet=\"contentTpl\"></ng-container>\r\n</a>\r\n</ng-container>\r\n\r\n<ng-container *fwDoesntHaveAnyAuthority=\"authorities\">\r\n\t<ng-container *ngTemplateOutlet=\"contentTpl\"></ng-container>\r\n</ng-container>\r\n\r\n<ng-template #contentTpl><ng-content></ng-content></ng-template>\r\n"
            }]
    }], function () { return []; }, { authorities: [{
            type: Input
        }], link: [{
            type: Input
        }] }); })();

class FwAuthModule {
}
FwAuthModule.ɵfac = function FwAuthModule_Factory(t) { return new (t || FwAuthModule)(); };
FwAuthModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FwAuthModule });
FwAuthModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, RouterModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FwAuthModule, { declarations: function () { return [FwDoesntHaveAnyAuthorityDirective, FwHasAnyAuthorityDirective, FwAnchorComponent]; }, imports: function () { return [CommonModule, RouterModule]; }, exports: function () { return [FwDoesntHaveAnyAuthorityDirective, FwHasAnyAuthorityDirective, FwAnchorComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwAuthModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, RouterModule],
                declarations: [FwDoesntHaveAnyAuthorityDirective, FwHasAnyAuthorityDirective, FwAnchorComponent],
                entryComponents: [],
                providers: [],
                exports: [FwDoesntHaveAnyAuthorityDirective, FwHasAnyAuthorityDirective, FwAnchorComponent]
            }]
    }], null, null); })();

class StateStorageService {
    constructor() { }
    getPreviousState() {
        return JSON.parse(sessionStorage.getItem('previousState'));
    }
    resetPreviousState() {
        sessionStorage.removeItem('previousState');
    }
    storePreviousState(previousStateName, previousStateParams) {
        const previousState = { name: previousStateName, params: previousStateParams };
        sessionStorage.setItem('previousState', JSON.stringify((previousState)));
    }
    getDestinationState() {
        return JSON.parse(sessionStorage.getItem('destinationState'));
    }
    storeUrl(url) {
        sessionStorage.setItem('previousUrl', url);
    }
    getUrl() {
        return sessionStorage.getItem('previousUrl');
    }
    storeDestinationState(destinationState, destinationStateParams, fromState) {
        const destinationInfo = {
            destination: {
                name: destinationState.name,
                data: destinationState.data
            },
            params: destinationStateParams,
            from: {
                name: fromState.name
            }
        };
        sessionStorage.setItem('destinationState', JSON.stringify(destinationInfo));
    }
}
StateStorageService.ɵfac = function StateStorageService_Factory(t) { return new (t || StateStorageService)(); };
StateStorageService.ɵprov = ɵɵdefineInjectable({ factory: function StateStorageService_Factory() { return new StateStorageService(); }, token: StateStorageService, providedIn: "root" });
StateStorageService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StateStorageService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/*
 * Public API Surface of fw-auth
 */

class FwOverlayComponent {
    constructor() {
        this.showStatus = true;
    }
}
FwOverlayComponent.ɵfac = function FwOverlayComponent_Factory(t) { return new (t || FwOverlayComponent)(); };
FwOverlayComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FwOverlayComponent, selectors: [["fw-aside-overlay"]], decls: 1, vars: 1, consts: [[1, "overlay"]], template: function FwOverlayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("@show", ctx.showStatus);
    } }, styles: [".overlay[_ngcontent-%COMP%] {\n        z-index: 1;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: currentColor;\n        opacity: .6;\n    }"], data: { animation: [
            trigger('show', [
                transition('void => *', [
                    style([{ opacity: 0 }]),
                    animate(100, style([{ opacity: .6 }]))
                ])
            ])
        ] } });
FwOverlayComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwOverlayComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'fw-aside-overlay',
                template: `
        <div class="overlay" [@show]="showStatus"></div>`,
                animations: [
                    trigger('show', [
                        transition('void => *', [
                            style([{ opacity: 0 }]),
                            animate(100, style([{ opacity: .6 }]))
                        ])
                    ])
                ],
                styles: [`.overlay {
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: currentColor;
        opacity: .6;
    }`]
            }]
    }], function () { return []; }, null); })();

const slideAnimations = trigger('slide', [
    transition('void => left', [
        style({
            opacity: .6,
            transform: 'translate3d(-100%,0,0)'
        }),
        animate('.2s cubic-bezier(0.215, 0.610, 0.355, 1)', style({
            opacity: 1,
            transform: 'translateZ(0)'
        }))
    ]),
    transition('void => right', [
        style({
            opacity: .6,
            transform: 'translate3d(100%,0,0)'
        }),
        animate('.2s cubic-bezier(0.215, 0.610, 0.355, 1)', style({
            opacity: 1,
            transform: 'translateZ(0)'
        }))
    ]),
    transition('left => void', [
        animate('.2s cubic-bezier(0.165, 0.84, 0.44, 1)', style({
            opacity: 0,
            transform: 'translate3d(-50%,0,0)'
        }))
    ]),
    transition('right => void', [
        animate('.2s cubic-bezier(0.165, 0.84, 0.44, 1)', style({
            opacity: 0,
            transform: 'translate3d(50%,0,0)'
        }))
    ])
]);

class FwAsideComponent {
    constructor(_resolver, vcRef) {
        this._resolver = _resolver;
        this.vcRef = vcRef;
        this.cancel = new EventEmitter();
        this.submit = new EventEmitter();
        this.position = 'right';
        this.showOverlay = true;
        this.closeOnEscape = true;
        this.showDefaultFooter = true;
        this.showDefaultHeader = true;
        this.title = '';
        this.cancelButtonTitle = 'Cancel';
        this.submitButtonTitle = 'Submit';
        this.visibleStatus = false;
        this.rootViewContainerRef = vcRef;
    }
    hideAside(event) {
        if (this.cancel.observers.length > 0) {
            this.cancel.emit(event);
        }
        else { // If we don`t have any subscribers
            this.hide();
        }
    }
    submitAside(event) {
        if (this.cancel.observers.length > 0) {
            this.submit.emit();
        }
        else { // If we don`t have any subscribers
            this.hide();
        }
    }
    handleEscape(event) {
        if (this.closeOnEscape) {
            event.preventDefault();
            this.hideAside(event);
        }
        return false;
    }
    hide() {
        this.visibleStatus = false;
        if (!this.backdrop) {
            return;
        }
        this.backdrop.destroy();
        this.backdrop = void 0;
    }
    show() {
        this.visibleStatus = true;
        this.addOverlay();
    }
    addOverlay() {
        if (!this.backdrop && this.showOverlay) {
            const OverlayComponentFactory = this._resolver.resolveComponentFactory(FwOverlayComponent);
            this.backdrop = this.rootViewContainerRef.createComponent(OverlayComponentFactory, 0);
        }
    }
}
FwAsideComponent.ɵfac = function FwAsideComponent_Factory(t) { return new (t || FwAsideComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
FwAsideComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FwAsideComponent, selectors: [["fw-aside"]], hostBindings: function FwAsideComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown.esc", function FwAsideComponent_keydown_esc_HostBindingHandler($event) { return ctx.handleEscape($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { position: "position", showOverlay: "showOverlay", closeOnEscape: "closeOnEscape", showDefaultFooter: "showDefaultFooter", showDefaultHeader: "showDefaultHeader", title: "title", cancelButtonTitle: "cancelButtonTitle", submitButtonTitle: "submitButtonTitle" }, outputs: { cancel: "cancel", submit: "submit" }, ngContentSelectors: _c13, decls: 1, vars: 1, consts: [[3, "className", 4, "ngIf"], [3, "className"], [4, "ngIf"], [1, "aside-container", "col-12"], [1, "aside-title"], [1, "aside-button-close", 3, "click"], ["type", "button", 1, "btn", "btn-secondary", "btn-cancel", 3, "click"], ["type", "button", 1, "btn", "btn-primary", "btn-submit", 3, "click"]], template: function FwAsideComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c12);
        ɵngcc0.ɵɵtemplate(0, FwAsideComponent_aside_0_Template, 8, 6, "aside", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.visibleStatus);
    } }, directives: [ɵngcc3.NgIf], styles: ["[_nghost-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box}[_nghost-%COMP%]   aside.right[_ngcontent-%COMP%]{right:0;top:0;bottom:0}[_nghost-%COMP%]   aside.left[_ngcontent-%COMP%]{left:0;top:0;bottom:0}aside[_ngcontent-%COMP%]{will-change:opacity;display:flex;flex-direction:column;align-items:stretch;position:fixed;width:auto;background-color:#fff;z-index:1100;box-shadow:-6px 3px 11px 0 rgba(0,0,0,.23);padding:1.5rem!important;height:100%}section[_ngcontent-%COMP%]{overflow:auto;flex-grow:1}header[_ngcontent-%COMP%]{font-size:20px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;width:100%;flex-shrink:0}header[_ngcontent-%COMP%]   .aside-button-close[_ngcontent-%COMP%]{width:20px;text-align:center;opacity:.8}header[_ngcontent-%COMP%]   .aside-button-close[_ngcontent-%COMP%]:hover{cursor:pointer;opacity:1}footer[_ngcontent-%COMP%]{flex-shrink:0;border-top:1px solid #e5e5e5;display:flex;align-items:flex-start;padding:16px 0}footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-right:6px}.left[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]{justify-content:flex-end}.right[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]{justify-content:flex-start}.left[_nghost-%COMP%]   aside[_ngcontent-%COMP%]{box-shadow:6px -1px 11px 0 rgba(0,0,0,.23)}.left.footer[_nghost-%COMP%]{justify-content:flex-end}"], data: { animation: [slideAnimations] } });
FwAsideComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ViewContainerRef }
];
FwAsideComponent.propDecorators = {
    cancel: [{ type: Output }],
    submit: [{ type: Output }],
    position: [{ type: Input }],
    showOverlay: [{ type: Input }],
    closeOnEscape: [{ type: Input }],
    showDefaultFooter: [{ type: Input }],
    showDefaultHeader: [{ type: Input }],
    title: [{ type: Input }],
    cancelButtonTitle: [{ type: Input }],
    submitButtonTitle: [{ type: Input }],
    handleEscape: [{ type: HostListener, args: ['document:keydown.esc', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwAsideComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'fw-aside',
                template: "<aside [@slide]=\"position\" *ngIf=\"visibleStatus\" [className]=\"position\">\r\n\r\n    <!-- Custom Header -->\r\n    <ng-content *ngIf=\"!showDefaultHeader\" class=\"aside-title-huj\" select=\"header\">\r\n\r\n\r\n    </ng-content>\r\n    <!-- End Custom Header -->\r\n\r\n\r\n    <!-- Default Header -->\r\n    <header *ngIf=\"showDefaultHeader\">\r\n        <div class=\"aside-title\">\r\n            {{title}}\r\n        </div>\r\n\r\n        <div (click)=\"hideAside($event)\" class=\"aside-button-close\">\r\n            &times;\r\n        </div>\r\n\r\n    </header>\r\n    <!-- End Custom Header -->\r\n\r\n\r\n    <section>\r\n        <div class=\"aside-container col-12\">\r\n            <ng-content></ng-content>\r\n        </div>\r\n    </section>\r\n\r\n    <!-- Custom Footer -->\r\n    <ng-content *ngIf=\"!showDefaultFooter\" select=\"footer\"></ng-content>\r\n    <!-- End Custom Footer -->\r\n\r\n    <!-- Default Footer -->\r\n    <footer *ngIf=\"showDefaultFooter\">\r\n\r\n        <button (click)=\"hideAside($event)\" type=\"button\" class=\"btn btn-secondary btn-cancel\">\r\n         {{cancelButtonTitle}}</button>\r\n\r\n        <button (click)=\"submitAside($event)\" type=\"button\" class=\"btn btn-primary btn-submit\">{{submitButtonTitle}}</button>\r\n\r\n\r\n    </footer>\r\n    <!--End  Default Footer -->\r\n\r\n</aside>\r\n",
                animations: [slideAnimations],
                styles: [":host *{box-sizing:border-box}:host aside.right{right:0;top:0;bottom:0}:host aside.left{left:0;top:0;bottom:0}aside{will-change:opacity;display:flex;flex-direction:column;align-items:stretch;position:fixed;width:auto;background-color:#fff;z-index:1100;box-shadow:-6px 3px 11px 0 rgba(0,0,0,.23);padding:1.5rem!important;height:100%}section{overflow:auto;flex-grow:1}header{font-size:20px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;width:100%;flex-shrink:0}header .aside-button-close{width:20px;text-align:center;opacity:.8}header .aside-button-close:hover{cursor:pointer;opacity:1}footer{flex-shrink:0;border-top:1px solid #e5e5e5;display:flex;align-items:flex-start;padding:16px 0}footer button{margin-right:6px}.left footer{justify-content:flex-end}.right footer{justify-content:flex-start}:host.left aside{box-shadow:6px -1px 11px 0 rgba(0,0,0,.23)}:host.left.footer{justify-content:flex-end}"]
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }]; }, { cancel: [{
            type: Output
        }], submit: [{
            type: Output
        }], position: [{
            type: Input
        }], showOverlay: [{
            type: Input
        }], closeOnEscape: [{
            type: Input
        }], showDefaultFooter: [{
            type: Input
        }], showDefaultHeader: [{
            type: Input
        }], title: [{
            type: Input
        }], cancelButtonTitle: [{
            type: Input
        }], submitButtonTitle: [{
            type: Input
        }], handleEscape: [{
            type: HostListener,
            args: ['document:keydown.esc', ['$event']]
        }] }); })();

class FwAsideModule {
}
FwAsideModule.ɵfac = function FwAsideModule_Factory(t) { return new (t || FwAsideModule)(); };
FwAsideModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FwAsideModule });
FwAsideModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FwAsideModule, { declarations: function () { return [FwAsideComponent, FwOverlayComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FwAsideComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwAsideModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [FwAsideComponent],
                declarations: [
                    FwAsideComponent,
                    FwOverlayComponent,
                ],
                entryComponents: [FwOverlayComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of fw-aside
 */

class FwServiceWorkerServiceConfig {
    constructor() {
        this.i18n = {
            toastHeaderText: "There's a new version of the app.",
            toastBodyText: 'Do you want to refresh the page in order to get it?',
            updateLabel: 'Update!'
        };
        this.toastClass = 'bg-light';
    }
}
FwServiceWorkerServiceConfig.ɵfac = function FwServiceWorkerServiceConfig_Factory(t) { return new (t || FwServiceWorkerServiceConfig)(); };
FwServiceWorkerServiceConfig.ɵprov = ɵɵdefineInjectable({ factory: function FwServiceWorkerServiceConfig_Factory() { return new FwServiceWorkerServiceConfig(); }, token: FwServiceWorkerServiceConfig, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwServiceWorkerServiceConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ConfirmUpdateToastService {
    constructor(config) {
        this.config = config;
        this.toasts = [];
    }
    showDefault() {
        this.show(this.config.i18n.toastHeaderText, this.config.i18n.toastBodyText, this.config.i18n.updateLabel, this.config.toastClass);
    }
    show(header, body, updateLabel, cssClass) {
        this.toasts.push({ header, body, updateLabel, cssClass });
    }
    hide(toast) {
        this.toasts = this.toasts.filter(t => t !== toast);
    }
}
ConfirmUpdateToastService.ɵfac = function ConfirmUpdateToastService_Factory(t) { return new (t || ConfirmUpdateToastService)(ɵngcc0.ɵɵinject(FwServiceWorkerServiceConfig)); };
ConfirmUpdateToastService.ɵprov = ɵɵdefineInjectable({ factory: function ConfirmUpdateToastService_Factory() { return new ConfirmUpdateToastService(ɵɵinject(FwServiceWorkerServiceConfig)); }, token: ConfirmUpdateToastService, providedIn: "root" });
ConfirmUpdateToastService.ctorParameters = () => [
    { type: FwServiceWorkerServiceConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfirmUpdateToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: FwServiceWorkerServiceConfig }]; }, null); })();

/**
 * Cargamos la nueva versión de la aplicación al detectar un nuevo despliegue. Angular puede tardar unos
 * segundos en darse cuenta. Dependiendo de la aplicación puede interesa mostrar un aviso en vez de
 * recargar directamente.
 */
class ServiceWorkerService {
    constructor(swUpdate, confirmUpdateToastService) {
        this.swUpdate = swUpdate;
        this.confirmUpdateToastService = confirmUpdateToastService;
    }
    checkForUpdates(production) {
        if (production) {
            this.swUpdate.available.subscribe(evt => {
                this.confirmUpdateToastService.showDefault();
            });
        }
    }
    launchUpdate() {
        this.swUpdate.activateUpdate().then(() => {
            window.location.reload();
        });
    }
}
ServiceWorkerService.ɵfac = function ServiceWorkerService_Factory(t) { return new (t || ServiceWorkerService)(ɵngcc0.ɵɵinject(ɵngcc9.SwUpdate), ɵngcc0.ɵɵinject(ConfirmUpdateToastService)); };
ServiceWorkerService.ɵprov = ɵɵdefineInjectable({ factory: function ServiceWorkerService_Factory() { return new ServiceWorkerService(ɵɵinject(SwUpdate), ɵɵinject(ConfirmUpdateToastService)); }, token: ServiceWorkerService, providedIn: "root" });
ServiceWorkerService.ctorParameters = () => [
    { type: SwUpdate },
    { type: ConfirmUpdateToastService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServiceWorkerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc9.SwUpdate }, { type: ConfirmUpdateToastService }]; }, null); })();

class ConfirmUpdateToastComponent {
    constructor(confirmUpdateToastService, serviceWorkerService) {
        this.confirmUpdateToastService = confirmUpdateToastService;
        this.serviceWorkerService = serviceWorkerService;
    }
    ngOnInit() {
    }
    launchUpdate(toast) {
        this.serviceWorkerService.launchUpdate();
        this.confirmUpdateToastService.hide(toast);
    }
}
ConfirmUpdateToastComponent.ɵfac = function ConfirmUpdateToastComponent_Factory(t) { return new (t || ConfirmUpdateToastComponent)(ɵngcc0.ɵɵdirectiveInject(ConfirmUpdateToastService), ɵngcc0.ɵɵdirectiveInject(ServiceWorkerService)); };
ConfirmUpdateToastComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfirmUpdateToastComponent, selectors: [["fw-confirm-update-toast"]], decls: 1, vars: 1, consts: [[3, "autohide", "header", "ngClass", "hide", 4, "ngFor", "ngForOf"], [3, "autohide", "header", "ngClass", "hide"], ["href", "javascript:void(0);", 3, "click"]], template: function ConfirmUpdateToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ConfirmUpdateToastComponent_ngb_toast_0_Template, 5, 5, "ngb-toast", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.confirmUpdateToastService.toasts);
    } }, directives: [ɵngcc3.NgForOf, ɵngcc2.NgbToast, ɵngcc3.NgClass], styles: ["[_nghost-%COMP%]{position:fixed;bottom:0;left:0;margin:.5em;z-index:1200}[_nghost-%COMP%]   ngb-toast[_ngcontent-%COMP%]{max-width:600px}"] });
ConfirmUpdateToastComponent.ctorParameters = () => [
    { type: ConfirmUpdateToastService },
    { type: ServiceWorkerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfirmUpdateToastComponent, [{
        type: Component,
        args: [{
                selector: 'fw-confirm-update-toast',
                template: "<ngb-toast [autohide]=\"false\" (hide)=\"confirmUpdateToastService.hide(toast)\" [header]=\"toast.header\"\r\n           *ngFor=\"let toast of confirmUpdateToastService.toasts\" [ngClass]=\"toast.cssClass\">\r\n    <div>{{toast.body}} <a href=\"javascript:void(0);\" (click)=\"launchUpdate(toast)\">{{toast.updateLabel}}</a></div>\r\n</ngb-toast>\r\n",
                styles: [":host{position:fixed;bottom:0;left:0;margin:.5em;z-index:1200}:host ngb-toast{max-width:600px}"]
            }]
    }], function () { return [{ type: ConfirmUpdateToastService }, { type: ServiceWorkerService }]; }, null); })();

class FwServiceWorkerServiceModule {
}
FwServiceWorkerServiceModule.ɵfac = function FwServiceWorkerServiceModule_Factory(t) { return new (t || FwServiceWorkerServiceModule)(); };
FwServiceWorkerServiceModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FwServiceWorkerServiceModule });
FwServiceWorkerServiceModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            NgbToastModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FwServiceWorkerServiceModule, { declarations: function () { return [ConfirmUpdateToastComponent]; }, imports: function () { return [CommonModule,
        NgbToastModule]; }, exports: function () { return [ConfirmUpdateToastComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FwServiceWorkerServiceModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ConfirmUpdateToastComponent
                ],
                imports: [
                    CommonModule,
                    NgbToastModule
                ],
                exports: [
                    ConfirmUpdateToastComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of service-worker-service
 */

/*
 * Public API Surface of core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractInputComponent, AbstractNgModelComponent, AlertErrorService, AppRouterOutletDirective, AutofocusDirective, BaseUrlGeneratorService, BigDecimalFilter, BooleanComponent, BooleanFilter, BreadcrumbsComponent, ConfirmUpdateToastComponent, ConfirmationDialogService, ContextFormService, CustomEndpointContextService, CustomInputComponent, CustomReuseStrategy, DateComponent, DatetimeComponent, DebounceDirective, Direction, DoubleFilter, EmptyListComponent, ErrorComponent, Filter, FloatFilter, FormCancelComponent, FormComponent, FormEditComponent, FormFooterButtonsComponent, FormHeaderButtonsComponent, FormSaveComponent, FormSaveContinueComponent, FormWrapperComponent, FwAnchorComponent, FwAsideComponent, FwAsideModule, FwAuthModule, FwBaseList, FwBreadcrumbsConfig, FwBreadcrumbsModule, FwBreadcrumbsResolver, FwBreadcrumbsService, FwCommonConfig, FwCommonModule, FwConfirmationDialogComponent, FwCreateUpdateContinueForm, FwCreateUpdateForm, FwDoesntHaveAnyAuthorityDirective, FwFilterByDirective, FwFilterDirective, FwFormsConfig, FwFormsModule, FwHasAnyAuthorityDirective, FwOrdenByDirective, FwOrderDirective, FwPaginacionComponent, FwPaginacionSiguienteComponent, FwPaginationConfig, FwPaginationModule, FwPrincipalService, FwSaveForm, FwServiceWorkerServiceConfig, FwServiceWorkerServiceModule, FwValidatorModule, IdentificationService, InputService, InstantFilter, IntegerFilter, LabelComponent, LanguageService, LocalDateFilter, LongFilter, MultipleSelection, MultipleSelectionComponent, NgbDateStringAdapter, NumberComponent, Order, Page, Pageable, RangeFilter, RichEditorComponent, RichEditorConfig, SelectAllComponent, SelectComponent, SelectElementComponent, SelectEnumComponent, SelectionService, SelectorIdiomaComponent, ServiceWorkerService, ShortFilter, Sort, StateStorageService, Store, StringFilter, TableComponent, TextComponent, TextareaComponent, ToastService, ValidateCifNifNieDirective, ValidateEqualDirective, ValidateIbanDirective, ValidateMaxlengthHtmlDirective, ValidateMinValueDirective, ValidationComponent, ValueComponent, composeValidators, flattenConPrefijosExceptoElPrimero, hmrBootstrap, isPromise, provideValidators, provideValueAccessor, stringFormat, validate, wrapIntoObservable, ɵ0, Store$1 as ɵa, DateFormatService as ɵb, FwPaginacionUtil as ɵc, slideAnimations as ɵd, FwOverlayComponent as ɵe, ConfirmUpdateToastService as ɵf };

//# sourceMappingURL=fw-core.js.map